Object.assign(window.labelToSkuPartMap = window.labelToSkuPartMap || {}, {
  "CITY OF AIRDRIE": "ARDR-C",
  "MUNICIPALITY": "M",
  "NEIGHBOURHOOD": "N",
  "CITY OF AIRDRIE": "ARDR-C",
  "CITY OF BROOKS": "BRKS-C",
  "CITY OF CALGARY": "CLGR-C",
  "CITY OF CAMROSE": "CMRS-C",
  "CITY OF COLD LAKE": "CLDL-C",
  "CITY OF EDMONTON": "EDMN-C",
  "CITY OF FORT SASKATCHEWAN": "FRTS-C",
  "CITY OF GRANDE PRAIRIE": "GRND-C",
  "CITY OF LACOMBE": "LCMB-C",
  "CITY OF LEDUC": "LDC-C",
  "CITY OF LETHBRIDGE": "LTHB-C",
  "CITY OF LLOYDMINSTER": "LLYD-C",
  "CITY OF MEDICINE HAT": "MDCN-C",
  "CITY OF RED DEER": "RDDR-C",
  "CITY OF SPRUCE GROVE": "SPRC-C",
  "CITY OF ST ALBERT": "STLB-C",
  "CITY OF WETASKIWIN": "WTSK-C",
  "TOWN OF ATHABASCA": "ATHB-T",
  "TOWN OF BANFF": "BNFF-T",
  "TOWN OF BARRHEAD": "BRRH-T",
  "TOWN OF BASHAW": "BSHW-T",
  "TOWN OF BASSANO": "BSSN-T",
  "TOWN OF BEAUMONT": "BMNT-T",
  "TOWN OF BEAVERLODGE": "BVRL-T",
  "TOWN OF BENTLEY": "BNTL-T",
  "TOWN OF BLACK DIAMOND": "BLCK-T",
  "TOWN OF BLACKFALDS": "BLC1-T",
  "TOWN OF BON ACCORD": "BNCC-T",
  "TOWN OF BONNYVILLE": "BNNY-T",
  "TOWN OF BOW ISLAND": "BWSL-T",
  "TOWN OF BOWDEN": "BWDN-T",
  "TOWN OF BRUDERHEIM": "BRDR-T",
  "TOWN OF CALMAR": "CLMR-T",
  "TOWN OF CANMORE": "CNMR-T",
  "TOWN OF CARDSTON": "CRDS-T",
  "TOWN OF CARSTAIRS": "CRST-T",
  "TOWN OF CASTOR": "CSTR-T",
  "TOWN OF CHESTERMERE": "CHST-T",
  "TOWN OF CLARESHOLM": "CLRS-T",
  "TOWN OF COALDALE": "CLD1-T",
  "TOWN OF COALHURST": "CLHR-T",
  "TOWN OF COCHRANE": "CCHR-T",
  "TOWN OF CORONATION": "CRNT-T",
  "TOWN OF CROSSFIELD": "CRSS-T",
  "TOWN OF DAYSLAND": "DYSL-T",
  "TOWN OF DEVON": "DVN-T",
  "TOWN OF DIDSBURY": "DDSB-T",
  "TOWN OF DRAYTON VALLEY": "DRYT-T",
  "TOWN OF DRUMHELLER": "DRMH-T",
  "TOWN OF ECKVILLE": "ECKV-T",
  "TOWN OF EDSON": "EDSN-T",
  "TOWN OF ELK POINT": "ELKP-T",
  "TOWN OF FAIRVIEW": "FRVW-T",
  "TOWN OF FALHER": "FLHR-T",
  "TOWN OF FORT MACLEOD": "FRTM-T",
  "TOWN OF FOX CREEK": "FXCR-T",
  "TOWN OF GIBBONS": "GBBN-T",
  "TOWN OF GRANDE CACHE": "GRN1-T",
  "TOWN OF GRIMSHAW": "GRMS-T",
  "TOWN OF HANNA": "HNN-T",
  "TOWN OF HARDISTY": "HRDS-T",
  "TOWN OF HIGH LEVEL": "HGHL-T",
  "TOWN OF HIGH PRAIRIE": "HGHP-T",
  "TOWN OF HIGH RIVER": "HGHR-T",
  "TOWN OF HINTON": "HNTN-T",
  "TOWN OF INNISFAIL": "INNS-T",
  "TOWN OF IRRICANA": "IRRC-T",
  "TOWN OF KILLAM": "KLLM-T",
  "TOWN OF LAMONT": "LMNT-T",
  "TOWN OF LEGAL": "LGL-T",
  "TOWN OF MAGRATH": "MGRT-T",
  "TOWN OF MANNING": "MNNN-T",
  "TOWN OF MAYERTHORPE": "MYRT-T",
  "TOWN OF MCLENNAN": "MCLN-T",
  "TOWN OF MILK RIVER": "MLKR-T",
  "TOWN OF MILLET": "MLLT-T",
  "TOWN OF MORINVILLE": "MRNV-T",
  "TOWN OF MUNDARE": "MNDR-T",
  "TOWN OF NANTON": "NNTN-T",
  "TOWN OF OKOTOKS": "OKTK-T",
  "TOWN OF OLDS": "OLDS-T",
  "TOWN OF ONOWAY": "ONWY-T",
  "TOWN OF OYEN": "OYN-T",
  "TOWN OF PEACE RIVER": "PCRV-T",
  "TOWN OF PENHOLD": "PNHL-T",
  "TOWN OF PICTURE BUTTE": "PCTR-T",
  "TOWN OF PINCHER CREEK": "PNCH-T",
  "TOWN OF PONOKA": "PNK-T",
  "TOWN OF PROVOST": "PRVS-T",
  "TOWN OF RAINBOW LAKE": "RNBW-T",
  "TOWN OF RAYMOND": "RYMN-T",
  "TOWN OF REDCLIFF": "RDCL-T",
  "TOWN OF REDWATER": "RDWT-T",
  "TOWN OF RIMBEY": "RMBY-T",
  "TOWN OF ROCKY MOUNTAIN HOUSE": "RCKY-T",
  "TOWN OF SEDGEWICK": "SDGW-T",
  "TOWN OF SEXSMITH": "SXSM-T",
  "TOWN OF SLAVE LAKE": "SLVL-T",
  "TOWN OF SMOKY LAKE": "SMKY-T",
  "TOWN OF SPIRIT RIVER": "SPRT-T",
  "TOWN OF ST PAUL": "STPL-T",
  "TOWN OF STAVELY": "STVL-T",
  "TOWN OF STETTLER": "STTT-T",
  "TOWN OF STONY PLAIN": "STNY-T",
  "TOWN OF STRATHMORE": "STRT-T",
  "TOWN OF SUNDRE": "SNDR-T",
  "TOWN OF SWAN HILLS": "SWNH-T",
  "TOWN OF SYLVAN LAKE": "SYLV-T",
  "TOWN OF TABER": "TBR-T",
  "TOWN OF THREE HILLS": "THRH-T",
  "TOWN OF TOFIELD": "TFLD-T",
  "TOWN OF TROCHU": "TRCH-T",
  "TOWN OF TURNER VALLEY": "TRNR-T",
  "TOWN OF TWO HILLS": "TWHL-T",
  "TOWN OF VALLEYVIEW": "VLLY-T",
  "TOWN OF VAUXHALL": "VXHL-T",
  "TOWN OF VEGREVILLE": "VGRV-T",
  "TOWN OF VERMILION": "VRML-T",
  "TOWN OF VIKING": "VKNG-T",
  "TOWN OF VULCAN": "VLCN-T",
  "TOWN OF WAINWRIGHT": "WNWR-T",
  "TOWN OF WEMBLEY": "WMBL-T",
  "TOWN OF WESTLOCK": "WSTL-T",
  "TOWN OF WHITECOURT": "WHTC-T",
  "VILLAGE OF ARGENTIA BEACH": "ARGN-V",
  "VILLAGE OF BETULA BEACH": "BTLB-V",
  "VILLAGE OF BIRCH COVE": "BRCH-V",
  "VILLAGE OF BIRCHCLIFF": "BRC1-V",
  "VILLAGE OF BONDISS": "BNDS-V",
  "VILLAGE OF BONNYVILLE BEACH": "BNN1-V",
  "VILLAGE OF BURNSTICK LAKE": "BRNS-V",
  "VILLAGE OF CASTLE ISLAND": "CSTL-V",
  "VILLAGE OF CRYSTAL SPRINGS": "CRYS-V",
  "VILLAGE OF GHOST LAKE": "GHST-V",
  "VILLAGE OF GOLDEN DAYS": "GLDN-V",
  "VILLAGE OF GRANDVIEW": "GRN2-V",
  "VILLAGE OF GULL LAKE": "GLLL-V",
  "VILLAGE OF HALF MOON BAY": "HLFM-V",
  "VILLAGE OF HORSESHOE BAY": "HRSS-V",
  "VILLAGE OF ISLAND LAKE": "ISLN-V",
  "VILLAGE OF ISLAND LAKE SOUTH": "ISL1-V",
  "VILLAGE OF ITASKA BEACH": "ITSK-V",
  "VILLAGE OF JARVIS BAY": "JRVS-V",
  "VILLAGE OF KAPASIWIN": "KPSW-V",
  "VILLAGE OF LAKEVIEW": "LKVW-V",
  "VILLAGE OF LARKSPUR": "LRKS-V",
  "VILLAGE OF MA-ME-O BEACH": "MMBC-V",
  "VILLAGE OF MEWATHA BEACH": "MWTH-V",
  "VILLAGE OF NAKAMUN PARK": "NKMN-V",
  "VILLAGE OF NORGLENWOLD": "NRGL-V",
  "VILLAGE OF NORRIS BEACH": "NRRS-V",
  "VILLAGE OF PARKLAND BEACH": "PRKL-V",
  "VILLAGE OF PELICAN NARROWS": "PLCN-V",
  "VILLAGE OF POINT ALISON": "PNTL-V",
  "VILLAGE OF POPLAR BAY": "PPLR-V",
  "VILLAGE OF ROCHON SANDS": "RCHN-V",
  "VILLAGE OF ROSS HAVEN": "RSSH-V",
  "VILLAGE OF SANDY BEACH": "SNDY-V",
  "VILLAGE OF SEBA BEACH": "SBBC-V",
  "VILLAGE OF SILVER BEACH": "SLVR-V",
  "VILLAGE OF SILVER SANDS": "SLV1-V",
  "VILLAGE OF SOUTH BAPTISTE": "STHB-V",
  "VILLAGE OF SOUTH VIEW": "STHV-V",
  "VILLAGE OF SUNBREAKER COVE": "SNBR-V",
  "VILLAGE OF SUNDANCE BEACH": "SNDN-V",
  "VILLAGE OF SUNRISE BEACH": "SNRS-V",
  "VILLAGE OF SUNSET BEACH": "SNST-V",
  "VILLAGE OF SUNSET POINT": "SNS1-V",
  "VILLAGE OF VAL QUENTIN": "VLQN-V",
  "VILLAGE OF WAIPAROUS": "WPRS-V",
  "VILLAGE OF WEST BAPTISTE": "WSTB-V",
  "VILLAGE OF WEST COVE": "WSTC-V",
  "VILLAGE OF WHISPERING HILLS": "WHSP-V",
  "VILLAGE OF WHITE SANDS": "WHTS-V",
  "VILLAGE OF YELLOWSTONE": "YLLW-V",
  "VILLAGE OF HEISLER": "HSLR-V",
  "VILLAGE OF HILL SPRING": "HLLS-V",
  "VILLAGE OF HINES CREEK": "HNSC-V",
  "VILLAGE OF HOLDEN": "HLDN-V",
  "VILLAGE OF HUGHENDEN": "HGHN-V",
  "VILLAGE OF HUSSAR": "HSSR-V",
  "VILLAGE OF INNISFREE": "INN1-V",
  "VILLAGE OF IRMA": "IRM-V",
  "VILLAGE OF KITSCOTY": "KTSC-V",
  "VILLAGE OF LINDEN": "LNDN-V",
  "VILLAGE OF LOMOND": "LMND-V",
  "VILLAGE OF LONGVIEW": "LNGV-V",
  "VILLAGE OF LOUGHEED": "LGHD-V",
  "VILLAGE OF MANNVILLE": "MNNV-V",
  "VILLAGE OF MARWAYNE": "MRWY-V",
  "VILLAGE OF MILO": "ML-V",
  "VILLAGE OF MORRIN": "MRRN-V",
  "VILLAGE OF MUNSON": "MNSN-V",
  "VILLAGE OF MYRNAM": "MYRN-V",
  "VILLAGE OF NAMPA": "NMP-V",
  "VILLAGE OF NOBLEFORD": "NBLF-V",
  "VILLAGE OF PARADISE VALLEY": "PRDS-V",
  "VILLAGE OF ROCKYFORD": "RCK1-V",
  "VILLAGE OF ROSALIND": "RSLN-V",
  "VILLAGE OF ROSEMARY": "RSMR-V",
  "VILLAGE OF RYCROFT": "RYCR-V",
  "VILLAGE OF RYLEY": "RYLY-V",
  "VILLAGE OF SPRING LAKE": "SPRN-V",
  "VILLAGE OF STANDARD": "STND-V",
  "VILLAGE OF STIRLING": "STRL-V",
  "VILLAGE OF THORSBY": "THRS-V",
  "VILLAGE OF VETERAN": "VTRN-V",
  "VILLAGE OF VILNA": "VLN-V",
  "VILLAGE OF WARBURG": "WRBR-V",
  "VILLAGE OF WARNER": "WRNR-V",
  "VILLAGE OF WASKATENAU": "WSKT-V",
  "VILLAGE OF YOUNGSTOWN": "YNGS-V",
  "HAMLET OF ABEE": "ABEE-H",
  "HAMLET OF ACADIA VALLEY": "ACDV-H",
  "HAMLET OF AETNA": "ATN-H",
  "HAMLET OF ALCOMDALE": "ALCM-H",
  "HAMLET OF ALDER FLATS": "ALDR-H",
  "HAMLET OF ALDERSYDE": "ALD1-H",
  "HAMLET OF ALHAMBRA": "ALHM-H",
  "HAMLET OF ALTARIO": "ALTR-H",
  "HAMLET OF ANTLER LAKE": "ANTL-H",
  "HAMLET OF ANZAC": "ANZC-H",
  "HAMLET OF ARDENODE": "ARDN-H",
  "HAMLET OF ARDLEY": "ARDL-H",
  "HAMLET OF ARDMORE": "ARDM-H",
  "HAMLET OF ARDROSSAN": "ARDR-H",
  "HAMLET OF ARMENA": "ARMN-H",
  "HAMLET OF ASHMONT": "ASHM-H",
  "HAMLET OF ATMORE": "ATMR-H",
  "HAMLET OF BALZAC": "BLZC-H",
  "HAMLET OF BEAUVALLON": "BVLL-H",
  "HAMLET OF BEAVER CROSSING": "BVRC-H",
  "HAMLET OF BEAVER LAKE": "BVR1-H",
  "HAMLET OF BEAVER MINES": "BVRM-H",
  "HAMLET OF BEAVERDAM": "BVRD-H",
  "HAMLET OF BEAZER": "BZR-H",
  "HAMLET OF BELLIS": "BLLS-H",
  "HAMLET OF BENALTO": "BNLT-H",
  "HAMLET OF BENCHLANDS": "BNCH-H",
  "HAMLET OF BENTON": "BNTN-H",
  "HAMLET OF BEZANSON": "BZNS-H",
  "HAMLET OF BINDLOSS": "BNDL-H",
  "HAMLET OF BIRCHAM": "BRC2-H",
  "HAMLET OF BLACKFOOT": "BLC2-H",
  "HAMLET OF BLACKIE": "BLC3-H",
  "HAMLET OF BLUE RIDGE": "BLRD-H",
  "HAMLET OF BLUESKY": "BLSK-H",
  "HAMLET OF BLUFFTON": "BLFF-H",
  "HAMLET OF BODO": "BD-H",
  "HAMLET OF BOTHA": "BTH-H",
  "HAMLET OF BOTTREL": "BTTR-H",
  "HAMLET OF BOW CITY": "BWCT-H",
  "HAMLET OF BRAGG CREEK": "BRGG-H",
  "HAMLET OF BRANT": "BRNT-H",
  "HAMLET OF BREYNAT": "BRYN-H",
  "HAMLET OF BROSSEAU": "BRSS-H",
  "HAMLET OF BROWNFIELD": "BRWN-H",
  "HAMLET OF BROWNVALE": "BRW1-H",
  "HAMLET OF BRUCE": "BRC-H",
  "HAMLET OF BRULE": "BRLE-H",
  "HAMLET OF BUCK CREEK": "BCKC-H",
  "HAMLET OF BUCK LAKE": "BCKL-H",
  "HAMLET OF BUFFALO": "BFFL-H",
  "HAMLET OF BUFFALO LAKES": "BFF1-H",
  "HAMLET OF BUFORD": "BFRD-H",
  "HAMLET OF BURDETT": "BRDT-H",
  "HAMLET OF BUSBY": "BSBY-H",
  "HAMLET OF BYEMOOR": "BYMR-H",
  "HAMLET OF CADOGAN": "CDGN-H",
  "HAMLET OF CADOMIN": "CDMN-H",
  "HAMLET OF CADOTTE LAKE": "CDTT-H",
  "HAMLET OF CALAHOO": "CLH-H",
  "HAMLET OF CALLING LAKE": "CLLN-H",
  "HAMLET OF CAMPSIE": "CMPS-H",
  "HAMLET OF CANYON CREEK": "CNYN-H",
  "HAMLET OF CARBONDALE": "CRBN-H",
  "HAMLET OF CARDIFF": "CRDF-H",
  "HAMLET OF CAROLSIDE": "CRLS-H",
  "HAMLET OF CARSELAND": "CRSL-H",
  "HAMLET OF CARVEL": "CRVL-H",
  "HAMLET OF CARWAY": "CRWY-H",
  "HAMLET OF CASLAN": "CSLN-H",
  "HAMLET OF CASSILS": "CSSL-H",
  "HAMLET OF CAVENDISH": "CVND-H",
  "HAMLET OF CAYLEY": "CYLY-H",
  "HAMLET OF CEREAL": "CRL-H",
  "HAMLET OF CESSFORD": "CSSF-H",
  "HAMLET OF CHANCELLOR": "CHNC-H",
  "HAMLET OF CHEADLE": "CHDL-H",
  "HAMLET OF CHERHILL": "CHRH-H",
  "HAMLET OF CHERRY GROVE": "CHRR-H",
  "HAMLET OF CHIN": "CHN-H",
  "HAMLET OF CHINOOK": "CHNK-H",
  "HAMLET OF CHISHOLM": "CHSH-H",
  "HAMLET OF CLAIRMONT": "CLRM-H",
  "HAMLET OF CLANDONALD": "CLND-H",
  "HAMLET OF CLEARDALE": "CLRD-H",
  "HAMLET OF CLUNY": "CLNY-H",
  "HAMLET OF COCHRANE LAKE": "CCH1-H",
  "HAMLET OF COLINTON": "CLNT-H",
  "HAMLET OF COLLINGWOOD COVE": "CLWC-H",
  "HAMLET OF COMPEER": "CMPR-H",
  "HAMLET OF CONDOR": "CNDR-H",
  "HAMLET OF CONKLIN": "CNKL-H",
  "HAMLET OF CONRICH": "CNRC-H",
  "HAMLET OF CRAIGMYLE": "CRGM-H",
  "HAMLET OF CYNTHIA": "CYNT-H",
  "HAMLET OF DALEMEAD": "DLMD-H",
  "HAMLET OF DALROY": "DLRY-H",
  "HAMLET OF DALUM": "DALM-H",
  "HAMLET OF DAPP": "DAPP-H",
  "HAMLET OF DARWELL": "DRWL-H",
  "HAMLET OF DE WINTON": "DWNT-H",
  "HAMLET OF DEAD MAN'S FLATS": "DDMN-H",
  "HAMLET OF DEADWOOD": "DDWD-H",
  "HAMLET OF DEBOLT": "DBLT-H",
  "HAMLET OF DEL BONITA": "DLBN-H",
  "HAMLET OF DELACOUR": "DLCR-H",
  "HAMLET OF DEMMITT": "DMMT-H",
  "HAMLET OF DERWENT": "DRWN-H",
  "HAMLET OF DESERT BLUME": "DSRT-H",
  "HAMLET OF DEWBERRY": "DWBR-H",
  "HAMLET OF DIAMOND CITY": "DMND-H",
  "HAMLET OF DICKSON": "DCKS-H",
  "HAMLET OF DIMSDALE": "DMSD-H",
  "HAMLET OF DIXONVILLE": "DXNV-H",
  "HAMLET OF DONATVILLE": "DNTV-H",
  "HAMLET OF DOROTHY": "DRTH-H",
  "HAMLET OF DUFFIELD": "DFFL-H",
  "HAMLET OF DUHAMEL": "DHML-H",
  "HAMLET OF DUNMORE": "DNMR-H",
  "HAMLET OF DUVERNAY": "DVRN-H",
  "HAMLET OF EAGLESHAM": "EGLS-H",
  "HAMLET OF EDWAND": "EDWN-H",
  "HAMLET OF EGREMONT": "EGRM-H",
  "HAMLET OF ELLSCOTT": "ELLS-H",
  "HAMLET OF ELMWORTH": "ELMW-H",
  "HAMLET OF ENCHANT": "ENCH-H",
  "HAMLET OF ENDIANG": "ENDN-H",
  "HAMLET OF ENILDA": "ENLD-H",
  "HAMLET OF ENSIGN": "ENSG-H",
  "HAMLET OF ENTWISTLE": "ENTW-H",
  "HAMLET OF ERSKINE": "ERSK-H",
  "HAMLET OF ESTHER": "ESTH-H",
  "HAMLET OF ETZIKOM": "ETZK-H",
  "HAMLET OF EVANSBURG": "EVNS-H",
  "HAMLET OF EXCEL": "EXCL-H",
  "HAMLET OF EXSHAW": "EXSH-H",
  "HAMLET OF FABYAN": "FBYN-H",
  "HAMLET OF FAIRVIEW": "FRVW-H",
  "HAMLET OF FALLIS": "FLLS-H",
  "HAMLET OF FALUN": "FALN-H",
  "HAMLET OF FAUST": "FAST-H",
  "HAMLET OF FAWCETT": "FWCT-H",
  "HAMLET OF FEDERAL": "FDRL-H",
  "HAMLET OF FERINTOSH": "FRNT-H",
  "HAMLET OF FLATBUSH": "FLTB-H",
  "HAMLET OF FLEET": "FLET-H",
  "HAMLET OF FORT ASSINIBOINE": "FRT1-H",
  "HAMLET OF FORT CHIPEWYAN": "FRTC-H",
  "HAMLET OF FORT KENT": "FRTK-H",
  "HAMLET OF FORT MCKAY": "FRT2-H",
  "HAMLET OF FORT MCMURRAY": "FRT3-H",
  "HAMLET OF FORT VERMILION": "FRTV-H",
  "HAMLET OF GADSBY": "GDSB-H",
  "HAMLET OF GAINFORD": "GNFR-H",
  "HAMLET OF GALAHAD": "GLHD-H",
  "HAMLET OF GASOLINE ALLEY": "GSLN-H",
  "HAMLET OF GEM": "GEM-H",
  "HAMLET OF GLEICHEN": "GLCH-H",
  "HAMLET OF GLENEVIS": "GLNV-H",
  "HAMLET OF GOODFARE": "GDFR-H",
  "HAMLET OF GOOSE LAKE": "GSLK-H",
  "HAMLET OF GRANDE CACHE": "GRN3-H",
  "HAMLET OF GRANUM": "GRNM-H",
  "HAMLET OF GRASSLAND": "GRSS-H",
  "HAMLET OF GRASSY LAKE": "GRS1-H",
  "HAMLET OF GREEN COURT": "GRNC-H",
  "HAMLET OF GREENSHIELDS": "GRNS-H",
  "HAMLET OF GREGOIRE LAKE ESTATES": "GRGR-H",
  "HAMLET OF GROUARD": "GRRD-H",
  "HAMLET OF GROVEDALE": "GRVD-H",
  "HAMLET OF GUNN": "GNN-H",
  "HAMLET OF GUY": "GUY-H",
  "HAMLET OF GWYNNE": "GWYN-H",
  "HAMLET OF HAIRY HILL": "HRYH-H",
  "HAMLET OF HALF MOON LAKE": "HLF1-H",
  "HAMLET OF HALCOURT": "HLCR-H",
  "HAMLET OF HARMONY": "HRMN-H",
  "HAMLET OF HARTELL": "HRTL-H",
  "HAMLET OF HARVIE HEIGHTS": "HRVH-H",
  "HAMLET OF HASTINGS LAKE": "HSTN-H",
  "HAMLET OF HAYNES": "HYNS-H",
  "HAMLET OF HAYS": "HAYS-H",
  "HAMLET OF HAYTER": "HYTR-H",
  "HAMLET OF HEINSBURG": "HNSB-H",
  "HAMLET OF HEMARUKA": "HMRK-H",
  "HAMLET OF HERITAGE POINTE": "HRTG-H",
  "HAMLET OF HERRONTON": "HRRN-H",
  "HAMLET OF HESKETH": "HSKT-H",
  "HAMLET OF HILDA": "HLDA-H",
  "HAMLET OF HILLIARD": "HLLR-H",
  "HAMLET OF HOADLEY": "HDLY-H",
  "HAMLET OF HUALLEN": "HLLN-H",
  "HAMLET OF HUXLEY": "HXLY-H",
  "HAMLET OF HYLO": "HYLO-H",
  "HAMLET OF HYTHE": "HYTH-H",
  "HAMLET OF IDDESLEIGH": "IDDS-H",
  "HAMLET OF INDUS": "INDS-H",
  "HAMLET OF IRON RIVER": "IRNR-H",
  "HAMLET OF IRON SPRINGS": "IRNS-H",
  "HAMLET OF IRVINE": "IRVN-H",
  "HAMLET OF ISLAY": "ISLY-H",
  "HAMLET OF JANET": "JNET-H",
  "HAMLET OF JANVIER SOUTH": "JNVR-H",
  "HAMLET OF JARVIE": "JRVE-H",
  "HAMLET OF JEAN COTE": "JNCT-H",
  "HAMLET OF JENNER": "JNNR-H",
  "HAMLET OF JOFFRE": "JFFR-H",
  "HAMLET OF JOHNSON'S ADDITION": "JHNS-H",
  "HAMLET OF JOSEPHBURG": "JSPH-H",
  "HAMLET OF JOUSSARD": "JSSR-H",
  "HAMLET OF KATHYRN": "KTHY-H",
  "HAMLET OF KAVANAGH": "KVNG-H",
  "HAMLET OF KEEPHILLS": "KPHL-H",
  "HAMLET OF KELSEY": "KLSY-H",
  "HAMLET OF KEOMA": "KEOM-H",
  "HAMLET OF KIMBALL": "KMBL-H",
  "HAMLET OF KINGMAN": "KNGM-H",
  "HAMLET OF KINSELLA": "KNSL-H",
  "HAMLET OF KINUSO": "KNUS-H",
  "HAMLET OF KIPP": "KIPP-H",
  "HAMLET OF KIRKCALDY": "KRKC-H",
  "HAMLET OF KIRRIEMUIR": "KRRM-H",
  "HAMLET OF LA COREY": "LCRY-H",
  "HAMLET OF LA CRETE": "LCRT-H",
  "HAMLET OF LA GLACE": "LGLC-H",
  "HAMLET OF LAC DES ARCS": "LCDS-H",
  "HAMLET OF LAC LA BICHE": "LCLB-H",
  "HAMLET OF LAFOND": "LFND-H",
  "HAMLET OF LAKE LOUISE": "LKLS-H",
  "HAMLET OF LAKE NEWELL RESORT": "LKNW-H",
  "HAMLET OF LAMOUREUX": "LMRX-H",
  "HAMLET OF LANDRY HEIGHTS": "LNDR-H",
  "HAMLET OF LANFINE": "LNFN-H",
  "HAMLET OF LANGDON": "LNGD-H",
  "HAMLET OF LAVOY": "LAVY-H",
  "HAMLET OF LEAVITT": "LVTT-H",
  "HAMLET OF LEEDALE": "LDL-H",
  "HAMLET OF LESLIEVILLE": "LSLV-H",
  "HAMLET OF LINDBERGH": "LNDB-H",
  "HAMLET OF LINN VALLEY": "LNNV-H",
  "HAMLET OF LITTLE BUFFALO": "LTTL-H",
  "HAMLET OF LITTLE SMOKY": "LTT1-H",
  "HAMLET OF LODGEPOLE": "LDGP-H",
  "HAMLET OF LONG LAKE": "LNGL-H",
  "HAMLET OF LOOMA": "LOOM-H",
  "HAMLET OF LOTTIE LAKE": "LTLK-H",
  "HAMLET OF LOUSANA": "LSNA-H",
  "HAMLET OF LOWLAND HEIGHTS": "LWLN-H",
  "HAMLET OF LOYALIST": "LYLS-H",
  "HAMLET OF LUNDBRECK": "LNBR-H",
  "HAMLET OF LYALTA": "LYLT-H",
  "HAMLET OF LYMBURN": "LYMB-H",
  "HAMLET OF MADDEN": "MDDN-H",
  "HAMLET OF MALLAIG": "MLLG-H",
  "HAMLET OF MANOLA": "MNL-H",
  "HAMLET OF MANYBERRIES": "MNYB-H",
  "HAMLET OF MARIE REINE": "MRR1-H",
  "HAMLET OF MARKERVILLE": "MRKR-H",
  "HAMLET OF MARLBORO": "MRLB-H",
  "HAMLET OF MARTEN BEACH": "MRTN-H",
  "HAMLET OF MASKWACIS": "MSKW-H",
  "HAMLET OF MCLAUGHLIN": "MCLG-H",
  "HAMLET OF MEANOOK": "MENK-H",
  "HAMLET OF MEARNS": "MRNS-H",
  "HAMLET OF MEETING CREEK": "MTNG-H",
  "HAMLET OF METISKOW": "MTSK-H",
  "HAMLET OF MICHICHI": "MCHC-H",
  "HAMLET OF MILLARVILLE": "MLLR-H",
  "HAMLET OF MINBURN": "MNBR-H",
  "HAMLET OF MIRROR": "MRRR-H",
  "HAMLET OF MITSUE LAKE INDUSTRIAL": "MTSL-H",
  "HAMLET OF MONARCH": "MNRC-H",
  "HAMLET OF MONITOR": "MNTR-H",
  "HAMLET OF MOON RIVER ESTATES": "MNRV-H",
  "HAMLET OF MORECAMBE": "MRCM-H",
  "HAMLET OF MORNINGSIDE": "MRNN-H",
  "HAMLET OF MOSSLEIGH": "MSSL-H",
  "HAMLET OF MOUNTAIN VIEW": "MNTN-H",
  "HAMLET OF MULHURST BAY": "MLHR-H",
  "HAMLET OF MUSIDORA": "MSDR-H",
  "HAMLET OF NAMAKA": "NMK-H",
  "HAMLET OF NAMAO": "NMAO-H",
  "HAMLET OF NAPHTHA": "NPHT-H",
  "HAMLET OF NEERLANDIA": "NRLN-H",
  "HAMLET OF NESTOW": "NSTW-H",
  "HAMLET OF NEVIS": "NEVS-H",
  "HAMLET OF NEW BRIGDEN": "NWBR-H",
  "HAMLET OF NEW DAYTON": "NWDY-H",
  "HAMLET OF NEW NORWAY": "NWNR-H",
  "HAMLET OF NEW SAREPTA": "NWSR-H",
  "HAMLET OF NEWBROOK": "NWB1-H",
  "HAMLET OF NIGHTINGALE": "NGHT-H",
  "HAMLET OF NISKU": "NSKU-H",
  "HAMLET OF NITON JUNCTION": "NTNJ-H",
  "HAMLET OF NORDEGG": "NRDG-H",
  "HAMLET OF NORTH COOKING LAKE": "NRTH-H",
  "HAMLET OF NORTH STAR": "NRT1-H",
  "HAMLET OF NOTIKEWIN": "NTKW-H",
  "HAMLET OF OHATON": "OHTN-H",
  "HAMLET OF OPAL": "OPAL-H",
  "HAMLET OF ORION": "ORN-H",
  "HAMLET OF ORTON": "ORTN-H",
  "HAMLET OF PARKLAND": "PRK1-H",
  "HAMLET OF PATRICIA": "PTRC-H",
  "HAMLET OF PEERS": "PRS-H",
  "HAMLET OF PELICAN POINT": "PLCN-H",
  "HAMLET OF PEORIA": "PEOR-H",
  "HAMLET OF PERRYVALE": "PRRY-H",
  "HAMLET OF PIBROCH": "PBRC-H",
  "HAMLET OF PICKARDVILLE": "PCKR-H",
  "HAMLET OF PINCHER STATION": "PNC1-H",
  "HAMLET OF PINE SANDS": "PNSN-H",
  "HAMLET OF PLAMONDON": "PLMN-H",
  "HAMLET OF POPLAR RIDGE": "PPLR-H",
  "HAMLET OF PRIDDIS": "PRDD-H",
  "HAMLET OF PRIDDIS GREENS": "PRDG-H",
  "HAMLET OF PURPLE SPRINGS": "PRPL-H",
  "HAMLET OF QUEENSTOWN": "QNST-H",
  "HAMLET OF RADWAY": "RDWY-H",
  "HAMLET OF RAINIER": "RNR-H",
  "HAMLET OF RANFURLY": "RNFR-H",
  "HAMLET OF RED EARTH CREEK": "RDRT-H",
  "HAMLET OF RED WILLOW": "RDWL-H",
  "HAMLET OF REDLAND": "RDLN-H",
  "HAMLET OF RENO": "RENO-H",
  "HAMLET OF RICH VALLEY": "RCHV-H",
  "HAMLET OF RICHDALE": "RCHD-H",
  "HAMLET OF RIDGEVALLEY": "RDGV-H",
  "HAMLET OF RIVERCOURSE": "RVRC-H",
  "HAMLET OF RIVERVIEW": "RVRV-H",
  "HAMLET OF RIVIÈRE QUI BARRE": "RVRQ-H",
  "HAMLET OF ROBB": "RBB-H",
  "HAMLET OF ROCHESTER": "RCHS-H",
  "HAMLET OF ROCHFORT BRIDGE": "RCHF-H",
  "HAMLET OF ROCKY RAPIDS": "RKYR-H",
  "HAMLET OF ROLLING HILLS": "RLLN-H",
  "HAMLET OF ROLLY VIEW": "RLLY-H",
  "HAMLET OF ROSEBUD": "RSBD-H",
  "HAMLET OF ROSELYNN": "RSLY-H",
  "HAMLET OF ROUND HILL": "RNDH-H",
  "HAMLET OF ROWLEY": "RWLY-H",
  "HAMLET OF RUMSEY": "RMSY-H",
  "HAMLET OF SANDY LAKE": "SND1-H",
  "HAMLET OF SANGUDO": "SNGD-H",
  "HAMLET OF SAPRAE CREEK": "SPRC-H",
  "HAMLET OF SCANDIA": "SCND-H",
  "HAMLET OF SCAPA": "SCP-H",
  "HAMLET OF SCHULER": "SCHL-H",
  "HAMLET OF SCOTFIELD": "SCTF-H",
  "HAMLET OF SEDALIA": "SDLA-H",
  "HAMLET OF SEVEN PERSONS": "SVNP-H",
  "HAMLET OF SHAUGHNESSY": "SHGH-H",
  "HAMLET OF SHEERNESS": "SHRN-H",
  "HAMLET OF SHERWOOD PARK": "SHRW-H",
  "HAMLET OF SHOULDICE": "SHLD-H",
  "HAMLET OF SIBBALD": "SBBL-H",
  "HAMLET OF SKIFF": "SKFF-H",
  "HAMLET OF SMITH": "SMTH-H",
  "HAMLET OF SOUTH COOKING LAKE": "STHC-H",
  "HAMLET OF SPEDDEN": "SPDD-H",
  "HAMLET OF SPRING COULEE": "SPR2-H",
  "HAMLET OF SPRINGBROOK": "SPR3-H",
  "HAMLET OF SPRUCE VIEW": "SPR4-H",
  "HAMLET OF ST EDOUARD": "STDR-H",
  "HAMLET OF ST FRANCIS": "STFR-H",
  "HAMLET OF ST ISIDORE": "STSD-H",
  "HAMLET OF ST LINA": "STLN-H",
  "HAMLET OF ST MICHAEL": "STMC-H",
  "HAMLET OF ST VINCENT": "STVN-H",
  "HAMLET OF STANMORE": "STNM-H",
  "HAMLET OF STAR": "STR-H",
  "HAMLET OF STREAMSTOWN": "STRM-H",
  "HAMLET OF STROME": "STR1-H",
  "HAMLET OF SUFFIELD": "SFFL-H",
  "HAMLET OF SUNNYBROOK": "SNNY-H",
  "HAMLET OF SUNNYNOOK": "SNN1-H",
  "HAMLET OF SUNNYSLOPE": "SNN2-H",
  "HAMLET OF SWALWELL": "SWLW-H",
  "HAMLET OF TANGENT": "TNGN-H",
  "HAMLET OF TAWATINAW": "TWTN-H",
  "HAMLET OF TEEPEE CREEK": "TPCR-H",
  "HAMLET OF TEES": "TEES-H",
  "HAMLET OF TELFORDVILLE": "TLFR-H",
  "HAMLET OF THERIEN": "THRN-H",
  "HAMLET OF THORHILD": "TRHD-H",
  "HAMLET OF THRONE": "TRNE-H",
  "HAMLET OF THUNDER LAKE": "THND-H",
  "HAMLET OF TILLEY": "TLLY-H",
  "HAMLET OF TILLICUM BEACH": "TLLC-H",
  "HAMLET OF TOMAHAWK": "TMHW-H",
  "HAMLET OF TORRINGTON": "TRRN-H",
  "HAMLET OF TRAVERS": "TRVR-H",
  "HAMLET OF TULLIBY LAKE": "TLLB-H",
  "HAMLET OF TURIN": "TRN-H",
  "HAMLET OF TWIN BUTTE": "TWNB-H",
  "HAMLET OF VALHALLA CENTRE": "VLHL-H",
  "HAMLET OF VEINERVILLE": "VNRV-H",
  "HAMLET OF VENICE": "VNC-H",
  "VILLAGE AT PIGEON LAKE": "VPGL-V",
  "HAMLET OF VILLENEUVE": "VLLN-H",
  "HAMLET OF VIMY": "VMY-H",
  "HAMLET OF VIOLET GROVE": "VLTG-H",
  "HAMLET OF WABAMUN": "WBMN-H",
  "HAMLET OF WABASCA": "WBSC-H",
  "HAMLET OF WAGNER": "WGNR-H",
  "HAMLET OF WALSH": "WLSH-H",
  "HAMLET OF WANDERING RIVER": "WNDR-H",
  "HAMLET OF WANHAM": "WNHM-H",
  "HAMLET OF WARDLOW": "WRDL-H",
  "HAMLET OF WARSPITE": "WRSP-H",
  "HAMLET OF WATERTON PARK": "WTRT-H",
  "HAMLET OF WATINO": "WTN-H",
  "HAMLET OF WATTS": "WTTS-H",
  "HAMLET OF WEDGEWOOD": "WDGW-H",
  "HAMLET OF WELLING": "WLLN-H",
  "HAMLET OF WELLING STATION": "WLLS-H",
  "HAMLET OF WESTEROSE": "WSTR-H",
  "HAMLET OF WHITELAW": "WHTL-H",
  "HAMLET OF WHITFORD": "WHTF-H",
  "HAMLET OF WHITLA": "WHT1-H",
  "HAMLET OF WIDEWATER": "WDWT-H",
  "HAMLET OF WILDWOOD": "WLDW-H",
  "HAMLET OF WILLINGDON": "WLLD-H",
  "HAMLET OF WIMBORNE": "WMBR-H",
  "HAMLET OF WINFIELD": "WNFL-H",
  "HAMLET OF WINNIFRED": "WNNF-H",
  "HAMLET OF WITHROW": "WTHR-H",
  "HAMLET OF WOKING": "WKNG-H",
  "HAMLET OF WOODHOUSE": "WDHS-H",
  "HAMLET OF WOOLFORD": "WLFR-H",
  "HAMLET OF WORSLEY": "WRSL-H",
  "HAMLET OF WOSTOK": "WSTK-H",
  "HAMLET OF WRENTHAM": "WRNT-H",
  "HAMLET OF ZAMA CITY": "ZMCT-H",
  "CHINATOWN, CALGARY": "CAL",
  "CITYSCAPE, CALGARY": "CAL",
  "COUNTRY HILLS VILLAGE, CALGARY": "CAL",
  "DOWNTOWN COMMERCIAL CORE, CALGARY": "CAL",
  "DOWNTOWN EAST VILLAGE, CALGARY": "CAL",
  "DOWNTOWN WEST END, CALGARY": "CAL",
  "MCKENZIE TOWNE, CALGARY": "CAL",
  "QUEENS PARK VILLAGE, CALGARY": "CAL",
  "BRITANNIA YOUNGSTOWN, EDMONTON": "EDM",
  "CLAREVIEW TOWN CENTRE, EDMONTON": "EDM",
  "DOWNTOWN, EDMONTON": "EDM",
  "HERITAGE VALLEY TOWN CENTRE AREA, EDMONTON": "EDM",
  "MILL WOODS TOWN CENTRE, EDMONTON": "EDM",
  "TERWILLEGAR TOWNE, EDMONTON": "EDM",
  "WESTVIEW VILLAGE, EDMONTON": "EDM",
  "VARSITY VILLAGE, LETHBRIDGE": "LET",
  "DEER PARK VILLAGE, RED DEER": "RED",
  "DOWNTOWN, RED DEER": "RED",
  "DOWNTOWN, AIRDRIE": "AIR",
  "MIDTOWN, AIRDRIE": "AIR",
  "OLD TOWN, AIRDRIE": "AIR",
  "THE VILLAGE, AIRDRIE": "AIR",
  "WILLIAMSTOWN, AIRDRIE": "AIR",
  "CITY OF ABBOTSFORD": "ABBT-C",
  "CITY OF ARMSTRONG": "ARMS-C",
  "CITY OF BURNABY": "BRNB-C",
  "CITY OF CAMPBELL RIVER": "CMPB-C",
  "CITY OF CASTLEGAR": "CSTL-C",
  "CITY OF CHILLIWACK": "CHLL-C",
  "CITY OF COLWOOD": "CLWD-C",
  "CITY OF COQUITLAM": "CQTL-C",
  "CITY OF COURTENAY": "CRTN-C",
  "CITY OF CRANBROOK": "CRNB-C",
  "CITY OF DAWSON CREEK": "DWSN-C",
  "CITY OF DUNCAN": "DNCN-C",
  "CITY OF ENDERBY": "ENDR-C",
  "CITY OF FERNIE": "FRN-C",
  "CITY OF FORT ST JOHN": "FRTS-C",
  "CITY OF GRAND FORKS": "GRND-C",
  "CITY OF GREENWOOD": "GRNW-C",
  "CITY OF KAMLOOPS": "KMLP-C",
  "CITY OF KELOWNA": "KLWN-C",
  "CITY OF KIMBERLEY": "KMBR-C",
  "CITY OF LANGFORD": "LNGF-C",
  "CITY OF LANGLEY": "LNGL-C",
  "CITY OF MAPLE RIDGE": "MPLR-C",
  "CITY OF MERRITT": "MRRT-C",
  "CITY OF NANAIMO": "NNM-C",
  "CITY OF NELSON": "NLSN-C",
  "CITY OF NEW WESTMINSTER": "NWWS-C",
  "CITY OF NORTH VANCOUVER": "NRTH-C",
  "CITY OF PARKSVILLE": "PRKS-C",
  "CITY OF PENTICTON": "PNTC-C",
  "CITY OF PITT MEADOWS": "PTTM-C",
  "CITY OF PORT ALBERNI": "PRTL-C",
  "CITY OF PORT COQUITLAM": "PRTC-C",
  "CITY OF PORT MOODY": "PRTM-C",
  "CITY OF POWELL RIVER": "PWLL-C",
  "CITY OF PRINCE GEORGE": "PRNC-C",
  "CITY OF PRINCE RUPERT": "PRN1-C",
  "CITY OF QUESNEL": "QSNL-C",
  "CITY OF REVELSTOKE": "RVLS-C",
  "CITY OF RICHMOND": "RCHM-C",
  "CITY OF ROSSLAND": "RSSL-C",
  "CITY OF SALMON ARM": "SLMN-C",
  "CITY OF SURREY": "SRRY-C",
  "CITY OF TERRACE": "TRRC-C",
  "CITY OF TRAIL": "TRL-C",
  "CITY OF VANCOUVER": "VNCV-C",
  "CITY OF VERNON": "VRNN-C",
  "CITY OF VICTORIA": "VCTR-C",
  "CITY OF WEST KELOWNA": "WSTK-C",
  "CITY OF WHITE ROCK": "WHTR-C",
  "CITY OF WILLIAMS LAKE": "WLLM-C",
  "TOWN OF COMOX": "CMX-T",
  "TOWN OF CRESTON": "CRST-T",
  "TOWN OF GIBSONS": "GBSN-T",
  "TOWN OF GOLDEN": "GLDN-T",
  "TOWN OF LADYSMITH": "LDYS-T",
  "TOWN OF LAKE COWICHAN": "LKCW-T",
  "TOWN OF OLIVER": "OLVR-T",
  "TOWN OF OSOYOOS": "OSYS-T",
  "TOWN OF PORT MCNEILL": "PRT1-T",
  "TOWN OF PRINCETON": "PRN2-T",
  "TOWN OF QUALICUM BEACH": "QLCM-T",
  "TOWN OF SIDNEY": "SDNY-T",
  "TOWN OF SMITHERS": "SMTH-T",
  "TOWN OF VIEW ROYAL": "VWRY-T",
  "TOWNSHIP OF ESQUIMALT": "ESQM-TS",
  "TOWNSHIP OF LANGLEY": "LNG1-TS",
  "TOWNSHIP OF SPALLUMCHEEN": "SPLL-TS",
  "VILLAGE OF ALERT BAY": "ALRT-V",
  "VILLAGE OF ANMORE": "ANMR-V",
  "VILLAGE OF ASHCROFT": "ASHC-V",
  "VILLAGE OF BELCARRA": "BLCR-V",
  "VILLAGE OF BURNS LAKE": "BRNS-V",
  "VILLAGE OF CACHE CREEK": "CCHC-V",
  "VILLAGE OF CANAL FLATS": "CNLF-V",
  "VILLAGE OF CHASE": "CHS-V",
  "VILLAGE OF CLINTON": "CLNT-V",
  "VILLAGE OF CUMBERLAND": "CMBR-V",
  "VILLAGE OF FRASER LAKE": "FRSR-V",
  "VILLAGE OF FRUITVALE": "FRTV-V",
  "VILLAGE OF GOLD RIVER": "GLDR-V",
  "VILLAGE OF GRANISLE": "GRNS-V",
  "VILLAGE OF HARRISON HOT SPRINGS": "HRRS-V",
  "VILLAGE OF HAZELTON": "HZLT-V",
  "VILLAGE OF KASLO": "KSL-V",
  "VILLAGE OF KEREMEOS": "KRMS-V",
  "VILLAGE OF LIONS BAY": "LNSB-V",
  "VILLAGE OF LUMBY": "LMBY-V",
  "VILLAGE OF LYTTON": "LYTT-V",
  "VILLAGE OF MASSET": "MSST-V",
  "VILLAGE OF MCBRIDE": "MCBR-V",
  "VILLAGE OF MIDWAY": "MDWY-V",
  "VILLAGE OF MONTROSE": "MNTR-V",
  "VILLAGE OF NAKUSP": "NKSP-V",
  "VILLAGE OF NEW DENVER": "NWDN-V",
  "VILLAGE OF PEMBERTON": "PMBR-V",
  "VILLAGE OF PORT ALICE": "PRT2-V",
  "VILLAGE OF PORT CLEMENTS": "PRT3-V",
  "VILLAGE OF POUCE COUPE": "PCCP-V",
  "VILLAGE OF QUEEN CHARLOTTE": "QNCH-V",
  "VILLAGE OF RADIUM HOT SPRINGS": "RDMH-V",
  "VILLAGE OF SALMO": "SLM-V",
  "VILLAGE OF SAYWARD": "SYWR-V",
  "VILLAGE OF SILVERTON": "SLVR-V",
  "VILLAGE OF SLOCAN": "SLCN-V",
  "VILLAGE OF TAHSIS": "THSS-V",
  "VILLAGE OF TELKWA": "TLKW-V",
  "VILLAGE OF VALEMOUNT": "VLMN-V",
  "VILLAGE OF WARFIELD": "WRFL-V",
  "VILLAGE OF ZEBALLOS": "ZBLL-V",
  "ALBERNI-CLAYOQUOT REGIONAL DISTRICT": "ALBR-RG",
  "BULKLEY-NECHAKO REGIONAL DISTRICT": "BKNC-RG",
  "CAPITAL REGIONAL DISTRICT": "CPTL-RG",
  "CARIBOO REGIONAL DISTRICT": "CRBO-RG",
  "CENTRAL COAST REGIONAL DISTRICT": "CCST-RG",
  "CENTRAL KOOTENAY REGIONAL DISTRICT": "CKTN-RG",
  "CENTRAL OKANAGAN REGIONAL DISTRICT": "COKN-RG",
  "COLUMBIA SHUSWAP REGIONAL DISTRICT": "CSWP-RG",
  "COMOX VALLEY REGIONAL DISTRICT": "COMO-RG",
  "COWICHAN VALLEY REGIONAL DISTRICT": "CWCV-RG",
  "EAST KOOTENAY REGIONAL DISTRICT": "EKTN-RG",
  "FRASER VALLEY REGIONAL DISTRICT": "FRVL-RG",
  "FRASER-FORT GEORGE REGIONAL DISTRICT": "FFG-RG",
  "GREATER VANCOUVER REGIONAL DISTRICT": "GRVC-RG",
  "KITIMAT-STIKINE REGIONAL DISTRICT": "KMSK-RG",
  "KOOTENAY BOUNDARY REGIONAL DISTRICT": "KTBD-RG",
  "MOUNT WADDINGTON REGIONAL DISTRICT": "MWDG-RG",
  "NANAIMO REGIONAL DISTRICT": "NNMO-RG",
  "NORTH COAST REGIONAL DISTRICT": "NRCS-RG",
  "NORTH OKANAGAN REGIONAL DISTRICT": "NOKN-RG",
  "OKANAGAN-SIMILKAMEEN REGIONAL DISTRICT": "OKSM-RG",
  "PEACE RIVER REGIONAL DISTRICT": "PRVR-RG",
  "QATHET REGIONAL DISTRICT": "QTHT-RG",
  "SQUAMISH-LILLOOET REGIONAL DISTRICT": "SQLL-RG",
  "STRATHCONA REGIONAL DISTRICT": "STCN-RG",
  "SUNSHINE COAST REGIONAL DISTRICT": "SSNC-RG",
  "THOMPSON-NICOLA REGIONAL DISTRICT": "TPSN-RG",
  "RESORT MUNICIPALITY OF WHISTLER": "WHST-RM",
  "DOWNTOWN, VANCOUVER": "VAN",
  "DOWNTOWN, VICTORIA": "VIC",
  "LAKE CITY, BURNABY HEIGHTS": "BUR",
  "GARDEN VILLAGE, BURNABY HEIGHTS": "BUR",
  "GARDEN CITY, RICHMOND": "RIC",
  "STEVESTON VILLAGE, RICHMOND": "RIC",
  "TOWN CENTRE, COQUITLAM": "COQ",
  "DOWNTOWN, ABBOTSFORD": "ABB",
  "TOWNLINE, ABBOTSFORD": "ABB",
  "CITY OF BRANDON": "BRND-C",
  "CITY OF DAUPHIN": "DPHN-C",
  "CITY OF FLIN FLON": "FLNF-C",
  "CITY OF MORDEN": "MRDN-C",
  "CITY OF PORTAGE LA PRAIRIE": "PRTG-C",
  "CITY OF SELKIRK": "SLKR-C",
  "CITY OF STEINBACH": "STNB-C",
  "CITY OF THOMPSON": "THMP-C",
  "CITY OF WINKLER": "WNKL-C",
  "CITY OF WINNIPEG": "WNNP-C",
  "TOWN OF ALTONA": "ALTN-T",
  "TOWN OF ARBORG": "ARBR-T",
  "TOWN OF BEAUSEJOUR": "BSJR-T",
  "TOWN OF BIRTLE": "BRTL-T",
  "TOWN OF BOISSEVAIN": "BSSV-T",
  "TOWN OF CARBERRY": "CRBR-T",
  "TOWN OF CARMAN": "CRMN-T",
  "TOWN OF CHURCHILL": "CHRC-T",
  "TOWN OF DELORAINE": "DLRN-T",
  "TOWN OF EMERSON": "EMRS-T",
  "TOWN OF ERICKSON": "ERCK-T",
  "TOWN OF GILBERT PLAINS": "GLBR-T",
  "TOWN OF GILLAM": "GLLM-T",
  "TOWN OF GLADSTONE": "GLDS-T",
  "TOWN OF GRAND RAPIDS": "GRND-T",
  "TOWN OF GRANDVIEW": "GRN1-T",
  "TOWN OF GRETNA": "GRTN-T",
  "TOWN OF HARTNEY": "HRTN-T",
  "TOWN OF LAC DU BONNET": "LCDB-T",
  "TOWN OF LEAF RAPIDS": "LFRP-T",
  "TOWN OF LYNN LAKE": "LYNN-T",
  "TOWN OF MACGREGOR": "MCGR-T",
  "TOWN OF MANITOU": "MNT-T",
  "TOWN OF MELITA": "MLT-T",
  "TOWN OF MINITONAS": "MNTN-T",
  "TOWN OF MINNEDOSA": "MNND-T",
  "TOWN OF MORRIS": "MRRS-T",
  "TOWN OF NEEPAWA": "NPW-T",
  "TOWN OF NIVERVILLE": "NVRV-T",
  "TOWN OF OAK LAKE": "OKLK-T",
  "TOWN OF PILOT MOUND": "PLTM-T",
  "TOWN OF PLUM COULEE": "PLMC-T",
  "TOWN OF POWERVIEW-PINE FALLS": "PWRV-T",
  "TOWN OF RAPID CITY": "RPDC-T",
  "TOWN OF RIVERS": "RVRS-T",
  "TOWN OF ROBLIN": "RBLN-T",
  "TOWN OF ROSSBURN": "RSSB-T",
  "TOWN OF RUSSELL": "RSSL-T",
  "TOWN OF SNOW LAKE": "SNWL-T",
  "TOWN OF SOURIS": "SRS-T",
  "TOWN OF STE ANNE": "STNN-T",
  "TOWN OF STE ROSE DU LAC": "STRS-T",
  "TOWN OF STONEWALL": "STNW-T",
  "TOWN OF SWAN RIVER": "SWNR-T",
  "TOWN OF TEULON": "TLN-T",
  "TOWN OF THE PAS": "THPS-T",
  "TOWN OF TREHERNE": "TRHR-T",
  "TOWN OF VIRDEN": "VRDN-T",
  "TOWN OF WINNIPEG BEACH": "WNN1-T",
  "VILLAGE OF BENITO": "BNT-V",
  "VILLAGE OF BINSCARTH": "BNSC-V",
  "VILLAGE OF BOWSMAN": "BWSM-V",
  "VILLAGE OF CARTWRIGHT": "CRTW-V",
  "VILLAGE OF CRYSTAL CITY": "CRYS-V",
  "VILLAGE OF DUNNOTAR": "DNNT-V",
  "VILLAGE OF ELKHORN": "ELKH-V",
  "VILLAGE OF ETHELBERT": "ETHL-V",
  "VILLAGE OF GLENBORO": "GLNB-V",
  "VILLAGE OF MCCREARY": "MCCR-V",
  "VILLAGE OF NOTRE DAME DE LOURDES": "NTRD-V",
  "VILLAGE OF RIVERTON": "RVRT-V",
  "VILLAGE OF SOMERSET": "SMRS-V",
  "VILLAGE OF ST CLAUDE": "STCL-V",
  "VILLAGE OF ST LAZARE": "STLZ-V",
  "VILLAGE OF ST PIERRE-JOLYS": "STPR-V",
  "VILLAGE OF WASKADA": "WSKD-V",
  "VILLAGE OF WAWANESA": "WWNS-V",
  "VILLAGE OF WINNIPEGOSIS": "WNN2-V",
  "MUNICIPALITY OF BIFROST-RIVERTON": "BFRS-M",
  "MUNICIPALITY OF BOISSEVAIN-MORTON": "BSS1-M",
  "MUNICIPALITY OF BRENDA-WASKADA": "BRN1-M",
  "MUNICIPALITY OF CARTWRIGHT-ROBLIN": "CRT1-M",
  "MUNICIPALITY OF CLANWILLIAM-ERICKSON": "CLNW-M",
  "MUNICIPALITY OF DELORAINE-WINCHESTER": "DLR1-M",
  "MUNICIPALITY OF ELLICE-ARCHIE": "ELLC-M",
  "MUNICIPALITY OF EMERSON-FRANKLIN": "EMR1-M",
  "MUNICIPALITY OF GLENBORO-SOUTH CYPRESS": "GLN1-M",
  "MUNICIPALITY OF GLENELLA-LANSDOWNE": "GLNL-M",
  "MUNICIPALITY OF GRANDVIEW": "GRN2-M",
  "MUNICIPALITY OF GRASSLAND": "GRSS-M",
  "MUNICIPALITY OF HARRISON PARK": "HRRS-M",
  "MUNICIPALITY OF KILLARNY-TURTLE MOUNTAIN": "KLLR-M",
  "MUNICIPALITY OF MCCREARY": "MCC1-M",
  "MUNICIPALITY OF MINITONAS-BOWSMAN": "MNT1-M",
  "MUNICIPALITY OF MOSSEY RIVER": "MSSY-M",
  "MUNICIPALITY OF NORFOLK TREHERNE": "NRFL-M",
  "MUNICIPALITY OF NORTH CYPRESS-LANGFORD": "NRTH-M",
  "MUNICIPALITY OF NORTH NORFOLK": "NRT1-M",
  "MUNICIPALITY OF OAKLAND-WAWANESA": "OKLN-M",
  "MUNICIPALITY OF OAKVIEW": "OKVW-M",
  "MUNICIPALITY OF PEMBINA": "PMBN-M",
  "MUNICIPALITY OF PRAIRIE LAKES": "PRRL-M",
  "MUNICIPALITY OF PRAIRIE VIEW": "PRRV-M",
  "MUNICIPALITY OF RHINELAND": "RHNL-M",
  "MUNICIPALITY OF RIDING MOUNTAIN WEST": "RDNG-M",
  "MUNICIPALITY OF RIVERDALE": "RVRD-M",
  "MUNICIPALITY OF ROBLIN": "RBL1-M",
  "MUNICIPALITY OF ROSSBURN MUNICIPALITY": "RSS1-M",
  "MUNICIPALITY OF RUSSELL-BINSCARTH": "RSS2-M",
  "MUNICIPALITY OF SHOAL LAKE": "SHLL-M",
  "MUNICIPALITY OF SOURIS-GLENWOOD": "SRSG-M",
  "MUNICIPALITY OF SWAN VALLEY WEST": "SWNV-M",
  "MUNICIPALITY OF TWO BORDERS": "TWBR-M",
  "MUNICIPALITY OF WALLACE-WOODWORTH": "WLLC-M",
  "MUNICIPALITY OF WEST INTERLAKE": "WSTN-M",
  "MUNICIPALITY OF WESTLAKE-GLADSTONE": "WSTL-M",
  "MUNICIPALITY OF YELLOWHEAD": "YLLW-M",
  "MUNICIPALITY OF HAMIOTA": "HMT-M",
  "RURAL MUNICIPALITY OF ALBERT": "ALBR-RM",
  "RURAL MUNICIPALITY OF ALEXANDER": "ALXN-RM",
  "RURAL MUNICIPALITY OF ALONSA": "ALNS-RM",
  "RURAL MUNICIPALITY OF ARCHIE": "ARCH-RM",
  "RURAL MUNICIPALITY OF ARGYLE": "ARGY-RM",
  "RURAL MUNICIPALITY OF ARMSTRONG": "ARMS-RM",
  "RURAL MUNICIPALITY OF ARTHUR": "ARTH-RM",
  "RURAL MUNICIPALITY OF BIFROST": "BFR1-RM",
  "RURAL MUNICIPALITY OF BIRTLE": "BRT1-RM",
  "RURAL MUNICIPALITY OF BLANSHARD": "BLNS-RM",
  "RURAL MUNICIPALITY OF BRENDA": "BRN2-RM",
  "RURAL MUNICIPALITY OF BROKENHEAD": "BRKN-RM",
  "RURAL MUNICIPALITY OF CAMERON": "CMRN-RM",
  "RURAL MUNICIPALITY OF CARTIER": "CRTR-RM",
  "RURAL MUNICIPALITY OF CLANWILLIAM": "CLN1-RM",
  "RURAL MUNICIPALITY OF COLDWELL": "CLDW-RM",
  "RURAL MUNICIPALITY OF CORNWALLIS": "CRNW-RM",
  "RURAL MUNICIPALITY OF DALY": "DLY-RM",
  "RURAL MUNICIPALITY OF DAUPHIN": "DPH1-RM",
  "RURAL MUNICIPALITY OF DE SALABERRY": "DSLB-RM",
  "RURAL MUNICIPALITY OF DUFFERIN": "DFFR-RM",
  "RURAL MUNICIPALITY OF EAST ST PAUL": "ESTS-RM",
  "RURAL MUNICIPALITY OF EDWARD": "EDWR-RM",
  "RURAL MUNICIPALITY OF ELLICE": "ELL1-RM",
  "RURAL MUNICIPALITY OF ELTON": "ELTN-RM",
  "RURAL MUNICIPALITY OF ERIKSDALE": "ERKS-RM",
  "RURAL MUNICIPALITY OF ETHELBERT": "ETH1-RM",
  "RURAL MUNICIPALITY OF FISHER": "FSHR-RM",
  "RURAL MUNICIPALITY OF FRANKLIN": "FRNK-RM",
  "RURAL MUNICIPALITY OF GILBERT PLAINS": "GLB1-RM",
  "RURAL MUNICIPALITY OF GIMLI": "GML-RM",
  "RURAL MUNICIPALITY OF GLENELLA": "GLN2-RM",
  "RURAL MUNICIPALITY OF GLENWOOD": "GLNW-RM",
  "RURAL MUNICIPALITY OF GRAHAMDALE": "GRHM-RM",
  "RURAL MUNICIPALITY OF GREY": "GRY-RM",
  "RURAL MUNICIPALITY OF HANOVER": "HNVR-RM",
  "RURAL MUNICIPALITY OF HARRISON": "HRR1-RM",
  "RURAL MUNICIPALITY OF HEADINGLEY": "HDNG-RM",
  "RURAL MUNICIPALITY OF HILLSBURG": "HLLS-RM",
  "RURAL MUNICIPALITY OF KELSEY": "KLSY-RM",
  "RURAL MUNICIPALITY OF LA BROQUERIE": "LBRQ-RM",
  "RURAL MUNICIPALITY OF LAC DU BONNET": "LCD1-RM",
  "RURAL MUNICIPALITY OF LAKESHORE": "LKSH-RM",
  "RURAL MUNICIPALITY OF LAKEVIEW": "LKVW-RM",
  "RURAL MUNICIPALITY OF LANGFORD": "LNGF-RM",
  "RURAL MUNICIPALITY OF LANSDOWNE": "LNSD-RM",
  "RURAL MUNICIPALITY OF LAWRENCE": "LWRN-RM",
  "RURAL MUNICIPALITY OF LORNE": "LRN-RM",
  "RURAL MUNICIPALITY OF LOUISE": "LOUS-RM",
  "RURAL MUNICIPALITY OF MACDONALD": "MCDN-RM",
  "RURAL MUNICIPALITY OF MCCREARY": "MCC2-RM",
  "RURAL MUNICIPALITY OF MINIOTA": "MNT2-RM",
  "RURAL MUNICIPALITY OF MINITONAS": "MNT3-RM",
  "RURAL MUNICIPALITY OF MINTO": "MNT4-RM",
  "RURAL MUNICIPALITY OF MINTO-ODANAH": "MNTD-RM",
  "RURAL MUNICIPALITY OF MONTCALM": "MNTC-RM",
  "RURAL MUNICIPALITY OF MORRIS": "MRR1-RM",
  "RURAL MUNICIPALITY OF MORTON": "MRTN-RM",
  "RURAL MUNICIPALITY OF MOSSEY RIVER": "MSS1-RM",
  "RURAL MUNICIPALITY OF MOUNTAIN": "MNT5-RM",
  "RURAL MUNICIPALITY OF NORTH CYPRESS": "NRT2-RM",
  "RURAL MUNICIPALITY OF NORTH NORFOLK": "NRT3-RM",
  "RURAL MUNICIPALITY OF OAKLAND": "OKL1-RM",
  "RURAL MUNICIPALITY OF OAKVIEW": "OKV1-RM",
  "RURAL MUNICIPALITY OF OCHRE RIVER": "OCHR-RM",
  "RURAL MUNICIPALITY OF ODANAH": "ODNH-RM",
  "RURAL MUNICIPALITY OF PARK": "PRK-RM",
  "RURAL MUNICIPALITY OF PEMBINA": "PMB1-RM",
  "RURAL MUNICIPALITY OF PINEY": "PNY-RM",
  "RURAL MUNICIPALITY OF PIPESTONE": "PPST-RM",
  "RURAL MUNICIPALITY OF PORTAGE LA PRAIRIE": "PRT1-RM",
  "RURAL MUNICIPALITY OF PRAIRIE LAKES": "PRR1-RM",
  "RURAL MUNICIPALITY OF REYNOLDS": "RYNL-RM",
  "RURAL MUNICIPALITY OF RHINELAND": "RHN1-RM",
  "RURAL MUNICIPALITY OF RIDING MOUNTAIN WEST": "RDN1-RM",
  "RURAL MUNICIPALITY OF RITCHOT": "RTCH-RM",
  "RURAL MUNICIPALITY OF RIVERSIDE": "RVR1-RM",
  "RURAL MUNICIPALITY OF ROBLIN": "RBL2-RM",
  "RURAL MUNICIPALITY OF ROCKWOOD": "RCKW-RM",
  "RURAL MUNICIPALITY OF ROLAND": "RLND-RM",
  "RURAL MUNICIPALITY OF ROSEDALE": "RSDL-RM",
  "RURAL MUNICIPALITY OF ROSSBURN": "RSS3-RM",
  "RURAL MUNICIPALITY OF ROSSER": "RSSR-RM",
  "RURAL MUNICIPALITY OF RUSSELL": "RSS4-RM",
  "RURAL MUNICIPALITY OF SASKATCHEWAN": "SSKT-RM",
  "RURAL MUNICIPALITY OF SHELL RIVER": "SHL1-RM",
  "RURAL MUNICIPALITY OF SHELLMOUTH-BOULTON": "SHL2-RM",
  "RURAL MUNICIPALITY OF SIFTON": "SFTN-RM",
  "RURAL MUNICIPALITY OF SIGLUNES": "SGLN-RM",
  "RURAL MUNICIPALITY OF SILVER CREEK": "SLVR-RM",
  "RURAL MUNICIPALITY OF SOUTH CYPRESS": "STHC-RM",
  "RURAL MUNICIPALITY OF SOUTH NORFOLK": "STHN-RM",
  "RURAL MUNICIPALITY OF SPRINGFIELD": "SPRN-RM",
  "RURAL MUNICIPALITY OF ST ANDREWS": "STND-RM",
  "RURAL MUNICIPALITY OF ST CLEMENTS": "STC1-RM",
  "RURAL MUNICIPALITY OF ST FRANCOIS XAVIER": "STFR-RM",
  "RURAL MUNICIPALITY OF ST LAURENT": "STLR-RM",
  "RURAL MUNICIPALITY OF STANLEY": "STNL-RM",
  "RURAL MUNICIPALITY OF STE ANNE": "STN1-RM",
  "RURAL MUNICIPALITY OF STE ROSE": "STR1-RM",
  "RURAL MUNICIPALITY OF STRATHCLAIR": "STRT-RM",
  "RURAL MUNICIPALITY OF STRATHCONA": "STR2-RM",
  "RURAL MUNICIPALITY OF STUARTBURN": "STR3-RM",
  "RURAL MUNICIPALITY OF SWAN RIVER": "SWN1-RM",
  "RURAL MUNICIPALITY OF TACHE": "TCH-RM",
  "RURAL MUNICIPALITY OF THOMPSON": "THM1-RM",
  "RURAL MUNICIPALITY OF VICTORIA": "VCTR-RM",
  "RURAL MUNICIPALITY OF VICTORIA BEACH": "VCT1-RM",
  "RURAL MUNICIPALITY OF WALLACE": "WLL1-RM",
  "RURAL MUNICIPALITY OF WALLACE-WOODWORTH": "WLL2-RM",
  "RURAL MUNICIPALITY OF WEST INTERLAKE": "WST1-RM",
  "RURAL MUNICIPALITY OF WEST ST PAUL": "WSTS-RM",
  "RURAL MUNICIPALITY OF WESTBOURNE": "WSTB-RM",
  "RURAL MUNICIPALITY OF WHITEHEAD": "WHTH-RM",
  "RURAL MUNICIPALITY OF WHITEMOUTH": "WHTM-RM",
  "RURAL MUNICIPALITY OF WHITEWATER": "WHTW-RM",
  "RURAL MUNICIPALITY OF WINCHESTER": "WNCH-RM",
  "RURAL MUNICIPALITY OF WOODLANDS": "WDLN-RM",
  "RURAL MUNICIPALITY OF WOODWORTH": "WDWR-RM",
  "RURAL MUNICIPALITY OF YELLOWHEAD": "YLL1-RM",
  "CHINA TOWN, WINNIPEG": "WIN",
  "DOWNTOWN WINNIPEG, WINNIPEG": "WIN",
  "CITY OF BATHURST": "BATH-C",
  "CITY OF CAMPBELLTON": "CMPB-C",
  "CITY OF DIEPPE": "DIEP-C",
  "CITY OF EDMUNDSTON": "EDMS-C",
  "CITY OF FREDERICTON": "FRDR-C",
  "CITY OF MIRAMICHI": "MRMC-C",
  "CITY OF MONCTON": "MNCT-C",
  "CITY OF SAINT JOHN": "STJN-C",
  "VILLAGE OF GRAND MANAN": "GRND-V",
  "VILLAGE OF HARVEY": "HRV1-V",
  "VILLAGE OF HILLSBOROUGH": "HLLS-V",
  "VILLAGE OF LAC-BAKER": "LCBK-V",
  "VILLAGE OF LAKELAND RIDGES": "LKLN-V",
  "VILLAGE OF MCADAM": "MCDM-V",
  "VILLAGE OF MEMRAMCOOK": "MMRM-V",
  "VILLAGE OF MUNICIPALITY OF GRAND LAKE": "GRLK-VM",
  "VILLAGE OF NEGUAC": "NGC-V",
  "VILLAGE OF NEW MARYLAND": "NWMR-V",
  "VILLAGE OF NOUVELLE-ARCADIE": "NVLL-V",
  "VILLAGE OF SOUTHERN VICTORIA": "STHR-V",
  "MUNICIPALITY OF THE COUNTY OF PICTOU": "CTPC-M",
  "VILLAGE OF TOBIQUE VALLEY": "TBQV-V",
  "VILLAGE OF TRACY": "TRCY-V",
  "VILLAGE OF VALLEY WATERS": "VLLY-V",
  "CITY OF CORNER BROOK": "CRNR-C",
  "CITY OF MOUNT PEARL": "MNTP-C",
  "CITY OF ST. JOHN'S": "STJH-C",
  "TOWN OF ADMIRALS BEACH": "ADMR-T",
  "TOWN OF ANCHOR POINT": "ANCH-T",
  "TOWN OF APPLETON": "APPL-T",
  "TOWN OF AQUAFORTE": "AQFR-T",
  "TOWN OF ARNOLD'S COVE": "ARNL-T",
  "TOWN OF AVONDALE": "AVND-T",
  "TOWN OF BADGER": "BDGR-T",
  "TOWN OF BAIE VERTE": "BVRT-T",
  "TOWN OF BAINE HARBOUR": "BNHR-T",
  "TOWN OF BAULINE": "BLN-T",
  "TOWN OF BAY BULLS": "BYBL-T",
  "TOWN OF BAY L'ARGENT": "BYLR-T",
  "TOWN OF BAY ROBERTS": "BYRB-T",
  "TOWN OF BAY DE VERDE": "BYDV-T",
  "TOWN OF BAYTONA": "BYTN-T",
  "TOWN OF BEACHSIDE": "BCHS-T",
  "TOWN OF BELLBURNS": "BLLB-T",
  "TOWN OF BELLEORAM": "BLLR-T",
  "TOWN OF BIRCHY BAY": "BRCH-T",
  "TOWN OF BIRD COVE": "BRDC-T",
  "TOWN OF BISHOP'S COVE": "BSHP-T",
  "TOWN OF BISHOP'S FALLS": "BSH1-T",
  "TOWN OF BONAVISTA": "BNVS-T",
  "TOWN OF BOTWOOD": "BTWD-T",
  "TOWN OF BRANCH": "BRNC-T",
  "TOWN OF BRENT'S COVE": "BRNT-T",
  "TOWN OF BRIGHTON": "BRGH-T",
  "TOWN OF BRIGUS": "BRGS-T",
  "TOWN OF BRYANT'S COVE": "BRYN-T",
  "TOWN OF BUCHANS": "BCHN-T",
  "TOWN OF BURGEO": "BRG-T",
  "TOWN OF BURIN": "BRN-T",
  "TOWN OF BURLINGTON": "BRLN-T",
  "TOWN OF BURNT ISLANDS": "BRN1-T",
  "TOWN OF CAMPBELLTON": "CMPB-T",
  "TOWN OF CAPE BROYLE": "CPBR-T",
  "TOWN OF CAPE ST. GEORGE": "CPST-T",
  "TOWN OF CARBONEAR": "CRBN-T",
  "TOWN OF CARMANVILLE": "CRMN-T",
  "TOWN OF CARTWRIGHT": "CRTW-T",
  "TOWN OF CENTREVILLE-WAREHAM-TRINITY": "CNTR-T",
  "TOWN OF CHANCE COVE": "CHNC-T",
  "TOWN OF CHANGE ISLANDS": "CHNG-T",
  "TOWN OF CHANNEL-PORT AUX BASQUES": "CHNN-T",
  "TOWN OF CHAPEL ARM": "CHPL-T",
  "TOWN OF CHARLOTTETOWN": "CHRL-T",
  "TOWN OF CLARENVILLE": "CLRN-T",
  "TOWN OF CLARKE'S BEACH": "CLRK-T",
  "TOWN OF COACHMAN'S COVE": "CCHM-T",
  "TOWN OF COLINET": "CLNT-T",
  "TOWN OF COLLIERS": "CLLR-T",
  "TOWN OF COME BY CHANCE": "CMBY-T",
  "TOWN OF COMFORT COVE-NEWSTEAD": "CMFR-T",
  "TOWN OF CONCEPTION BAY SOUTH": "CNCP-T",
  "TOWN OF CONCEPTION HARBOUR": "CNC1-T",
  "TOWN OF CONCHE": "CNCH-T",
  "TOWN OF COOK'S HARBOUR": "CKSH-T",
  "TOWN OF CORMACK": "CRMC-T",
  "TOWN OF COTTLESVILLE": "CTTL-T",
  "TOWN OF COW HEAD": "CWHD-T",
  "TOWN OF COX'S COVE": "CXSC-T",
  "TOWN OF CROW HEAD": "CRWH-T",
  "TOWN OF CUPIDS": "CPDS-T",
  "TOWN OF DANIEL'S HARBOUR": "DNLS-T",
  "TOWN OF DEER LAKE": "DRLK-T",
  "TOWN OF DOVER": "DVR-T",
  "TOWN OF DUNTARA": "DNTR-T",
  "TOWN OF EASTPORT": "ESTP-T",
  "TOWN OF ELLISTON": "ELLS-T",
  "TOWN OF EMBREE": "EMBR-T",
  "TOWN OF ENGLEE": "ENGL-T",
  "TOWN OF ENGLISH HARBOUR EAST": "ENG1-T",
  "TOWN OF FERMEUSE": "FRMS-T",
  "TOWN OF FERRYLAND": "FRRY-T",
  "TOWN OF FLATROCK": "FLTR-T",
  "TOWN OF FLEUR DE LYS": "FLRD-T",
  "TOWN OF FLOWER'S COVE": "FLWR-T",
  "TOWN OF FOGO ISLAND": "FGSL-T",
  "TOWN OF FORTEAU": "FRT-T",
  "TOWN OF FORTUNE": "FRTN-T",
  "TOWN OF FOX COVE-MORTIER": "FXCV-T",
  "TOWN OF FOX HARBOUR": "FXHR-T",
  "TOWN OF FRENCHMAN'S COVE": "FRNC-T",
  "TOWN OF GALLANTS": "GLLN-T",
  "TOWN OF GAMBO": "GMB-T",
  "TOWN OF GANDER": "GNDR-T",
  "TOWN OF GARNISH": "GRNS-T",
  "TOWN OF GASKIERS-POINT LA HAYE": "GSKR-T",
  "TOWN OF GAULTOIS": "GLTS-T",
  "TOWN OF GILLAMS": "GLLM-T",
  "TOWN OF GLENBURNIE-BIRCHY HEAD-SHOAL BROOK": "GLNB-T",
  "TOWN OF GLENWOOD": "GLNW-T",
  "TOWN OF GLOVERTOWN": "GLVR-T",
  "TOWN OF GOOSE COVE EAST": "GSCV-T",
  "TOWN OF GRAND BANK": "GRND-T",
  "TOWN OF GRAND FALLS-WINDSOR": "GRN1-T",
  "TOWN OF GRAND LE PIERRE": "GRN2-T",
  "TOWN OF GREENSPOND": "GRN3-T",
  "TOWN OF HAMPDEN": "HMPD-T",
  "TOWN OF HANT'S HARBOUR": "HNTS-T",
  "TOWN OF HAPPY ADVENTURE": "HPPY-T",
  "TOWN OF HAPPY VALLEY-GOOSE BAY": "HPP1-T",
  "TOWN OF HARBOUR BRETON": "HRBR-T",
  "TOWN OF HARBOUR GRACE": "HRB1-T",
  "TOWN OF HARBOUR MAIN-CHAPEL'S COVE-LAKEVIEW": "HRB2-T",
  "TOWN OF HARE BAY": "HRBY-T",
  "TOWN OF HAWKE'S BAY": "HWKS-T",
  "TOWN OF HEART'S CONTENT": "HRTS-T",
  "TOWN OF HEART'S DELIGHT-ISLINGTON": "HRT1-T",
  "TOWN OF HEART'S DESIRE": "HRT2-T",
  "TOWN OF HERMITAGE-SANDYVILLE": "HRMT-T",
  "TOWN OF HOLYROOD": "HLYR-T",
  "TOWN OF HOWLEY": "HWLY-T",
  "TOWN OF HUGHES BROOK": "HGHS-T",
  "TOWN OF HUMBER ARM SOUTH": "HMBR-T",
  "TOWN OF INDIAN BAY": "INDN-T",
  "TOWN OF IRISHTOWN-SUMMERSIDE": "IRSH-T",
  "TOWN OF ISLE AUX MORTS": "ISLX-T",
  "TOWN OF JACKSON'S ARM": "JCKS-T",
  "TOWN OF KEELS": "KLS-T",
  "TOWN OF KING'S COVE": "KNGS-T",
  "TOWN OF KING'S POINT": "KNG1-T",
  "TOWN OF KIPPENS": "KPPN-T",
  "TOWN OF L'ANSE AU CLAIR": "LNSC-T",
  "TOWN OF L'ANSE AU LOUP": "LNSL-T",
  "TOWN OF LA SCIE": "LSC-T",
  "TOWN OF LABRADOR CITY": "LBRD-T",
  "TOWN OF LAMALINE": "LMLN-T",
  "TOWN OF LARK HARBOUR": "LRKH-T",
  "TOWN OF LAWN": "LWN-T",
  "TOWN OF LEADING TICKLES": "LDNG-T",
  "TOWN OF LEWIN'S COVE": "LWNS-T",
  "TOWN OF LEWISPORTE": "LWSP-T",
  "TOWN OF LITTLE BAY": "LTTL-T",
  "TOWN OF LITTLE BAY EAST": "LTT1-T",
  "TOWN OF LITTLE BAY ISLANDS": "LTT2-T",
  "TOWN OF LITTLE BURNT BAY": "LTT3-T",
  "TOWN OF LOGY BAY-MIDDLE COVE-OUTER COVE": "LGYB-T",
  "TOWN OF LONG HARBOUR-MOUNT ARLINGTON HEIGHTS": "LNGH-T",
  "TOWN OF LORD'S COVE": "LRDS-T",
  "TOWN OF LOURDES": "LRD1-T",
  "TOWN OF LUMSDEN": "LMSD-T",
  "TOWN OF LUSHES BIGHT-BEAUMONT-BEAUMONT NORTH": "LSHS-T",
  "TOWN OF MAIN BROOK": "MNBR-T",
  "TOWN OF MARY'S HARBOUR": "MRYS-T",
  "TOWN OF MARYSTOWN": "MRY1-T",
  "TOWN OF MASSEY DRIVE": "MSSY-T",
  "TOWN OF MCIVERS": "MCVR-T",
  "TOWN OF MEADOWS": "MDWS-T",
  "TOWN OF MIDDLE ARM": "MDDL-T",
  "TOWN OF MILES COVE": "MLSC-T",
  "TOWN OF MILLERTOWN": "MLLR-T",
  "TOWN OF MILLTOWN-HEAD OF BAY D'ESPOIR": "MHBE-T",
  "TOWN OF MING'S BIGHT": "MNGS-T",
  "TOWN OF MORRISVILLE": "MRRS-T",
  "TOWN OF MOUNT CARMEL-MITCHELLS BROOK-ST. CATHERINE'S": "MNTC-T",
  "TOWN OF MOUNT MORIAH": "MNTM-T",
  "TOWN OF MUSGRAVE HARBOUR": "MSGR-T",
  "TOWN OF MUSGRAVETOWN": "MSG1-T",
  "TOWN OF NEW PERLICAN": "NWPR-T",
  "TOWN OF NEW-WES-VALLEY": "NWWS-T",
  "TOWN OF NIPPERS HARBOUR": "NPPR-T",
  "TOWN OF NORMAN'S COVE-LONG COVE": "NRMN-T",
  "TOWN OF NORRIS ARM": "NRRS-T",
  "TOWN OF NORRIS POINT": "NRR1-T",
  "TOWN OF NORTH RIVER": "NRTH-T",
  "TOWN OF NORTH WEST RIVER": "NRT1-T",
  "TOWN OF NORTHERN ARM": "NRT2-T",
  "TOWN OF OLD PERLICAN": "OLDP-T",
  "TOWN OF PACQUET": "PCQT-T",
  "TOWN OF PARADISE": "PRDS-T",
  "TOWN OF PARKER'S COVE": "PRKR-T",
  "TOWN OF PARSON'S POND": "PRSN-T",
  "TOWN OF PASADENA": "PSDN-T",
  "TOWN OF PETERVIEW": "PTRV-T",
  "TOWN OF PETTY HARBOUR-MADDOX COVE": "PTTY-T",
  "TOWN OF PILLEY'S ISLAND": "PLLY-T",
  "TOWN OF PINWARE": "PNWR-T",
  "TOWN OF PLACENTIA": "PLCN-T",
  "TOWN OF POINT LANCE": "PNTL-T",
  "TOWN OF POINT LEAMINGTON": "PNT1-T",
  "TOWN OF POINT MAY": "PNTM-T",
  "TOWN OF POINT AU GAUL": "PNTG-T",
  "TOWN OF POINT OF BAY": "PTBY-T",
  "TOWN OF POOL'S COVE": "PLSC-T",
  "TOWN OF PORT ANSON": "PRTN-T",
  "TOWN OF PORT BLANDFORD": "PRTB-T",
  "TOWN OF PORT HOPE SIMPSON": "PRTH-T",
  "TOWN OF PORT KIRWAN": "PRTK-T",
  "TOWN OF PORT REXTON": "PRTR-T",
  "TOWN OF PORT SAUNDERS": "PRTS-T",
  "TOWN OF PORT AU CHOIX": "PRTC-T",
  "TOWN OF PORT AU PORT EAST": "PRTP-T",
  "TOWN OF PORT AU PORT WEST-AGUATHUNA-FELIX COVE": "PRT1-T",
  "TOWN OF PORTUGAL COVE SOUTH": "PRTG-T",
  "TOWN OF PORTUGAL COVE-ST. PHILIP'S": "PRT2-T",
  "TOWN OF POUCH COVE": "PCHC-T",
  "TOWN OF RALEIGH": "RLGH-T",
  "TOWN OF RAMEA": "RAME-T",
  "TOWN OF RED BAY": "RDBY-T",
  "TOWN OF RED HARBOUR": "RDHR-T",
  "TOWN OF REIDVILLE": "RDVL-T",
  "TOWN OF RENCONTRE EAST": "RNCN-T",
  "TOWN OF RENEWS-CAPPAHAYDEN": "RNWS-T",
  "TOWN OF RIVER OF PONDS": "RVPD-T",
  "TOWN OF RIVERHEAD": "RVRH-T",
  "TOWN OF ROBERT'S ARM": "RBRT-T",
  "TOWN OF ROCKY HARBOUR": "RCKY-T",
  "TOWN OF RODDICKTON-BIDE ARM": "RDDC-T",
  "TOWN OF ROSE BLANCHE-HARBOUR LE COU": "RSBL-T",
  "TOWN OF RUSHOON": "RSHN-T",
  "TOWN OF SALMON COVE": "SLMN-T",
  "TOWN OF SALVAGE": "SLVG-T",
  "TOWN OF SANDRINGHAM": "SNDR-T",
  "TOWN OF SANDY COVE": "SNDY-T",
  "TOWN OF SEAL COVE (FORTUNE BAY)": "SLCV-T",
  "TOWN OF SEAL COVE (WHITE BAY)": "SLC1-T",
  "TOWN OF SMALL POINT–ADAM'S COVE–BLACKHEAD–BROAD COVE": "SMLL-T",
  "TOWN OF SOUTH BROOK": "STHB-T",
  "TOWN OF SOUTH RIVER": "STHR-T",
  "TOWN OF SOUTHERN HARBOUR": "STH1-T",
  "TOWN OF SPANIARD'S BAY": "SPNR-T",
  "TOWN OF SPRINGDALE": "SPRN-T",
  "TOWN OF ST. ALBAN'S": "STLB-T",
  "TOWN OF ST. ANTHONY": "STNT-T",
  "TOWN OF ST. BERNARD'S-JACQUES FONTAINE": "STBR-T",
  "TOWN OF ST. BRENDAN'S": "STB1-T",
  "TOWN OF ST. BRIDE'S": "STB2-T",
  "TOWN OF ST. GEORGE'S": "STGR-T",
  "TOWN OF ST. JACQUES-COOMB'S COVE": "STJC-T",
  "TOWN OF ST. JOSEPH'S": "STJS-T",
  "TOWN OF ST. LAWRENCE": "STLW-T",
  "TOWN OF ST. LEWIS": "STL1-T",
  "TOWN OF ST. LUNAIRE-GRIQUET": "STLN-T",
  "TOWN OF ST. MARY'S": "STMR-T",
  "TOWN OF ST. PAUL'S": "STPL-T",
  "TOWN OF ST. SHOTT'S": "STSH-T",
  "TOWN OF ST. VINCENT'S-ST. STEPHEN'S-PETER'S RIVER": "STVN-T",
  "TOWN OF STEADY BROOK": "STDY-T",
  "TOWN OF STEPHENVILLE": "STPH-T",
  "TOWN OF STEPHENVILLE CROSSING": "STP1-T",
  "TOWN OF SUMMERFORD": "SMMR-T",
  "TOWN OF SUNNYSIDE (TRINITY BAY)": "SNNY-T",
  "TOWN OF TERRA NOVA": "TRRN-T",
  "TOWN OF TERRENCEVILLE": "TRR1-T",
  "TOWN OF TILT COVE": "TLTC-T",
  "TOWN OF TORBAY": "TRBY-T",
  "TOWN OF TRAYTOWN": "TRYT-T",
  "TOWN OF TREPASSEY": "TRPS-T",
  "TOWN OF TRINITY": "TRNT-T",
  "TOWN OF TRINITY BAY NORTH": "TRN1-T",
  "TOWN OF TRITON": "TRTN-T",
  "TOWN OF TROUT RIVER": "TRTR-T",
  "TOWN OF TWILLINGATE": "TWLL-T",
  "TOWN OF UPPER ISLAND COVE": "UPPR-T",
  "TOWN OF VICTORIA": "VCTR-T",
  "TOWN OF WABANA": "WBN-T",
  "TOWN OF WABUSH": "WBSH-T",
  "TOWN OF WEST ST. MODESTE": "WSTS-T",
  "TOWN OF WESTPORT": "WSTP-T",
  "TOWN OF WHITBOURNE": "WHTB-T",
  "TOWN OF WHITEWAY": "WHTW-T",
  "TOWN OF WINTERLAND": "WNTR-T",
  "TOWN OF WINTERTON": "WNT1-T",
  "TOWN OF WITLESS BAY": "WTLS-T",
  "TOWN OF WOODSTOCK": "WDST-T",
  "TOWN OF WOODY POINT": "WDYP-T",
  "TOWN OF YORK HARBOUR": "YRKH-T",
  "TOWN OF FORT SMITH": "FRTS-T",
  "TOWN OF HAY RIVER": "HYRV-T",
  "TOWN OF INUVIK": "INVK-T",
  "TOWN OF NORMAN WELLS": "NRMN-T",
  "VILLAGE OF FORT SIMPSON": "FRT1-V",
  "HAMLET OF AKLAVIK": "AKLV-H",
  "HAMLET OF ENTERPRISE": "ENTR-H",
  "HAMLET OF FORT LIARD": "FRTL-H",
  "HAMLET OF FORT MCPHERSON": "FRTM-H",
  "HAMLET OF FORT PROVIDENCE": "FRTP-H",
  "HAMLET OF FORT RESOLUTION": "FRTR-H",
  "HAMLET OF PAULATUK": "PLTK-H",
  "HAMLET OF SACHS HARBOUR": "SCHS-H",
  "HAMLET OF TUKTOYAKTUK": "TKTY-H",
  "HAMLET OF TULITA": "TLTA-H",
  "HAMLET OF ULUKHAKTOK": "ULKH-H",
  "CITY OF HALIFAX": "HLFX-C",
  "COMMUNITIES OF EAST LAWRENCETOWN": "ESTL-CM",
  "COMMUNITIES OF EAST LOON LAKE VILLAGE": "EST1-CM",
  "COMMUNITIES OF FRENCH VILLAGE": "FRNC-CM",
  "COMMUNITIES OF LAWRENCETOWN": "LWRN-CM",
  "COMMUNITIES OF LOWER LAWRENCETOWN": "LWRL-CM",
  "COMMUNITIES OF UPPER LAWRENCETOWN": "UPP4-CM",
  "COMMUNITIES OF WEST LAWRENCETOWN": "WSTL-CM",
  "COMMUNITIES OF YANKEETOWN": "YNKT-CM",
  "COMMUNITIES OF SCOTCHTOWN": "SCT1-CM",
  "COMMUNITIES OF MILL VILLAGE": "MLL1-CM",
  "TOWN OF AMHERST": "AMHR-T",
  "TOWN OF ANNAPOLIS ROYAL": "ANNP-T",
  "TOWN OF ANTIGONISH": "ANTG-T",
  "TOWN OF BERWICK": "BRWC-T",
  "TOWN OF BRIDGEWATER": "BRD1-T",
  "TOWN OF CLARK'S HARBOUR": "CLRK-T",
  "TOWN OF DIGBY": "DGBY-T",
  "TOWN OF HANTSPORT": "HNT1-T",
  "TOWN OF KENTVILLE": "KNTV-T",
  "TOWN OF LOCKEPORT": "LCKP-T",
  "TOWN OF LUNENBURG": "LNNB-T",
  "TOWN OF MAHONE BAY": "MHNB-T",
  "TOWN OF MIDDLETON": "MDD5-T",
  "TOWN OF MULGRAVE": "MLGR-T",
  "TOWN OF NEW GLASGOW": "NWGL-T",
  "TOWN OF OXFORD": "OXFR-T",
  "TOWN OF PARRSBORO": "PRRS-T",
  "TOWN OF PICTOU": "PCT-T",
  "TOWN OF PORT HAWKESBURY": "PRTH-T",
  "TOWN OF SHELBURNE": "SHLB-T",
  "TOWN OF STELLARTON": "STL1-T",
  "TOWN OF STEWIACKE": "STWC-T",
  "TOWN OF TRENTON": "TRNT-T",
  "TOWN OF TRURO": "TRR-T",
  "TOWN OF WESTVILLE": "WSTV-T",
  "TOWN OF WINDSOR": "WND1-T",
  "TOWN OF WOLFVILLE": "WLFV-T",
  "TOWN OF YARMOUTH": "YRMT-T",
  "VILLAGE OF AYLESFORD": "AYLS-V",
  "VILLAGE OF BADDECK": "BDDC-V",
  "VILLAGE OF BIBLE HILL": "BBLH-V",
  "VILLAGE OF CANNING": "CNNN-V",
  "VILLAGE OF CHESTER": "CHST-V",
  "VILLAGE OF CORNWALLIS SQUARE": "CRNW-V",
  "VILLAGE OF DOVER": "DVR-V",
  "VILLAGE OF FREEPORT": "FRPR-V",
  "VILLAGE OF GREENWOOD": "GRN6-V",
  "VILLAGE OF HEBBVILLE": "HBBV-V",
  "VILLAGE OF KINGSTON": "KNGS-V",
  "VILLAGE OF LAWRENCETOWN": "LWR3-V",
  "VILLAGE OF NEW MINAS": "NWMN-V",
  "VILLAGE OF PORT WILLIAMS": "PRTW-V",
  "VILLAGE OF PUGWASH": "PGWS-V",
  "VILLAGE OF RIVER HEBERT": "RVRH-V",
  "VILLAGE OF ST PETER’S": "STPT-V",
  "VILLAGE OF ST PETER'S": "STP1-V",
  "VILLAGE OF TATAMAGOUCHE": "TTMG-V",
  "VILLAGE OF TIVERTON": "TVRT-V",
  "VILLAGE OF WESTPORT": "WST3-V",
  "VILLAGE OF WEYMOUTH": "WYMT-V",
  "RURAL MUNICIPALITY OF ANNAPOLIS": "ANN1-RM",
  "RURAL MUNICIPALITY OF ANTIGONISH": "ANT1-RM",
  "RURAL MUNICIPALITY OF ARGYLE": "ARGY-RM",
  "RURAL MUNICIPALITY OF BARRINGTON": "BRRN-RM",
  "RURAL MUNICIPALITY OF CHESTER": "CHS1-RM",
  "RURAL MUNICIPALITY OF CLARE": "CLR-RM",
  "RURAL MUNICIPALITY OF COLCHESTER": "CLCH-RM",
  "RURAL MUNICIPALITY OF CUMBERLAND": "CMBR-RM",
  "RURAL MUNICIPALITY OF DIGBY": "DGB1-RM",
  "RURAL MUNICIPALITY OF EAST HANTS": "ESTH-RM",
  "RURAL MUNICIPALITY OF GUYSBOROUGH": "GYSB-RM",
  "RURAL MUNICIPALITY OF INVERNESS": "INVR-RM",
  "RURAL MUNICIPALITY OF KINGS": "KNG1-RM",
  "RURAL MUNICIPALITY OF LUNENBURG": "LNN1-RM",
  "RURAL MUNICIPALITY OF PICTOU": "PCT1-RM",
  "RURAL MUNICIPALITY OF RICHMOND": "RCHM-RM",
  "RURAL MUNICIPALITY OF SHELBURNE": "SHL1-RM",
  "RURAL MUNICIPALITY OF ST MARY'S": "STMR-RM",
  "RURAL MUNICIPALITY OF VICTORIA": "VCT1-RM",
  "RURAL MUNICIPALITY OF WEST HANTS": "WSTH-RM",
  "RURAL MUNICIPALITY OF YARMOUTH": "YRM1-RM",
  "DOWNTOWN BEDFORD": "HAL",
  "COLBY VILLAGE": "HAL",
  "DOWNTOWN DARTMOUTH": "HAL",
  "DUTCH VILLAGE": "HAL",
  "DOWNTOWN HALIFAX": "HAL",
  "THE VILLAGE": "HAL",
  "CITY OF BRAMPTON": "BRMP-C",
  "CITY OF BURLINGTON": "BRLN-C",
  "CITY OF CAMBRIDGE": "CMBR-C",
  "CITY OF CLARENCE-ROCKLAND": "CLRN-C",
  "CITY OF KITCHENER": "KTCH-C",
  "CITY OF MARKHAM": "MRKH-C",
  "CITY OF MISSISSAUGA": "MSSS-C",
  "CITY OF NIAGARA FALLS": "NGRF-C",
  "CITY OF OSHAWA": "OSHW-C",
  "CITY OF OWEN SOUND": "OWNS-C",
  "CITY OF PICKERING": "PCKR-C",
  "CITY OF PORT COLBORNE": "PRTC-C",
  "CITY OF SARNIA": "SRN-C",
  "CITY OF ST CATHERINES": "STCT-C",
  "CITY OF THOROLD": "THRL-C",
  "CITY OF VAUGHAN": "VGHN-C",
  "CITY OF WATERLOO": "WTRL-C",
  "CITY OF WELLAND": "WLLN-C",
  "CITY OF WOODSTOCK": "WDST-C",
  "CITY OF BARRIE": "BRR-C",
  "CITY OF BELLEVILLE": "BLLV-C",
  "CITY OF BRANTFORD": "BRNT-C",
  "CITY OF BROCKVILLE": "BRCK-C",
  "CITY OF CORNWALL": "CRNW-C",
  "CITY OF DRYDEN": "DRYD-C",
  "CITY OF ELLIOT LAKE": "ELLT-C",
  "CITY OF GREATER SUDBURY": "GRTR-C",
  "CITY OF GUELPH": "GLPH-C",
  "CITY OF HAMILTON": "HMLT-C",
  "CITY OF KAWARTHA LAKES": "KWRT-C",
  "CITY OF KENORA": "KNR-C",
  "CITY OF KINGSTON": "KNGS-C",
  "CITY OF LONDON": "LNDN-C",
  "CITY OF ORILLIA, CITY OF": "ORLL-C",
  "CITY OF OTTAWA, CITY OF": "OTTW-C",
  "CITY OF PEMBROKE, CITY OF": "PMBR-C",
  "CITY OF PETERBOROUGH, CITY OF": "PTRB-C",
  "CITY OF NORTH BAY, CITY OF": "NRTH-C",
  "CITY OF TEMISKAMING SHORES": "TMSK-C",
  "CITY OF THUNDER BAY": "THND-C",
  "CITY OF TIMMINS": "TMMN-C",
  "CITY OF TORONTO": "TORO-C",
  "CITY OF WINDSOR": "WNDS-C",
  "CITY OF QUINTE WEST": "QNTW-C",
  "CITY OF SAULT STE MARIE": "SLTS-C",
  "CITY OF ST THOMAS": "STTH-C",
  "CITY OF STRATFORD": "STRT-C",
  "TOWN OF AJAX": "AJX-T",
  "TOWN OF AMHERSTBURG": "AMHR-T",
  "TOWN OF ARNPRIOR": "ARNP-T",
  "TOWN OF AURORA": "ARR-T",
  "TOWN OF AYLMER": "AYLM-T",
  "TOWN OF BANCROFT": "BNCR-T",
  "TOWN OF BAYHAM": "BYHM-T",
  "TOWN OF BRACEBRIDGE": "BRCB-T",
  "TOWN OF BRADFORD WEST GWILLIMBURY": "BRDF-T",
  "TOWN OF CALEDON": "CLDN-T",
  "TOWN OF CARLETON PLACE": "CRLT-T",
  "TOWN OF COBOURG": "CBRG-T",
  "TOWN OF COLLINGWOOD": "CLLN-T",
  "TOWN OF DEEP RIVER": "DPRV-T",
  "TOWN OF DESERONTO": "DSRN-T",
  "TOWN OF EAST GWILLIMBURY": "ESTG-T",
  "TOWN OF ERIN": "ERN-T",
  "TOWN OF ESSEX": "ESSX-T",
  "TOWN OF FORT ERIE": "FRTR-T",
  "TOWN OF GEORGINA": "GRGN-T",
  "TOWN OF GODERICH": "GDRC-T",
  "TOWN OF GRAND VALLEY": "GRND-T",
  "TOWN OF GRAVENHURST": "GRVN-T",
  "TOWN OF GREATER NAPANEE": "GRT1-T",
  "TOWN OF GRIMSBY": "GRMS-T",
  "TOWN OF HALTON HILLS": "HLTN-T",
  "TOWN OF HANOVER": "HNVR-T",
  "TOWN OF HAWKESBURY": "HWKS-T",
  "TOWN OF HUNTSVILLE": "HNTS-T",
  "TOWN OF INGERSOLL": "INGR-T",
  "TOWN OF INNISFIL": "INNS-T",
  "TOWN OF KINGSVILLE": "KNG1-T",
  "TOWN OF LASALLE": "LSLL-T",
  "TOWN OF LAKESHORE": "LKSH-T",
  "TOWN OF LAURENTIAN HILLS": "LRNT-T",
  "TOWN OF LINCOLN": "LNCL-T",
  "TOWN OF NEW TECUMSETH": "NWTC-T",
  "TOWN OF MIDLAND": "MDLN-T",
  "TOWN OF MILTON": "MLTN-T",
  "TOWN OF MINTO": "MNT-T",
  "TOWN OF MISSISSIPPI MILLS": "MSS1-T",
  "TOWN OF MONO": "MN-T",
  "TOWN OF NEWMARKET": "NWMR-T",
  "TOWN OF OAKVILLE": "OKVL-T",
  "TOWN OF ORANGEVILLE": "ORNG-T",
  "TOWN OF PELHAM": "PLHM-T",
  "TOWN OF PERTH": "PRTH-T",
  "TOWN OF PETAWAWA": "PTWW-T",
  "TOWN OF PETROLIA": "PTRL-T",
  "TOWN OF PLYMPTON-WYOMING": "PLYM-T",
  "TOWN OF RENFREW": "RNFR-T",
  "TOWN OF SAUGEEN SHORES": "SGNS-T",
  "TOWN OF SHELBURNE": "SHLB-T",
  "TOWN OF SOUTH BRUCE PENINSULA": "STHB-T",
  "TOWN OF RICHMOND HILL": "RCHM-T",
  "TOWN OF TECUMSEH": "TCMS-T",
  "TOWN OF THE BLUE MOUNTAINS": "THBL-T",
  "TOWN OF TILLSONBURG": "TLLS-T",
  "TOWN OF WASAGA BEACH": "WSGB-T",
  "TOWN OF WHITBY": "WHTB-T",
  "TOWN OF WHITCHURCH-STOUFFVILLE": "WHTC-T",
  "TOWN OF ATIKOKAN": "ATKK-T",
  "TOWN OF BLIND RIVER": "BLND-T",
  "TOWN OF BRUCE MINES": "BRCM-T",
  "TOWN OF COBALT": "CBLT-T",
  "TOWN OF COCHRANE": "CCHR-T",
  "TOWN OF ENGLEHART": "ENGL-T",
  "TOWN OF ESPANOLA": "ESPN-T",
  "TOWN OF FORT FRANCES": "FRTF-T",
  "TOWN OF GORE BAY": "GRBY-T",
  "TOWN OF HEARST": "HRST-T",
  "TOWN OF IROQUOIS FALLS": "IRQS-T",
  "TOWN OF KAPUSKASING": "KPSK-T",
  "TOWN OF KEARNEY": "KRNY-T",
  "TOWN OF MATTAWA": "MTTW-T",
  "TOWN OF KIRKLAND LAKE": "KRKL-T",
  "TOWN OF LATCHFORD": "LTCH-T",
  "TOWN OF MARATHON": "MRTH-T",
  "TOWN OF PARRY SOUND": "PRRY-T",
  "TOWN OF MOOSONEE": "MSN-T",
  "TOWN OF NORTHEASTERN MANITOULIN AND THE ISLANDS": "NRT1-T",
  "TOWN OF PRESCOTT": "PRSC-T",
  "TOWN OF RAINY RIVER": "RNYR-T",
  "TOWN OF SMITHS FALLS": "SMTH-T",
  "TOWN OF SMOOTH ROCK FALLS": "SMT1-T",
  "TOWN OF SPANISH": "SPNS-T",
  "TOWN OF ST MARYS": "STMR-T",
  "TOWN OF THESSALON": "THSS-T",
  "TOWN OF GANANOQUE": "GNNQ-T",
  "TOWNSHIP OF ADDINGTON HIGHLANDS": "ADDN-TS",
  "TOWNSHIP OF ADELAIDE-METCALFE": "ADLD-TS",
  "TOWNSHIP OF ADJALA-TOSORONTIO": "ADJL-TS",
  "TOWNSHIP OF ADMASTON/BROMLEY": "ADMS-TS",
  "TOWNSHIP OF ALFRED AND PLANTAGENET": "ALFR-TS",
  "TOWNSHIP OF ALGONQUIN HIGHLANDS": "ALGN-TS",
  "TOWNSHIP OF ALNWICK/HALDIMAND": "ALNW-TS",
  "TOWNSHIP OF AMARANTH": "AMRN-TS",
  "TOWNSHIP OF ARNPRIOR": "ARN1-TS",
  "TOWNSHIP OF ASHFIELD-COLBORNE-WAWANOSH": "ASHF-TS",
  "TOWNSHIP OF ASPHODEL-NORWOOD": "ASPH-TS",
  "TOWNSHIP OF ATHENS": "ATHN-TS",
  "TOWNSHIP OF AUGUSTA": "AGST-TS",
  "TOWNSHIP OF BECKWITH": "BCKW-TS",
  "TOWNSHIP OF BLANDFORD-BLENHEIM": "BLN1-TS",
  "TOWNSHIP OF BONNECHERE VALLEY": "BNNC-TS",
  "TOWNSHIP OF BROCK": "BRC1-TS",
  "TOWNSHIP OF BRUDENELL, LYNDOCH AND RAGLAN": "BRDN-TS",
  "TOWNSHIP OF CARLOW/MAYO": "CRLW-TS",
  "TOWNSHIP OF CAVAN-MONAGHAN": "CVNM-TS",
  "TOWNSHIP OF CENTRAL FRONTENA": "CNTR-TS",
  "TOWNSHIP OF CENTRE WELLINGTON": "CNT1-TS",
  "TOWNSHIP OF CHAMPLAIN": "CHMP-TS",
  "TOWNSHIP OF CHATSWORTH": "CHTS-TS",
  "TOWNSHIP OF CLARENCE-ROCKLAND": "CLR1-TS",
  "TOWNSHIP OF CLARINGTON": "CLR2-TS",
  "TOWNSHIP OF CLEARVIEW": "CLRV-TS",
  "TOWNSHIP OF CRAMAHE": "CRMH-TS",
  "TOWNSHIP OF DAWN-EUPHEMIA": "DWNP-TS",
  "TOWNSHIP OF DOURO-DUMMER": "DRDM-TS",
  "TOWNSHIP OF DRUMMOND/NORTH ELMSLEY": "DRMM-TS",
  "TOWNSHIP OF DYSART": "DYSR-TS",
  "TOWNSHIP OF DUDLEY": "DDLY-TS",
  "TOWNSHIP OF HARCOURT": "HRCR-TS",
  "TOWNSHIP OF GUILFORD": "GLFR-TS",
  "TOWNSHIP OF HARBURN": "HRBR-TS",
  "TOWNSHIP OF BRUTON": "BRTN-TS",
  "TOWNSHIP OF HAVELOCK": "HVLC-TS",
  "TOWNSHIP OF EYRE": "EYR-TS",
  "TOWNSHIP OF CLYDE": "CLYD-TS",
  "TOWNSHIP OF EAST GARAFRAXA": "EST1-TS",
  "TOWNSHIP OF EAST HAWKESBURY": "ESTH-TS",
  "TOWNSHIP OF EAST ZORRA-TAVISTOCK": "ESTZ-TS",
  "TOWNSHIP OF EDWARDSBURGH/CARDINAL": "EDWR-TS",
  "TOWNSHIP OF ELIZABETHTOWN-KITLEY": "ELZB-TS",
  "TOWNSHIP OF ENNISKILLEN": "ENNS-TS",
  "TOWNSHIP OF ESSA": "ESS-TS",
  "TOWNSHIP OF FARADAY": "FRDY-TS",
  "TOWNSHIP OF FRONT OF YONGE": "FRYG-TS",
  "TOWNSHIP OF FRONTENAC ISLANDS": "FRNT-TS",
  "TOWNSHIP OF GEORGIAN BAY": "GRG1-TS",
  "TOWNSHIP OF GEORGIAN BLUFFS": "GRG2-TS",
  "TOWNSHIP OF GREATER MADAWASKA": "GRT2-TS",
  "TOWNSHIP OF GUELPH/ERAMOSA": "GLP1-TS",
  "TOWNSHIP OF HAVELOCK-BELMONT-METHUEN": "HVL1-TS",
  "TOWNSHIP OF HEAD, CLARA AND MARIA": "HDCL-TS",
  "TOWNSHIP OF HORTON": "HRTN-TS",
  "TOWNSHIP OF HOWICK": "HWCK-TS",
  "TOWNSHIP OF HURON-KINLOSS": "HRNK-TS",
  "TOWNSHIP OF KILLALOE, HAGARTY AND RICHARDS": "KLLL-TS",
  "TOWNSHIP OF KING": "KNG-TS",
  "TOWNSHIP OF LAKE OF BAYS": "LKBY-TS",
  "TOWNSHIP OF LANARK HIGHLANDS": "LNRK-TS",
  "TOWNSHIP OF LAURENTIAN VALLEY": "LRN1-TS",
  "TOWNSHIP OF LEEDS AND THE THOUSAND ISLANDS": "LDSN-TS",
  "TOWNSHIP OF LIMERICK": "LMRC-TS",
  "TOWNSHIP OF LOYALIST": "LYLS-TS",
  "TOWNSHIP OF LUCAN BIDDULPH": "LCNB-TS",
  "TOWNSHIP OF MADAWASKA VALLEY": "MDWS-TS",
  "TOWNSHIP OF MADOC": "MDC-TS",
  "TOWNSHIP OF MALAHIDE": "MLHD-TS",
  "TOWNSHIP OF MAPLETON": "MPLT-TS",
  "TOWNSHIP OF MCNAB - BRAESIDE": "MCNB-TS",
  "TOWNSHIP OF MELANCTHON": "MLNC-TS",
  "TOWNSHIP OF MINDEN HILLS": "MNDN-TS",
  "TOWNSHIP OF MONTAGUE": "MNTG-TS",
  "TOWNSHIP OF MULMUR": "MLMR-TS",
  "TOWNSHIP OF MUSKOKA LAKES": "MSKK-TS",
  "TOWNSHIP OF NORTH ALGONA WILBERFORCE": "NRT2-TS",
  "TOWNSHIP OF NORTH DUMFRIES": "NRT3-TS",
  "TOWNSHIP OF NORTH DUNDAS": "NRT4-TS",
  "TOWNSHIP OF NORTH FRONTENAC": "NRT5-TS",
  "TOWNSHIP OF NORTH GLENGARRY": "NRT6-TS",
  "TOWNSHIP OF NORTH HURON": "NRT7-TS",
  "TOWNSHIP OF NORTH KAWARTHA": "NRT8-TS",
  "TOWNSHIP OF NORTH STORMONT": "NRT9-TS",
  "TOWNSHIP OF NORWICH": "NRWC-TS",
  "TOWNSHIP OF ORO-MEDONTE": "ORMD-TS",
  "TOWNSHIP OF OTONABEE-SOUTH MONAGHAN": "OTNB-TS",
  "TOWNSHIP OF PERTH EAST": "PRT1-TS",
  "TOWNSHIP OF PERTH SOUTH": "PRT2-TS",
  "TOWNSHIP OF PUSLINCH": "PSLN-TS",
  "TOWNSHIP OF RAMARA": "RMR-TS",
  "TOWNSHIP OF RIDEAU LAKES": "RDLK-TS",
  "TOWNSHIP OF RUSSELL": "RSSL-TS",
  "TOWNSHIP OF SCUGOG": "SCGG-TS",
  "TOWNSHIP OF SELWYN": "SLWY-TS",
  "TOWNSHIP OF SEVERN": "SVRN-TS",
  "TOWNSHIP OF SOUTH FRONTENAC": "STHF-TS",
  "TOWNSHIP OF SOUTH GLENGARRY": "STHG-TS",
  "TOWNSHIP OF SOUTH STORMONT": "STHS-TS",
  "TOWNSHIP OF SOUTH-WEST OXFORD": "STHW-TS",
  "TOWNSHIP OF SOUTHGATE": "STH1-TS",
  "TOWNSHIP OF SOUTHWOLD": "STH2-TS",
  "TOWNSHIP OF SPRINGWATER": "SPRN-TS",
  "TOWNSHIP OF ST CLAIR": "STCL-TS",
  "TOWNSHIP OF STIRLING-RAWDON": "STRL-TS",
  "TOWNSHIP OF STONE MILLS": "STNM-TS",
  "TOWNSHIP OF STRATHROY-CARADOC": "STR1-TS",
  "TOWNSHIP OF TAY VALLEY": "TYVL-TS",
  "TOWNSHIP OF TAY": "TY-TS",
  "TOWNSHIP OF TINY": "TNY-TS",
  "TOWNSHIP OF TUDOR AND CASHEL": "TDRN-TS",
  "TOWNSHIP OF TYENDINAGA": "TYND-TS",
  "TOWNSHIP OF UXBRIDGE": "UXBR-TS",
  "TOWNSHIP OF WAINFLEET": "WNFL-TS",
  "TOWNSHIP OF WARWICK": "WRWC-TS",
  "TOWNSHIP OF WELLESLEY": "WLLS-TS",
  "TOWNSHIP OF WELLINGTON NORTH": "WLL1-TS",
  "TOWNSHIP OF WEST LINCOLN": "WSTL-TS",
  "TOWNSHIP OF WHITEWATER REGION": "WHTW-TS",
  "TOWNSHIP OF WILMOT": "WLMT-TS",
  "TOWNSHIP OF WOLLASTON": "WLL2-TS",
  "TOWNSHIP OF WOOLWICH": "WLWC-TS",
  "TOWNSHIP OF ZORRA": "ZRR-TS",
  "TOWNSHIP OF ALBERTON": "ALBR-TS",
  "TOWNSHIP OF ARMOUR": "ARMR-TS",
  "TOWNSHIP OF ARMSTRONG": "ARMS-TS",
  "TOWNSHIP OF ASSIGINACK": "ASSG-TS",
  "TOWNSHIP OF BALDWIN": "BLDW-TS",
  "TOWNSHIP OF BILLINGS": "BLLN-TS",
  "TOWNSHIP OF BLACK RIVER-MATHESON": "BLCK-TS",
  "TOWNSHIP OF BONFIELD": "BNFL-TS",
  "TOWNSHIP OF BRETHOUR": "BRTH-TS",
  "TOWNSHIP OF BURPEE AND MILLS": "BRPN-TS",
  "TOWNSHIP OF CARLING": "CRLN-TS",
  "TOWNSHIP OF CASEY": "CSY-TS",
  "TOWNSHIP OF CHAMBERLAIN": "CHMB-TS",
  "TOWNSHIP OF CHAPLEAU": "CHPL-TS",
  "TOWNSHIP OF CHAPPLE": "CHPP-TS",
  "TOWNSHIP OF CHISHOLM": "CHSH-TS",
  "TOWNSHIP OF COCKBURN ISLAND": "CCKB-TS",
  "TOWNSHIP OF COLEMAN": "CLMN-TS",
  "TOWNSHIP OF CONMEE": "CNM-TS",
  "TOWNSHIP OF DAWSON": "DWSN-TS",
  "TOWNSHIP OF DORION": "DRN-TS",
  "TOWNSHIP OF DUBREUILVILLE": "DBRL-TS",
  "TOWNSHIP OF EAR FALLS": "ERFL-TS",
  "TOWNSHIP OF EAST FERRIS": "ESTF-TS",
  "TOWNSHIP OF EMO": "EM-TS",
  "TOWNSHIP OF EVANTUREL": "EVNT-TS",
  "TOWNSHIP OF FAUQUIER-STRICKLAND": "FQRS-TS",
  "TOWNSHIP OF GAUTHIER": "GTHR-TS",
  "TOWNSHIP OF GILLIES": "GLLS-TS",
  "TOWNSHIP OF HARLEY": "HRLY-TS",
  "TOWNSHIP OF HARRIS": "HRRS-TS",
  "TOWNSHIP OF HILLIARD": "HLLR-TS",
  "TOWNSHIP OF HILTON": "HLT1-TS",
  "TOWNSHIP OF HORNEPAYNE": "HRNP-TS",
  "TOWNSHIP OF HUDSON": "HDSN-TS",
  "TOWNSHIP OF IGNACE": "IGNC-TS",
  "TOWNSHIP OF JAMES": "JMS-TS",
  "TOWNSHIP OF JOCELYN": "JCLY-TS",
  "TOWNSHIP OF JOHNSON": "JHNS-TS",
  "TOWNSHIP OF JOLY": "JLY-TS",
  "TOWNSHIP OF KERNS": "KRNS-TS",
  "TOWNSHIP OF LA VALLEE": "LVLL-TS",
  "TOWNSHIP OF LAIRD": "LRD-TS",
  "TOWNSHIP OF LAKE OF THE WOODS": "LKWD-TS",
  "TOWNSHIP OF LARDER LAKE": "LRDR-TS",
  "TOWNSHIP OF MACDONALD": "MCDN-TS",
  "TOWNSHIP OF MACHAR": "MCHR-TS",
  "TOWNSHIP OF MACHIN": "MCHN-TS",
  "TOWNSHIP OF MANITOUWADGE": "MNTW-TS",
  "TOWNSHIP OF MATACHEWAN": "MTCH-TS",
  "TOWNSHIP OF MATTAWAN": "MTT1-TS",
  "TOWNSHIP OF MATTICE-VAL CÔTÉ": "MTTC-TS",
  "TOWNSHIP OF MCDOUGALL": "MCDG-TS",
  "TOWNSHIP OF MCGARRY": "MCGR-TS",
  "TOWNSHIP OF MCKELLAR": "MCKL-TS",
  "TOWNSHIP OF MCMURRICH/MONTEITH": "MCMR-TS",
  "TOWNSHIP OF MOONBEAM": "MNBM-TS",
  "TOWNSHIP OF MORLEY": "MRLY-TS",
  "TOWNSHIP OF NAIRN AND HYMAN": "NRNN-TS",
  "TOWNSHIP OF NIPIGON": "NPGN-TS",
  "TOWNSHIP OF NIPISSING": "NPSS-TS",
  "TOWNSHIP OF O'CONNOR": "OCNN-TS",
  "TOWNSHIP OF OPASATIKA": "OPST-TS",
  "TOWNSHIP OF PAPINEAU-CAMERON": "PPNC-TS",
  "TOWNSHIP OF PELEE": "PELE-TS",
  "TOWNSHIP OF PERRY": "PRR1-TS",
  "TOWNSHIP OF PICKLE LAKE": "PCKL-TS",
  "TOWNSHIP OF PLUMMER ADDITIONAL": "PLMM-TS",
  "TOWNSHIP OF PRINCE": "PRNC-TS",
  "TOWNSHIP OF RED ROCK": "RDRC-TS",
  "TOWNSHIP OF RYERSON": "RYRS-TS",
  "TOWNSHIP OF SABLES-SPANISH RIVERS": "SBLS-TS",
  "TOWNSHIP OF SCHREIBER": "SCHR-TS",
  "TOWNSHIP OF SEGUIN": "SGN-TS",
  "TOWNSHIP OF SIOUX NARROWS-NESTOR FALLS": "SXNR-TS",
  "TOWNSHIP OF SOUTH ALGONQUIN": "STHL-TS",
  "TOWNSHIP OF ST JOSEPH": "STJS-TS",
  "TOWNSHIP OF STRONG": "STRN-TS",
  "TOWNSHIP OF TARBUTT": "TRBT-TS",
  "TOWNSHIP OF TEHKUMMAH": "THKM-TS",
  "TOWNSHIP OF TERRACE BAY": "TRRC-TS",
  "TOWNSHIP OF THE ARCHIPELAGO": "THRC-TS",
  "TOWNSHIP OF THE NORTH SHORE": "THNR-TS",
  "TOWNSHIP OF VAL RITA-HARTY": "VLRT-TS",
  "TOWNSHIP OF WHITE RIVER": "WHTR-TS",
  "VILLAGE OF CASSELMAN": "CSSL-V",
  "VILLAGE OF MERRICKVILLE-WOLFORD": "MRRC-V",
  "VILLAGE OF NEWBURY": "NWBR-V",
  "VILLAGE OF OIL SPRINGS": "OLSP-V",
  "VILLAGE OF POINT EDWARD": "PNTD-V",
  "VILLAGE OF WESTPORT": "WSTP-V",
  "VILLAGE OF BURK'S FALLS": "BRKS-V",
  "VILLAGE OF HILTON BEACH": "HLT2-V",
  "VILLAGE OF SOUTH RIVER": "STHR-V",
  "VILLAGE OF SUNDRIDGE": "SNDR-V",
  "VILLAGE OF THORNLOE": "THRN-V",
  "MUNICIPALITY OF ARRAN-ELDERSLIE": "ARRN-M",
  "MUNICIPALITY OF BLUEWATER": "BLWT-M",
  "MUNICIPALITY OF BRIGHTON": "BRGH-M",
  "MUNICIPALITY OF BROCKTON": "BRC2-M",
  "MUNICIPALITY OF BROOKE-ALVINSTON": "BRKL-M",
  "MUNICIPALITY OF CENTRAL ELGIN": "CNT2-M",
  "MUNICIPALITY OF CENTRAL HURON": "CNT3-M",
  "MUNICIPALITY OF CENTRE HASTINGS": "CNT4-M",
  "MUNICIPALITY OF CLARINGTON": "CLR3-M",
  "MUNICIPALITY OF DUTTON": "DTTN-M",
  "MUNICIPALITY OF DUNWICH": "DNWC-M",
  "MUNICIPALITY OF GREY HIGHLANDS": "GRYH-M",
  "MUNICIPALITY OF HASTINGS HIGHLANDS": "HSTN-M",
  "MUNICIPALITY OF HIGHLANDS EAST": "HGHL-M",
  "MUNICIPALITY OF HURON EAST": "HRNS-M",
  "MUNICIPALITY OF KINCARDINE": "KNCR-M",
  "MUNICIPALITY OF LAMBTON SHORES": "LMBT-M",
  "MUNICIPALITY OF LEAMINGTON": "LMNG-M",
  "MUNICIPALITY OF MEAFORD": "MFRD-M",
  "MUNICIPALITY OF MIDDLESEX CENTRE": "MDDL-M",
  "MUNICIPALITY OF MORRIS-TURNBERRY": "MRRS-M",
  "MUNICIPALITY OF NORTH GRENVILLE": "NRT10-M",
  "MUNICIPALITY OF NORTH MIDDLESEX": "NRT11-M",
  "MUNICIPALITY OF NORTH PERTH": "NRT12-M",
  "MUNICIPALITY OF NORTHERN BRUCE PENINSULA": "NRT13-M",
  "MUNICIPALITY OF PORT HOPE": "PRT3-M",
  "MUNICIPALITY OF RED LAKE": "RDL1-M",
  "MUNICIPALITY OF SOUTH BRUCE": "STH3-M",
  "MUNICIPALITY OF SOUTH DUNDAS": "STHD-M",
  "MUNICIPALITY OF SOUTH HURON": "STHH-M",
  "MUNICIPALITY OF SOUTHWEST MIDDLESEX": "STH4-M",
  "MUNICIPALITY OF THAMES CENTRE": "THMS-M",
  "MUNICIPALITY OF THE NATION MUNICIPALITY": "THNT-M",
  "MUNICIPALITY OF TRENT HILLS": "TRNT-M",
  "MUNICIPALITY OF TRENT LAKES": "TRN1-M",
  "MUNICIPALITY OF TWEED": "TWD-M",
  "MUNICIPALITY OF WEST ELGIN": "WST1-M",
  "MUNICIPALITY OF WEST GREY": "WSTG-M",
  "MUNICIPALITY OF WEST PERTH": "WST2-M",
  "MUNICIPALITY OF MARMORA AND LAKE": "MRMR-M",
  "MUNICIPALITY OF CALLANDER": "CLL1-M",
  "MUNICIPALITY OF CALVIN": "CLVN-M",
  "MUNICIPALITY OF CENTRAL MANITOULIN": "CNT5-M",
  "MUNICIPALITY OF CHARLTON AND DACK": "CHRL-M",
  "MUNICIPALITY OF CHATHAM-KENT": "CHTH-M",
  "MUNICIPALITY OF FRENCH RIVER": "FRNC-M",
  "MUNICIPALITY OF GORDON/BARRIE ISLAND": "GRDN-M",
  "MUNICIPALITY OF GREENSTONE": "GRNS-M",
  "MUNICIPALITY OF HURON SHORES": "HRN1-M",
  "MUNICIPALITY OF KILLARNEY": "KLLR-M",
  "MUNICIPALITY OF MAGNETAWAN": "MGNT-M",
  "MUNICIPALITY OF OLIVER PAIPOONGE": "OLVR-M",
  "MUNICIPALITY OF MARKSTAY-WARREN": "MRKS-M",
  "MUNICIPALITY OF NEEBING": "NBNG-M",
  "MUNICIPALITY OF POWASSAN": "PWSS-M",
  "MUNICIPALITY OF SHUNIAH": "SHNH-M",
  "MUNICIPALITY OF SIOUX LOOKOUT": "SXLK-M",
  "MUNICIPALITY OF ST CHARLES": "STCH-M",
  "MUNICIPALITY OF TEMAGAMI": "TMGM-M",
  "MUNICIPALITY OF WAWA": "WW-M",
  "MUNICIPALITY OF WEST NIPISSING": "WSTN-M",
  "MUNICIPALITY OF WHITESTONE": "WHTS-M",
  "MUNICIPALITY OF DURHAM": "DRHM-M",
  "MUNICIPALITY OF HALTON": "HLT3-M",
  "MUNICIPALITY OF MUSKOKA": "MSK1-M",
  "MUNICIPALITY OF NIAGARA": "NGR-M",
  "MUNICIPALITY OF PEEL": "PL1-M",
  "MUNICIPALITY OF WATERLOO": "WTR1-M",
  "MUNICIPALITY OF YORK": "YRK-M",
  "MOUNT OLIVE-SILVERSTONE-JAMESTOWN, TORONTO": "TOR",
  "THISTLETOWN-BEAUMOND HEIGHTS, TORONTO": "TOR",
  "KINGSVIEW VILLAGE-THE WESTWAY, TORONTO": "TOR",
  "BEDFORD PARK-NORTOWN, TORONTO": "TOR",
  "VICTORIA VILLAGE, TORONTO": "TOR",
  "DON VALLEY VILLAGE, TORONTO": "TOR",
  "HILLCREST VILLAGE, TORONTO": "TOR",
  "BAYVIEW VILLAGE, TORONTO": "TOR",
  "CABBAGETOWN-SOUTH ST JAMES TOWN, TORONTO": "TOR",
  "NORTH ST JAMES TOWN, TORONTO": "TOR",
  "KENSINGTON-CHINATOWN, TORONTO": "TOR",
  "RUNNYMEDE-BLOOR WEST VILLAGE, TORONTO": "TOR",
  "OAKWOOD VILLAGE, TORONTO": "TOR",
  "SCARBOROUGH VILLAGE, TORONTO": "TOR",
  "ETOBICOKE CITY CENTRE, TORONTO": "TOR",
  "FORT YORK-LIBERTY VILLAGE, TORONTO": "TOR",
  "HARBOURFRONT-CITYPLACE, TORONTO": "TOR",
  "DOWNTOWN YONGE EAST, TORONTO": "TOR",
  "DOVERCOURT VILLAGE, TORONTO": "TOR",
  "CENTRETOWN, OTTAWA": "OTT",
  "DOWNTOWN, OTTAWA": "OTT",
  "LOWER TOWN, OTTAWA": "OTT",
  "BELLTOWN, OTTAWA": "OTT",
  "BRITANNIA VILLAGE, OTTAWA": "OTT",
  "WELLINGTON VILLAGE, OTTAWA": "OTT",
  "BLACKBURN HAMLET, OTTAWA": "OTT",
  "ORLÉANS VILLAGE, OTTAWA": "OTT",
  "WINDSOR PARK VILLAGE, OTTAWA": "OTT",
  "CITY VIEW, OTTAWA": "OTT",
  "LYNWOOD VILLAGE, OTTAWA": "OTT",
  "TREND VILLAGE, OTTAWA": "OTT",
  "CHATELAINE VILLAGE, OTTAWA": "OTT",
  "CUMBERLAND VILLAGE, OTTAWA": "OTT",
  "TOWN CENTRE (ORLEANS), OTTAWA": "OTT",
  "QUEENSWOOD VILLAGE, OTTAWA": "OTT",
  "AMBERWOOD VILLAGE, OTTAWA": "OTT",
  "OSGOODE TOWNSHIP, OTTAWA": "OTT",
  "GOODSTOWN, OTTAWA": "OTT",
  "MARATHON VILLAGE, OTTAWA": "OTT",
  "BEACONWOOD VILLAGE, OTTAWA": "OTT",
  "CITY CENTRE, MISSISSAUGA": "MIS",
  "MEADOWVALE VILLAGE, MISSISSAUGA": "MIS",
  "OVATION AT CITY CENTRE, MISSISSAUGA": "MIS",
  "VILLAGE CENTRE, MISSISSAUGA": "MIS",
  "DOWNTOWN BRAMPTON, BRAMPTON": "BRA",
  "FLETCHERS CREEK VILLAGE, BRAMPTON": "BRA",
  "BARNSTOWN, HAMILTON": "HAM",
  "COPETOWN, HAMILTON": "HAM",
  "CORKTOWN, HAMILTON": "HAM",
  "BERKSHIRE VILLAGE, LONDON": "LON",
  "DOWNTOWN LONDON, LONDON": "LON",
  "GRENFELL VILLAGE, LONDON": "LON",
  "CATHEDRALTOWN, MARKHAM": "MAR",
  "MARKHAM VILLAGE, MARKHAM": "MAR",
  "OLD MARKHAM VILLAGE, MARKHAM": "MAR",
  "VILLAGE GREEN - SOUTH UNIONVILLE, MARKHAM": "MAR",
  "VELLORE VILLAGE": "VAU",
  "CITY COMMERCIAL CORE": "KIT",
  "GRAND HILL VILLAGE": "KIT",
  "DOWNTOWN WINDSOR, WINDSOR": "WIN",
  "FORD CITY, WINDSOR": "WIN",
  "MIDTOWN, WINDSOR": "WIN",
  "OTTAWA STREET VILLAGE, WINDSOR": "WIN",
  "PEACHTREE VILLAGE, WINDSOR": "WIN",
  "PILLETTE ROAD VILLAGE, WINDSOR": "WIN",
  "WYANDOTTE TOWNE CENTRE, WINDSOR": "WIN",
  "OAKVILLE, DOWNTOWN OAKVILLE": "OAK",
  "ALTON VILLAGE": "BUR",
  "UPTOWN": "OSH",
  "OSHAWA, DOWNTOWN OSHAWA": "OSH",
  "GREATER SUDBURY, HISTORIC DOWNTOWN SUDBURY": "GRE",
  "CITY CENTER": "BAR",
  "GUELPH, GUELPH DOWNTOWN": "GUE",
  "GUELPH, GUELPH VILLAGE": "GUE",
  "GUELPH, WEST WILLOW VILLAGE": "GUE",
  "WHITBY, DOWNTOWN WHITBY": "WHI",
  "AJAX, DOWNTOWN AJAX": "AJA",
  "AJAX, MEMORIAL VILLAGE": "AJA",
  "AJAX, MIDTOWN": "AJA",
  "AJAX, VILLAGE": "AJA",
  "ST CATHERINES, DOWNTOWN ST CATHARINES": "STC",
  "CAMBRIDGE, DOWNTOWN CAMBRIDGE": "CAM",
  "CAMBRIDGE, GALT CITY CENTRE": "CAM",
  "CAMBRIDGE, HESPELER VILLAGE": "CAM",
  "KINGSTON, BARRIEFIELD VILLAGE HERITAGE DISTRICT": "KIN",
  "KINGSTON, DOWNTOWN KINGSTON": "KIN",
  "WATERLOO, DOWNTOWN WATERLOO": "KIN",
  "WATERLOO, LINCOLN VILLAGE": "KIN",
  "WATERLOO, UPTOWN WATERLOO": "KIN",
  "WATERLOO, UPTOWN WEST": "KIN",
  "THUNDER BAY, DOWNTOWN FORT WILLIAM": "FRI",
  "THUNDER BAY, DOWNTOWN PORT ARTHUR": "SAT",
  "THUNDER BAY, INTERCITY": "THU",
  "THUNDER BAY, WESTFORT VILLAGE": "CLA",
  "BRANTFORD, CITY CENTRE & ACADEMIC DISTRICT": "BRA",
  "BRANTFORD, DOWNTOWN BRANTFORD": "BRA",
  "BRANTFORD, MARKET STREET VILLAGE": "BRA",
  "CITY OF CHARLOTTETOWN": "CHRL-C",
  "CITY OF SUMMERSIDE": "SMMR-C",
  "TOWN OF ALBERTON": "ALBR-T",
  "TOWN OF BORDEN-CARLETON": "BRDN-T",
  "TOWN OF CORNWALL": "CRNW-T",
  "TOWN OF KENSINGTON": "KNSN-T",
  "TOWN OF NORTH RUSTICO": "NRTH-T",
  "TOWN OF O'LEARY": "OLRY-T",
  "TOWN OF SOURIS": "SRS-T",
  "TOWN OF STRATFORD": "STRT-T",
  "TOWN OF THREE RIVERS": "THRR-T",
  "TOWN OF TIGNISH": "TGNS-T",
  "MUNICIPALITY OF TIGNISH SHORE": "TGN1-M",
  "RESORT MUNICIPALITY OF STANLEY BRIDGE": "STNL-RS",
  "RESORT MUNICIPALITY OF HOPE RIVER": "HPRV-RS",
  "RESORT MUNICIPALITY OF BAYVIEW": "BYVW-RS",
  "RESORT MUNICIPALITY OF CAVENDISH": "CVND-RS",
  "RESORT MUNICIPALITY OF NORTH RUSTICO": "NRT1-RS",
  "RURAL MUNICIPALITY OF ABRAM-VILLAGE": "ABRM-RM",
  "RURAL MUNICIPALITY OF ALEXANDRA": "ALXN-RM",
  "RURAL MUNICIPALITY OF ANNANDALE-LITTLE POND-HOWE BAY": "ANNN-RM",
  "RURAL MUNICIPALITY OF BEDEQUE & AREA": "BDQR-RM",
  "RURAL MUNICIPALITY OF BELFAST": "BLFS-RM",
  "RURAL MUNICIPALITY OF BREADALBANE": "BRDL-RM",
  "RURAL MUNICIPALITY OF CENTRAL KINGS": "CNTR-RM",
  "RURAL MUNICIPALITY OF CENTRAL PRINCE": "CNT1-RM",
  "RURAL MUNICIPALITY OF CLYDE RIVER": "CLYD-RM",
  "RURAL MUNICIPALITY OF CRAPAUD": "CRPD-RM",
  "RURAL MUNICIPALITY OF EASTERN KINGS": "ESTR-RM",
  "RURAL MUNICIPALITY OF GREENMOUNT-MONTROSE": "GRNM-RM",
  "RURAL MUNICIPALITY OF HAMPSHIRE": "HMPS-RM",
  "RURAL MUNICIPALITY OF HAZELBROOK": "HZLB-RM",
  "RURAL MUNICIPALITY OF HUNTER RIVER": "HNTR-RM",
  "RURAL MUNICIPALITY OF KINGSTON": "KNGS-RM",
  "RURAL MUNICIPALITY OF KINKORA": "KNKR-RM",
  "RURAL MUNICIPALITY OF LINKLETTER": "LNKL-RM",
  "RURAL MUNICIPALITY OF LOT 11 & AREA": "LTR-RM",
  "RURAL MUNICIPALITY OF MALPEQUE BAY": "MLPQ-RM",
  "RURAL MUNICIPALITY OF MILTONVALE PARK": "MLTN-RM",
  "RURAL MUNICIPALITY OF MIMINEGASH": "MMNG-RM",
  "RURAL MUNICIPALITY OF MISCOUCHE": "MSCC-RM",
  "RURAL MUNICIPALITY OF MORELL": "MRLL-RM",
  "RURAL MUNICIPALITY OF MOUNT STEWART": "MNTS-RM",
  "RURAL MUNICIPALITY OF MURRAY HARBOUR": "MRRY-RM",
  "RURAL MUNICIPALITY OF MURRAY RIVER": "MRR1-RM",
  "RURAL MUNICIPALITY OF NORTH SHORE": "NRT2-RM",
  "RURAL MUNICIPALITY OF NORTH WILTSHIRE": "NRT3-RM",
  "RURAL MUNICIPALITY OF NORTHPORT": "NRT4-RM",
  "RURAL MUNICIPALITY OF PLEASANT GROVE": "PLSN-RM",
  "RURAL MUNICIPALITY OF SHERBROOKE": "SHRB-RM",
  "RURAL MUNICIPALITY OF SOURIS WEST": "SRSW-RM",
  "RURAL MUNICIPALITY OF ST FELIX": "STFL-RM",
  "RURAL MUNICIPALITY OF ST LOUIS": "STLS-RM",
  "RURAL MUNICIPALITY OF ST NICHOLAS": "STNC-RM",
  "RURAL MUNICIPALITY OF ST PETERS": "STPT-RM",
  "RURAL MUNICIPALITY OF TYNE VALLEY": "TYNV-RM",
  "RURAL MUNICIPALITY OF UNION ROAD": "UNNR-RM",
  "RURAL MUNICIPALITY OF VICTORIA": "VCTR-RM",
  "RURAL MUNICIPALITY OF WARREN GROVE": "WRRN-RM",
  "RURAL MUNICIPALITY OF WELLINGTON": "WLLN-RM",
  "RURAL MUNICIPALITY OF WEST RIVER": "WSTR-RM",
  "DOWNTOWN CHARLOTTETOWN, CHARLOTTETOWN": "CHA",
  "BRIGHTON, CHARLOTTETOWN": "CHA",
  "SPRING PARK, CHARLOTTETOWN": "CHA",
  "PARKDALE, CHARLOTTETOWN": "CHA",
  "SHERWOOD, CHARLOTTETOWN": "CHA",
  "EAST ROYALTY, CHARLOTTETOWN": "CHA",
  "HILLSBOROUGH PARK, CHARLOTTETOWN": "CHA",
  "WEST ROYALTY, CHARLOTTETOWN": "CHA",
  "WINSLOE, CHARLOTTETOWN": "CHA",
  "LEWIS POINT, CHARLOTTETOWN": "CHA",
  "BEACH GROVE, CHARLOTTETOWN": "CHA",
  "CITY OF LÉVIS": "LVS-C",
  "CITY OF MONTREAL": "MNTR-C",
  "CITY OF RIGAUD": "RGD-C",
  "CITY OF SAINT-HONORÉ": "SNTH-C",
  "CITY OF SAINT-PHILIPPE": "SNTP-C",
  "CITY OF SAINTE-BRIGITTE-DE-LAVAL": "SNTB-C",
  "CITY OF SHANNON": "SHNN-C",
  "MUNICIPALITY OF ADSTOCK": "ADST-M",
  "MUNICIPALITY OF AGUANISH": "AGNS-M",
  "MUNICIPALITY OF ALBANEL": "ALBN-M",
  "MUNICIPALITY OF ALBERTVILLE": "ALBR-M",
  "MUNICIPALITY OF ALLEYN-ET-CAWOOD": "ALLY-M",
  "MUNICIPALITY OF ANGE-GARDIEN": "ANGG-M",
  "MUNICIPALITY OF ARMAGH": "ARMG-M",
  "MUNICIPALITY OF ASCOT CORNER": "ASCT-M",
  "MUNICIPALITY OF ASTON-JONCTION": "ASTN-M",
  "MUNICIPALITY OF AUCLAIR": "ACLR-M",
  "MUNICIPALITY OF AUDET": "ADT-M",
  "MUNICIPALITY OF AUSTIN": "AST1-M",
  "MUNICIPALITY OF AUTHIER": "ATHR-M",
  "MUNICIPALITY OF AUTHIER-NORD": "ATH1-M",
  "MUNICIPALITY OF BAIE-DES-SABLES": "BDSS-M",
  "MUNICIPALITY OF BAIE-DU-FEBVRE": "BDFB-M",
  "MUNICIPALITY OF BAIE-JOHAN-BEETZ": "BJHN-M",
  "MUNICIPALITY OF BAIE-SAINTE-CATHERINE": "BSNT-M",
  "MUNICIPALITY OF BARNSTON-OUEST": "BRNS-M",
  "MUNICIPALITY OF BARRAUTE": "BRRT-M",
  "MUNICIPALITY OF BATISCAN": "BTSC-M",
  "MUNICIPALITY OF BÉARN": "BRN-M",
  "MUNICIPALITY OF BEAULAC-GARTHBY": "BLCG-M",
  "MUNICIPALITY OF BEAUMONT": "BMNT-M",
  "MUNICIPALITY OF BÉGIN": "BGN-M",
  "MUNICIPALITY OF BELCOURT": "BLCR-M",
  "MUNICIPALITY OF BERRY": "BRRY-M",
  "MUNICIPALITY OF BERTHIER-SUR-MER": "BRTH-M",
  "MUNICIPALITY OF BÉTHANIE": "BTHN-M",
  "MUNICIPALITY OF BIENCOURT": "BNCR-M",
  "MUNICIPALITY OF BLANC-SABLON": "BLNC-M",
  "MUNICIPALITY OF BLUE SEA": "BLS-M",
  "MUNICIPALITY OF BOILEAU": "BL-M",
  "MUNICIPALITY OF BOIS-FRANC": "BSFR-M",
  "MUNICIPALITY OF BOISCHATEL": "BSCH-M",
  "MUNICIPALITY OF BOLTON-EST": "BLTN-M",
  "MUNICIPALITY OF BOLTON-OUEST": "BLT1-M",
  "MUNICIPALITY OF BONNE-ESPÉRANCE": "BNNS-M",
  "MUNICIPALITY OF BONSECOURS": "BNSC-M",
  "MUNICIPALITY OF BOUCHETTE": "BCHT-M",
  "MUNICIPALITY OF BOWMAN": "BWMN-M",
  "MUNICIPALITY OF BRIGHAM": "BRGH-M",
  "MUNICIPALITY OF BRISTOL": "BRST-M",
  "MUNICIPALITY OF BRYSON": "BRYS-M",
  "MUNICIPALITY OF BURY": "BRY-M",
  "MUNICIPALITY OF CACOUNA": "CCN-M",
  "MUNICIPALITY OF CALIXA-LAVALLÉE": "CLXL-M",
  "MUNICIPALITY OF CAMPBELL'S BAY": "CMPB-M",
  "MUNICIPALITY OF CANTLEY": "CNTL-M",
  "MUNICIPALITY OF CAP-SAINT-IGNACE": "CPSN-M",
  "MUNICIPALITY OF CAPLAN": "CPLN-M",
  "MUNICIPALITY OF CASCAPÉDIA--SAINT-JULES": "CSCP-M",
  "MUNICIPALITY OF CAYAMANT": "CYMN-M",
  "MUNICIPALITY OF CHAMBORD": "CHMB-M",
  "MUNICIPALITY OF CHAMPLAIN": "CHMP-M",
  "MUNICIPALITY OF CHAMPNEUF": "CHM1-M",
  "MUNICIPALITY OF CHARETTE": "CHRT-M",
  "MUNICIPALITY OF CHARTIERVILLE": "CHR1-M",
  "MUNICIPALITY OF CHAZEL": "CHZL-M",
  "MUNICIPALITY OF CHELSEA": "CHLS-M",
  "MUNICIPALITY OF CHÉNÉVILLE": "CHNV-M",
  "MUNICIPALITY OF CHERTSEY": "CHR2-M",
  "MUNICIPALITY OF CHESTERVILLE": "CHST-M",
  "MUNICIPALITY OF CHUTE-SAINT-PHILIPPE": "CHTS-M",
  "MUNICIPALITY OF CLARENDON": "CLRN-M",
  "MUNICIPALITY OF CLERVAL": "CLRV-M",
  "MUNICIPALITY OF COLOMBIER": "CLMB-M",
  "MUNICIPALITY OF COMPTON": "CMPT-M",
  "MUNICIPALITY OF CÔTE-NORD-DU-GOLFE-DU-SAINT-LAURENT": "CTNR-M",
  "MUNICIPALITY OF COURCELLES": "CRCL-M",
  "MUNICIPALITY OF CRABTREE": "CRBT-M",
  "MUNICIPALITY OF DÉLÉAGE": "DLG-M",
  "MUNICIPALITY OF DENHOLM": "DNHL-M",
  "MUNICIPALITY OF DESCHAILLONS-SUR-SAINT-LAURENT": "DSCH-M",
  "MUNICIPALITY OF DESCHAMBAULT-GRONDINES": "DSC1-M",
  "MUNICIPALITY OF DIXVILLE": "DXVL-M",
  "MUNICIPALITY OF DOSQUET": "DSQT-M",
  "MUNICIPALITY OF DUDSWELL": "DDSW-M",
  "MUNICIPALITY OF DUHAMEL": "DHML-M",
  "MUNICIPALITY OF DUHAMEL-OUEST": "DHM1-M",
  "MUNICIPALITY OF DUPUY": "DPY-M",
  "MUNICIPALITY OF DURHAM-SUD": "DRHM-M",
  "MUNICIPALITY OF EAST BROUGHTON": "ESTB-M",
  "MUNICIPALITY OF EAST FARNHAM": "ESTF-M",
  "MUNICIPALITY OF EAST HEREFORD": "ESTH-M",
  "MUNICIPALITY OF EASTMAN": "ESTM-M",
  "MUNICIPALITY OF EGAN-SUD": "EGNS-M",
  "MUNICIPALITY OF ELGIN": "ELGN-M",
  "MUNICIPALITY OF ENTRELACS": "ENTR-M",
  "MUNICIPALITY OF ESCUMINAC": "ESCM-M",
  "MUNICIPALITY OF ESPRIT-SAINT": "ESPR-M",
  "MUNICIPALITY OF FASSETT": "FSST-M",
  "MUNICIPALITY OF FERLAND-ET-BOILLEAU": "FRLN-M",
  "MUNICIPALITY OF FERME-NEUVE": "FRMN-M",
  "MUNICIPALITY OF FORTIERVILLE": "FRTR-M",
  "MUNICIPALITY OF FRAMPTON": "FRMP-M",
  "MUNICIPALITY OF FRANKLIN": "FRNK-M",
  "MUNICIPALITY OF FRANQUELIN": "FRNQ-M",
  "MUNICIPALITY OF FRELIGHSBURG": "FRLG-M",
  "MUNICIPALITY OF FRONTENAC": "FRNT-M",
  "MUNICIPALITY OF FUGÈREVILLE": "FGRV-M",
  "MUNICIPALITY OF GALLICHAN": "GLLC-M",
  "MUNICIPALITY OF GIRARDVILLE": "GRRD-M",
  "MUNICIPALITY OF GOUVERNEMENT RÉGIONAL D'EEYOU ISTCHEE BAIE-JAMES": "GVRN-M",
  "MUNICIPALITY OF GRAND-MÉTIS": "GRND-M",
  "MUNICIPALITY OF GRAND-REMOUS": "GRN1-M",
  "MUNICIPALITY OF GRAND-SAINT-ESPRIT": "GRN2-M",
  "MUNICIPALITY OF GRANDE-VALLÉE": "GRN3-M",
  "MUNICIPALITY OF GRENVILLE-SUR-LA-ROUGE": "GRNV-M",
  "MUNICIPALITY OF GROS-MÉCATINA": "GRSM-M",
  "MUNICIPALITY OF GROSSE-ÎLE": "GRSS-M",
  "MUNICIPALITY OF GROSSES-ROCHES": "GRS1-M",
  "MUNICIPALITY OF HAM-SUD": "HMSD-M",
  "MUNICIPALITY OF HATLEY": "HTLY-M",
  "MUNICIPALITY OF HAVRE-SAINT-PIERRE": "HVRS-M",
  "MUNICIPALITY OF HÉBERTVILLE": "HBRT-M",
  "MUNICIPALITY OF HENRYVILLE": "HNRY-M",
  "MUNICIPALITY OF HINCHINBROOKE": "HNCH-M",
  "MUNICIPALITY OF HONFLEUR": "HNFL-M",
  "MUNICIPALITY OF HOPE TOWN": "HPTW-M",
  "MUNICIPALITY OF HOWICK": "HWCK-M",
  "MUNICIPALITY OF HUBERDEAU": "HBRD-M",
  "MUNICIPALITY OF INVERNESS": "INVR-M",
  "MUNICIPALITY OF IRLANDE": "IRLN-M",
  "MUNICIPALITY OF IVRY-SUR-LE-LAC": "IVRY-M",
  "MUNICIPALITY OF KAMOURASKA": "KMRS-M",
  "MUNICIPALITY OF KAZABAZUA": "KZBZ-M",
  "MUNICIPALITY OF KIAMIKA": "KMK-M",
  "MUNICIPALITY OF KINNEAR'S MILLS": "KNNR-M",
  "MUNICIPALITY OF KIPAWA": "KPW-M",
  "MUNICIPALITY OF L'ANGE-GARDIEN": "LNGG-M",
  "MUNICIPALITY OF L'ANSE-SAINT-JEAN": "LNSS-M",
  "MUNICIPALITY OF L'ASCENSION": "LSCN-M",
  "MUNICIPALITY OF L'ASCENSION-DE-PATAPÉDIA": "LSC1-M",
  "MUNICIPALITY OF L'AVENIR": "LVNR-M",
  "MUNICIPALITY OF L'ÎLE-D'ANTICOSTI": "LLDN-M",
  "MUNICIPALITY OF L'ÎLE-DU-GRAND-CALUMET": "LLDG-M",
  "MUNICIPALITY OF L'ISLE-AUX-ALLUMETTES": "LSLX-M",
  "MUNICIPALITY OF L'ISLE-AUX-COUDRES": "LSL1-M",
  "MUNICIPALITY OF L'ISLE-VERTE": "LSLV-M",
  "MUNICIPALITY OF L'ISLET": "LSLT-M",
  "MUNICIPALITY OF LA BOSTONNAIS": "LBST-M",
  "MUNICIPALITY OF LA CONCEPTION": "LCNC-M",
  "MUNICIPALITY OF LA CORNE": "LCRN-M",
  "MUNICIPALITY OF LA MACAZA": "LMCZ-M",
  "MUNICIPALITY OF LA MARTRE": "LMRT-M",
  "MUNICIPALITY OF LA MINERVE": "LMNR-M",
  "MUNICIPALITY OF LA MORANDIÈRE": "LMRN-M",
  "MUNICIPALITY OF LA MOTTE": "LMTT-M",
  "MUNICIPALITY OF LA PATRIE": "LPTR-M",
  "MUNICIPALITY OF LA PÊCHE": "LPCH-M",
  "MUNICIPALITY OF LA PRÉSENTATION": "LPRS-M",
  "MUNICIPALITY OF LA REINE": "LRN-M",
  "MUNICIPALITY OF LA VISITATION-DE-L'ÎLE-DUPAS": "LVST-M",
  "MUNICIPALITY OF LA VISITATION-DE-YAMASKA": "LVS1-M",
  "MUNICIPALITY OF LABELLE": "LBLL-M",
  "MUNICIPALITY OF LABRECQUE": "LBRC-M",
  "MUNICIPALITY OF LAC-AU-SAUMON": "LCSM-M",
  "MUNICIPALITY OF LAC-BEAUPORT": "LCBP-M",
  "MUNICIPALITY OF LAC-BOUCHETTE": "LCBC-M",
  "MUNICIPALITY OF LAC-DES-AIGLES": "LCDS-M",
  "MUNICIPALITY OF LAC-DES-ÉCORCES": "LCD1-M",
  "MUNICIPALITY OF LAC-DES-PLAGES": "LCD2-M",
  "MUNICIPALITY OF LAC-DES-SEIZE-ÎLES": "LCD3-M",
  "MUNICIPALITY OF LAC-DROLET": "LCDR-M",
  "MUNICIPALITY OF LAC-DU-CERF": "LCDC-M",
  "MUNICIPALITY OF LAC-ÉDOUARD": "LCD4-M",
  "MUNICIPALITY OF LAC-ETCHEMIN": "LCTC-M",
  "MUNICIPALITY OF LAC-FRONTIÈRE": "LCFR-M",
  "MUNICIPALITY OF LAC-SAINT-PAUL": "LCSN-M",
  "MUNICIPALITY OF LAC-SAINTE-MARIE": "LCS1-M",
  "MUNICIPALITY OF LAC-SIMON": "LCS2-M",
  "MUNICIPALITY OF LAC-SUPÉRIEUR": "LCSP-M",
  "MUNICIPALITY OF LAC-TREMBLANT-NORD": "LCTR-M",
  "MUNICIPALITY OF LACOLLE": "LCLL-M",
  "MUNICIPALITY OF LAFORCE": "LFRC-M",
  "MUNICIPALITY OF LAMARCHE": "LMRC-M",
  "MUNICIPALITY OF LAMBTON": "LMBT-M",
  "MUNICIPALITY OF LANORAIE": "LNR-M",
  "MUNICIPALITY OF LANTIER": "LNTR-M",
  "MUNICIPALITY OF LAROUCHE": "LRCH-M",
  "MUNICIPALITY OF LAURIERVILLE": "LRRV-M",
  "MUNICIPALITY OF LAVERLOCHÈRE": "LVRL-M",
  "MUNICIPALITY OF LAVERLOCHÈRE ANGLIERS": "LVR1-M",
  "MUNICIPALITY OF LECLERCVILLE": "LCLR-M",
  "MUNICIPALITY OF LEFEBVRE": "LFBV-M",
  "MUNICIPALITY OF LEJEUNE": "LJN-M",
  "MUNICIPALITY OF LEMIEUX": "LMX-M",
  "MUNICIPALITY OF LES BERGERONNES": "LSBR-M",
  "MUNICIPALITY OF LES CÈDRES": "LSCD-M",
  "MUNICIPALITY OF LES COTEAUX": "LSCT-M",
  "MUNICIPALITY OF LES ÉBOULEMENTS": "LSBL-M",
  "MUNICIPALITY OF LES ESCOUMINS": "LSSC-M",
  "MUNICIPALITY OF LES HAUTEURS": "LSHT-M",
  "MUNICIPALITY OF LES ÎLES-DE-LA-MADELEINE": "LSLS-M",
  "MUNICIPALITY OF LES MÉCHINS": "LSMC-M",
  "MUNICIPALITY OF LITCHFIELD": "LTCH-M",
  "MUNICIPALITY OF LONGUE-POINTE-DE-MINGAN": "LNGP-M",
  "MUNICIPALITY OF LONGUE-RIVE": "LNGR-M",
  "MUNICIPALITY OF LORRAINVILLE": "LRRN-M",
  "MUNICIPALITY OF LOTBINIÈRE": "LTBN-M",
  "MUNICIPALITY OF LYSTER": "LYST-M",
  "MUNICIPALITY OF MADDINGTON FALLS": "MDDN-M",
  "MUNICIPALITY OF MANDEVILLE": "MNDV-M",
  "MUNICIPALITY OF MANSEAU": "MNS-M",
  "MUNICIPALITY OF MANSFIELD-ET-PONTEFRACT": "MNSF-M",
  "MUNICIPALITY OF MARIA": "MR-M",
  "MUNICIPALITY OF MARICOURT": "MRCR-M",
  "MUNICIPALITY OF MARTINVILLE": "MRTN-M",
  "MUNICIPALITY OF MASKINONGÉ": "MSKN-M",
  "MUNICIPALITY OF MATAPÉDIA": "MTPD-M",
  "MUNICIPALITY OF MAYO": "MY-M",
  "MUNICIPALITY OF MCMASTERVILLE": "MCMS-M",
  "MUNICIPALITY OF MESSINES": "MSSN-M",
  "MUNICIPALITY OF MILAN": "MLN-M",
  "MUNICIPALITY OF MILLE-ISLES": "MLLS-M",
  "MUNICIPALITY OF MOFFET": "MFFT-M",
  "MUNICIPALITY OF MONT-CARMEL": "MNTC-M",
  "MUNICIPALITY OF MONT-SAINT-GRÉGOIRE": "MNTS-M",
  "MUNICIPALITY OF MONT-SAINT-MICHEL": "MNT1-M",
  "MUNICIPALITY OF MONTCALM": "MNT2-M",
  "MUNICIPALITY OF MONTCERF-LYTTON": "MNT3-M",
  "MUNICIPALITY OF MONTEBELLO": "MNTB-M",
  "MUNICIPALITY OF MONTPELLIER": "MNTP-M",
  "MUNICIPALITY OF MONTRÉAL-EST": "MNT4-M",
  "MUNICIPALITY OF MONTRÉAL-OUEST": "MNT5-M",
  "MUNICIPALITY OF MORIN-HEIGHTS": "MRNH-M",
  "MUNICIPALITY OF MULGRAVE-ET-DERRY": "MLGR-M",
  "MUNICIPALITY OF NAMUR": "NMR-M",
  "MUNICIPALITY OF NANTES": "NNTS-M",
  "MUNICIPALITY OF NAPIERVILLE": "NPRV-M",
  "MUNICIPALITY OF NATASHQUAN": "NTSH-M",
  "MUNICIPALITY OF NEW CARLISLE": "NWCR-M",
  "MUNICIPALITY OF NEWPORT": "NWPR-M",
  "MUNICIPALITY OF NOMININGUE": "NMNN-M",
  "MUNICIPALITY OF NORMÉTAL": "NRMT-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-BONSECOURS": "NTRD-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-HAM": "NTR1-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-LA-MERCI": "NTR2-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-LA-PAIX": "NTR3-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-LA-SALETTE": "NTR4-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-LORETTE": "NTR5-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-LOURDES": "NTR6-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-MONTAUBAN": "NTR7-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-PONTMAIN": "NTR8-M",
  "MUNICIPALITY OF NOTRE-DAME-DE-STANBRIDGE": "NTR9-M",
  "MUNICIPALITY OF NOTRE-DAME-DES-BOIS": "NTR10-M",
  "MUNICIPALITY OF NOTRE-DAME-DES-MONTS": "NTR11-M",
  "MUNICIPALITY OF NOTRE-DAME-DES-NEIGES": "NTR12-M",
  "MUNICIPALITY OF NOTRE-DAME-DU-LAUS": "NTR13-M",
  "MUNICIPALITY OF NOTRE-DAME-DU-NORD": "NTR14-M",
  "MUNICIPALITY OF NOTRE-DAME-DU-PORTAGE": "NTR15-M",
  "MUNICIPALITY OF NOTRE-DAME-DU-ROSAIRE": "NTR16-M",
  "MUNICIPALITY OF NOUVELLE": "NVLL-M",
  "MUNICIPALITY OF NOYAN": "NYN-M",
  "MUNICIPALITY OF OGDEN": "OGDN-M",
  "MUNICIPALITY OF OKA": "OK-M",
  "MUNICIPALITY OF ORMSTOWN": "ORMS-M",
  "MUNICIPALITY OF OTTER LAKE": "OTTR-M",
  "MUNICIPALITY OF PADOUE": "PD-M",
  "MUNICIPALITY OF PALMAROLLE": "PLMR-M",
  "MUNICIPALITY OF PAPINEAUVILLE": "PPNV-M",
  "MUNICIPALITY OF PÉRIBONKA": "PRBN-M",
  "MUNICIPALITY OF PETIT-SAGUENAY": "PTTS-M",
  "MUNICIPALITY OF PETITE-RIVIÈRE-SAINT-FRANÇOIS": "PTTR-M",
  "MUNICIPALITY OF PETITE-VALLÉE": "PTTV-M",
  "MUNICIPALITY OF PIEDMONT": "PDMN-M",
  "MUNICIPALITY OF PIERREVILLE": "PRRV-M",
  "MUNICIPALITY OF PIKE RIVER": "PKRV-M",
  "MUNICIPALITY OF PIOPOLIS": "PPLS-M",
  "MUNICIPALITY OF PLAISANCE": "PLSN-M",
  "MUNICIPALITY OF POINTE-À-LA-CROIX": "PNTL-M",
  "MUNICIPALITY OF POINTE-CALUMET": "PNTC-M",
  "MUNICIPALITY OF PONTIAC": "PNT1-M",
  "MUNICIPALITY OF PORT-DANIEL--GASCONS": "PRTD-M",
  "MUNICIPALITY OF PORTNEUF-SUR-MER": "PRTN-M",
  "MUNICIPALITY OF POULARIES": "PLRS-M",
  "MUNICIPALITY OF PREISSAC": "PRSS-M",
  "MUNICIPALITY OF RACINE": "RCN-M",
  "MUNICIPALITY OF RAPIDE-DANSEUR": "RPDD-M",
  "MUNICIPALITY OF RAPIDES-DES-JOACHIMS": "RPDS-M",
  "MUNICIPALITY OF RAWDON": "RWDN-M",
  "MUNICIPALITY OF RÉMIGNY": "RMGN-M",
  "MUNICIPALITY OF RIPON": "RPN-M",
  "MUNICIPALITY OF RIVIÈRE-À-CLAUDE": "RVRC-M",
  "MUNICIPALITY OF RIVIÈRE-À-PIERRE": "RVRP-M",
  "MUNICIPALITY OF RIVIÈRE-AU-TONNERRE": "RVRT-M",
  "MUNICIPALITY OF RIVIÈRE-BEAUDETTE": "RVRB-M",
  "MUNICIPALITY OF RIVIÈRE-BLEUE": "RVR1-M",
  "MUNICIPALITY OF RIVIÈRE-ÉTERNITÉ": "RVR2-M",
  "MUNICIPALITY OF RIVIÈRE-HÉVA": "RVRH-M",
  "MUNICIPALITY OF RIVIÈRE-OUELLE": "RVRL-M",
  "MUNICIPALITY OF RIVIÈRE-SAINT-JEAN": "RVRS-M",
  "MUNICIPALITY OF ROCHEBAUCOURT": "RCHB-M",
  "MUNICIPALITY OF ROQUEMAURE": "RQMR-M",
  "MUNICIPALITY OF ROUGEMONT": "RGMN-M",
  "MUNICIPALITY OF ROXTON POND": "RXTN-M",
  "MUNICIPALITY OF SACRÉ-CŒUR": "SCRC-M",
  "MUNICIPALITY OF SAINT-ADALBERT": "SNTD-M",
  "MUNICIPALITY OF SAINT-ADOLPHE-D'HOWARD": "SNT1-M",
  "MUNICIPALITY OF SAINT-ADRIEN": "SNT2-M",
  "MUNICIPALITY OF SAINT-ADRIEN-D'IRLANDE": "SNT3-M",
  "MUNICIPALITY OF SAINT-AGAPIT": "SNTG-M",
  "MUNICIPALITY OF SAINT-AIMÉ": "SNTM-M",
  "MUNICIPALITY OF SAINT-AIMÉ-DES-LACS": "SNT4-M",
  "MUNICIPALITY OF SAINT-AIMÉ-DU-LAC-DES-ÎLES": "SNT5-M",
  "MUNICIPALITY OF SAINT-ALBAN": "SNTL-M",
  "MUNICIPALITY OF SAINT-ALBERT": "SNT6-M",
  "MUNICIPALITY OF SAINT-ALEXANDRE": "SNT7-M",
  "MUNICIPALITY OF SAINT-ALEXANDRE-DE-KAMOURASKA": "SNT8-M",
  "MUNICIPALITY OF SAINT-ALEXIS": "SNT9-M",
  "MUNICIPALITY OF SAINT-ALFRED": "SNT10-M",
  "MUNICIPALITY OF SAINT-ALPHONSE": "SNT11-M",
  "MUNICIPALITY OF SAINT-ALPHONSE-DE-GRANBY": "SNT12-M",
  "MUNICIPALITY OF SAINT-ALPHONSE-RODRIGUEZ": "SNT13-M",
  "MUNICIPALITY OF SAINT-AMABLE": "SNT14-M",
  "MUNICIPALITY OF SAINT-AMBROISE": "SNT15-M",
  "MUNICIPALITY OF SAINT-AMBROISE-DE-KILDARE": "SNT16-M",
  "MUNICIPALITY OF SAINT-ANDRÉ": "SNTN-M",
  "MUNICIPALITY OF SAINT-ANDRÉ-AVELLIN": "SNT17-M",
  "MUNICIPALITY OF SAINT-ANDRÉ-D'ARGENTEUIL": "SNT18-M",
  "MUNICIPALITY OF SAINT-ANDRÉ-DE-RESTIGOUCHE": "SNT19-M",
  "MUNICIPALITY OF SAINT-ANICET": "SNT20-M",
  "MUNICIPALITY OF SAINT-ANSELME": "SNT21-M",
  "MUNICIPALITY OF SAINT-ANTOINE-DE-TILLY": "SNT22-M",
  "MUNICIPALITY OF SAINT-ANTOINE-SUR-RICHELIEU": "SNT23-M",
  "MUNICIPALITY OF SAINT-ANTONIN": "SNT24-M",
  "MUNICIPALITY OF SAINT-APOLLINAIRE": "SNT25-M",
  "MUNICIPALITY OF SAINT-ARMAND": "SNTR-M",
  "MUNICIPALITY OF SAINT-ATHANASE": "SNTT-M",
  "MUNICIPALITY OF SAINT-AUBERT": "SNT26-M",
  "MUNICIPALITY OF SAINT-AUGUSTIN": "SNT27-M",
  "MUNICIPALITY OF SAINT-BARNABÉ-SUD": "SNT28-M",
  "MUNICIPALITY OF SAINT-BENJAMIN": "SNT29-M",
  "MUNICIPALITY OF SAINT-BENOÎT-DU-LAC": "SNT30-M",
  "MUNICIPALITY OF SAINT-BENOÎT-LABRE": "SNT31-M",
  "MUNICIPALITY OF SAINT-BERNARD": "SNT32-M",
  "MUNICIPALITY OF SAINT-BERNARD-DE-LACOLLE": "SNT33-M",
  "MUNICIPALITY OF SAINT-BERNARD-DE-MICHAUDVILLE": "SNT34-M",
  "MUNICIPALITY OF SAINT-BLAISE-SUR-RICHELIEU": "SNT35-M",
  "MUNICIPALITY OF SAINT-BONAVENTURE": "SNT36-M",
  "MUNICIPALITY OF SAINT-BONIFACE": "SNT37-M",
  "MUNICIPALITY OF SAINT-BRUNO": "SNT38-M",
  "MUNICIPALITY OF SAINT-BRUNO-DE-GUIGUES": "SNT39-M",
  "MUNICIPALITY OF SAINT-BRUNO-DE-KAMOURASKA": "SNT40-M",
  "MUNICIPALITY OF SAINT-CALIXTE": "SNTC-M",
  "MUNICIPALITY OF SAINT-CASIMIR": "SNT41-M",
  "MUNICIPALITY OF SAINT-CÉLESTIN": "SNT42-M",
  "MUNICIPALITY OF SAINT-CHARLES-BORROMÉE": "SNT43-M",
  "MUNICIPALITY OF SAINT-CHARLES-DE-BELLECHASSE": "SNT44-M",
  "MUNICIPALITY OF SAINT-CHARLES-DE-BOURGET": "SNT45-M",
  "MUNICIPALITY OF SAINT-CHARLES-SUR-RICHELIEU": "SNT46-M",
  "MUNICIPALITY OF SAINT-CHRYSOSTOME": "SNT47-M",
  "MUNICIPALITY OF SAINT-CLAUDE": "SNT48-M",
  "MUNICIPALITY OF SAINT-CLÉMENT": "SNT49-M",
  "MUNICIPALITY OF SAINT-CLÉOPHAS-DE-BRANDON": "SNT50-M",
  "MUNICIPALITY OF SAINT-CLET": "SNT51-M",
  "MUNICIPALITY OF SAINT-CÔME": "SNT52-M",
  "MUNICIPALITY OF SAINT-CÔME-LINIÈRE": "SNT53-M",
  "MUNICIPALITY OF SAINT-CUTHBERT": "SNT54-M",
  "MUNICIPALITY OF SAINT-CYPRIEN": "SNT55-M",
  "MUNICIPALITY OF SAINT-CYPRIEN-DE-NAPIERVILLE": "SNT56-M",
  "MUNICIPALITY OF SAINT-CYRILLE-DE-WENDOVER": "SNT57-M",
  "MUNICIPALITY OF SAINT-DAMASE": "SNT58-M",
  "MUNICIPALITY OF SAINT-DAMASE-DE-L'ISLET": "SNT59-M",
  "MUNICIPALITY OF SAINT-DAVID": "SNT60-M",
  "MUNICIPALITY OF SAINT-DAVID-DE-FALARDEAU": "SNT61-M",
  "MUNICIPALITY OF SAINT-DENIS-DE-BROMPTON": "SNT62-M",
  "MUNICIPALITY OF SAINT-DENIS-DE-LA-BOUTEILLERIE": "SNT63-M",
  "MUNICIPALITY OF SAINT-DENIS-SUR-RICHELIEU": "SNT64-M",
  "MUNICIPALITY OF SAINT-DOMINIQUE": "SNT65-M",
  "MUNICIPALITY OF SAINT-DOMINIQUE-DU-ROSAIRE": "SNT66-M",
  "MUNICIPALITY OF SAINT-DONAT": "SNT67-M",
  "MUNICIPALITY OF SAINT-EDMOND-LES-PLAINES": "SNT68-M",
  "MUNICIPALITY OF SAINT-ÉDOUARD": "SNT69-M",
  "MUNICIPALITY OF SAINT-ÉDOUARD-DE-MASKINONGÉ": "SNT70-M",
  "MUNICIPALITY OF SAINT-ÉLIE-DE-CAXTON": "SNT71-M",
  "MUNICIPALITY OF SAINT-ELZÉAR": "SNT72-M",
  "MUNICIPALITY OF SAINT-ELZÉAR-DE-TÉMISCOUATA": "SNT73-M",
  "MUNICIPALITY OF SAINT-ÉMILE-DE-SUFFOLK": "SNT74-M",
  "MUNICIPALITY OF SAINT-ÉPHREM-DE-BEAUCE": "SNT75-M",
  "MUNICIPALITY OF SAINT-ÉPIPHANE": "SNT76-M",
  "MUNICIPALITY OF SAINT-ESPRIT": "SNTS-M",
  "MUNICIPALITY OF SAINT-ÉTIENNE-DE-BEAUHARNOIS": "SNT77-M",
  "MUNICIPALITY OF SAINT-ÉTIENNE-DE-BOLTON": "SNT78-M",
  "MUNICIPALITY OF SAINT-EUGÈNE": "SNT79-M",
  "MUNICIPALITY OF SAINT-EUGÈNE-D'ARGENTENAY": "SNT80-M",
  "MUNICIPALITY OF SAINT-EUGÈNE-DE-GUIGUES": "SNT81-M",
  "MUNICIPALITY OF SAINT-ÉVARISTE-DE-FORSYTH": "SNTV-M",
  "MUNICIPALITY OF SAINT-FAUSTIN--LAC-CARRÉ": "SNTF-M",
  "MUNICIPALITY OF SAINT-FÉLIX-D'OTIS": "SNT82-M",
  "MUNICIPALITY OF SAINT-FÉLIX-DE-DALQUIER": "SNT83-M",
  "MUNICIPALITY OF SAINT-FÉLIX-DE-KINGSEY": "SNT84-M",
  "MUNICIPALITY OF SAINT-FÉLIX-DE-VALOIS": "SNT85-M",
  "MUNICIPALITY OF SAINT-FERDINAND": "SNT86-M",
  "MUNICIPALITY OF SAINT-FERRÉOL-LES-NEIGES": "SNT87-M",
  "MUNICIPALITY OF SAINT-FLAVIEN": "SNT88-M",
  "MUNICIPALITY OF SAINT-FORTUNAT": "SNT89-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-D'ASSISE": "SNT90-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DAVIER-DE-BROMPTON": "SNT91-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DAVIER-DE-VIGER": "SNT92-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DE-L'ÎLE-D'ORLÉANS": "SNT93-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DE-LA-RIVIÈRE-DU-SUD": "SNT94-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DE-SALES": "SNT95-M",
  "MUNICIPALITY OF SAINT-FRANÇOIS-DU-LAC": "SNT96-M",
  "MUNICIPALITY OF SAINT-FULGENCE": "SNT97-M",
  "MUNICIPALITY OF SAINT-GABRIEL-DE-BRANDON": "SNT98-M",
  "MUNICIPALITY OF SAINT-GABRIEL-DE-RIMOUSKI": "SNT99-M",
  "MUNICIPALITY OF SAINT-GABRIEL-DE-VALCARTIER": "SNT100-M",
  "MUNICIPALITY OF SAINT-GABRIEL-LALEMANT": "SNT101-M",
  "MUNICIPALITY OF SAINT-GÉDÉON": "SNT102-M",
  "MUNICIPALITY OF SAINT-GÉDÉON-DE-BEAUCE": "SNT103-M",
  "MUNICIPALITY OF SAINT-GEORGES-DE-CLARENCEVILLE": "SNT104-M",
  "MUNICIPALITY OF SAINT-GEORGES-DE-WINDSOR": "SNT105-M",
  "MUNICIPALITY OF SAINT-GERMAIN-DE-GRANTHAM": "SNT106-M",
  "MUNICIPALITY OF SAINT-GERVAIS": "SNT107-M",
  "MUNICIPALITY OF SAINT-GILLES": "SNT108-M",
  "MUNICIPALITY OF SAINT-GUILLAUME": "SNT109-M",
  "MUNICIPALITY OF SAINT-GUY": "SNT110-M",
  "MUNICIPALITY OF SAINT-HENRI": "SNT111-M",
  "MUNICIPALITY OF SAINT-HENRI-DE-TAILLON": "SNT112-M",
  "MUNICIPALITY OF SAINT-HERMÉNÉGILDE": "SNT113-M",
  "MUNICIPALITY OF SAINT-HIPPOLYTE": "SNT114-M",
  "MUNICIPALITY OF SAINT-HONORÉ-DE-SHENLEY": "SNT115-M",
  "MUNICIPALITY OF SAINT-HONORÉ-DE-TÉMISCOUATA": "SNT116-M",
  "MUNICIPALITY OF SAINT-HUBERT-DE-RIVIÈRE-DU-LOUP": "SNT117-M",
  "MUNICIPALITY OF SAINT-HUGUES": "SNT118-M",
  "MUNICIPALITY OF SAINT-IGNACE-DE-LOYOLA": "SNT119-M",
  "MUNICIPALITY OF SAINT-IGNACE-DE-STANBRIDGE": "SNT120-M",
  "MUNICIPALITY OF SAINT-ISIDORE": "SNT121-M",
  "MUNICIPALITY OF SAINT-ISIDORE-DE-CLIFTON": "SNT122-M",
  "MUNICIPALITY OF SAINT-JACQUES": "SNTJ-M",
  "MUNICIPALITY OF SAINT-JACQUES-DE-LEEDS": "SNT123-M",
  "MUNICIPALITY OF SAINT-JACQUES-LE-MINEUR": "SNT124-M",
  "MUNICIPALITY OF SAINT-JANVIER-DE-JOLY": "SNT125-M",
  "MUNICIPALITY OF SAINT-JEAN-BAPTISTE": "SNT126-M",
  "MUNICIPALITY OF SAINT-JEAN-DE-BRÉBEUF": "SNT127-M",
  "MUNICIPALITY OF SAINT-JEAN-DE-DIEU": "SNT128-M",
  "MUNICIPALITY OF SAINT-JEAN-DE-L'ÎLE-D'ORLÉANS": "SNT129-M",
  "MUNICIPALITY OF SAINT-JEAN-DE-LA-LANDE": "SNT130-M",
  "MUNICIPALITY OF SAINT-JEAN-DE-MATHA": "SNT131-M",
  "MUNICIPALITY OF SAINT-JEAN-PORT-JOLI": "SNT132-M",
  "MUNICIPALITY OF SAINT-JOACHIM-DE-SHEFFORD": "SNT133-M",
  "MUNICIPALITY OF SAINT-JOSEPH-DE-COLERAINE": "SNT134-M",
  "MUNICIPALITY OF SAINT-JOSEPH-DES-ÉRABLES": "SNT135-M",
  "MUNICIPALITY OF SAINT-JOSEPH-DU-LAC": "SNT136-M",
  "MUNICIPALITY OF SAINT-JUDE": "SNT137-M",
  "MUNICIPALITY OF SAINT-JULIEN": "SNT138-M",
  "MUNICIPALITY OF SAINT-JUST-DE-BRETENIÈRES": "SNT139-M",
  "MUNICIPALITY OF SAINT-JUSTE-DU-LAC": "SNT140-M",
  "MUNICIPALITY OF SAINT-JUSTIN": "SNT141-M",
  "MUNICIPALITY OF SAINT-LAMBERT-DE-LAUZON": "SNT142-M",
  "MUNICIPALITY OF SAINT-LAURENT-DE-L'ÎLE-D'ORLÉANS": "SNT143-M",
  "MUNICIPALITY OF SAINT-LAZARE-DE-BELLECHASSE": "SNT144-M",
  "MUNICIPALITY OF SAINT-LÉONARD-D'ASTON": "SNT145-M",
  "MUNICIPALITY OF SAINT-LÉONARD-DE-PORTNEUF": "SNT146-M",
  "MUNICIPALITY OF SAINT-LIBOIRE": "SNT147-M",
  "MUNICIPALITY OF SAINT-LIGUORI": "SNT148-M",
  "MUNICIPALITY OF SAINT-LOUIS": "SNT149-M",
  "MUNICIPALITY OF SAINT-LOUIS-DE-BLANDFORD": "SNT150-M",
  "MUNICIPALITY OF SAINT-LOUIS-DE-GONZAGUE": "SNT151-M",
  "MUNICIPALITY OF SAINT-LUC-DE-BELLECHASSE": "SNT152-M",
  "MUNICIPALITY OF SAINT-LUC-DE-VINCENNES": "SNT153-M",
  "MUNICIPALITY OF SAINT-LUCIEN": "SNT154-M",
  "MUNICIPALITY OF SAINT-LUDGER": "SNT155-M",
  "MUNICIPALITY OF SAINT-LUDGER-DE-MILOT": "SNT156-M",
  "MUNICIPALITY OF SAINT-MAGLOIRE": "SNT157-M",
  "MUNICIPALITY OF SAINT-MALO": "SNT158-M",
  "MUNICIPALITY OF SAINT-MARC-SUR-RICHELIEU": "SNT159-M",
  "MUNICIPALITY OF SAINT-MARCEL": "SNT160-M",
  "MUNICIPALITY OF SAINT-MARCEL-DE-RICHELIEU": "SNT161-M",
  "MUNICIPALITY OF SAINT-MATHIAS-SUR-RICHELIEU": "SNT162-M",
  "MUNICIPALITY OF SAINT-MATHIEU": "SNT163-M",
  "MUNICIPALITY OF SAINT-MATHIEU-D'HARRICANA": "SNT164-M",
  "MUNICIPALITY OF SAINT-MATHIEU-DE-BELOEIL": "SNT165-M",
  "MUNICIPALITY OF SAINT-MATHIEU-DU-PARC": "SNT166-M",
  "MUNICIPALITY OF SAINT-MAXIME-DU-MONT-LOUIS": "SNT167-M",
  "MUNICIPALITY OF SAINT-MÉDARD": "SNT168-M",
  "MUNICIPALITY OF SAINT-MICHEL": "SNT169-M",
  "MUNICIPALITY OF SAINT-MICHEL-DE-BELLECHASSE": "SNT170-M",
  "MUNICIPALITY OF SAINT-MICHEL-DES-SAINTS": "SNT171-M",
  "MUNICIPALITY OF SAINT-MICHEL-DU-SQUATEC": "SNT172-M",
  "MUNICIPALITY OF SAINT-MODESTE": "SNT173-M",
  "MUNICIPALITY OF SAINT-NAZAIRE": "SNT174-M",
  "MUNICIPALITY OF SAINT-NÉRÉE-DE-BELLECHASSE": "SNT175-M",
  "MUNICIPALITY OF SAINT-NORBERT-D'ARTHABASKA": "SNT176-M",
  "MUNICIPALITY OF SAINT-OMER": "SNT177-M",
  "MUNICIPALITY OF SAINT-ONÉSIME-D'IXWORTH": "SNT178-M",
  "MUNICIPALITY OF SAINT-PACÔME": "SNT179-M",
  "MUNICIPALITY OF SAINT-PATRICE-DE-BEAURIVAGE": "SNT180-M",
  "MUNICIPALITY OF SAINT-PATRICE-DE-SHERRINGTON": "SNT181-M",
  "MUNICIPALITY OF SAINT-PAUL": "SNT182-M",
  "MUNICIPALITY OF SAINT-PAUL-D'ABBOTSFORD": "SNT183-M",
  "MUNICIPALITY OF SAINT-PAUL-DE-L'ÎLE-AUX-NOIX": "SNT184-M",
  "MUNICIPALITY OF SAINT-PAUL-DE-MONTMINY": "SNT185-M",
  "MUNICIPALITY OF SAINT-PAULIN": "SNT186-M",
  "MUNICIPALITY OF SAINT-PHILIBERT": "SNT187-M",
  "MUNICIPALITY OF SAINT-PIERRE-DE-BROUGHTON": "SNT188-M",
  "MUNICIPALITY OF SAINT-PIERRE-DE-L'ÎLE-D'ORLÉANS": "SNT189-M",
  "MUNICIPALITY OF SAINT-PIERRE-DE-LAMY": "SNT190-M",
  "MUNICIPALITY OF SAINT-PIERRE-LES-BECQUETS": "SNT191-M",
  "MUNICIPALITY OF SAINT-PLACIDE": "SNT192-M",
  "MUNICIPALITY OF SAINT-POLYCARPE": "SNT193-M",
  "MUNICIPALITY OF SAINT-PRIME": "SNT194-M",
  "MUNICIPALITY OF SAINT-PROSPER": "SNT195-M",
  "MUNICIPALITY OF SAINT-PROSPER-DE-CHAMPLAIN": "SNT196-M",
  "MUNICIPALITY OF SAINT-RAPHAËL": "SNT197-M",
  "MUNICIPALITY OF SAINT-RÉMI-DE-TINGWICK": "SNT198-M",
  "MUNICIPALITY OF SAINT-RENÉ-DE-MATANE": "SNT199-M",
  "MUNICIPALITY OF SAINT-ROBERT": "SNT200-M",
  "MUNICIPALITY OF SAINT-ROBERT-BELLARMIN": "SNT201-M",
  "MUNICIPALITY OF SAINT-ROCH-DE-L'ACHIGAN": "SNT202-M",
  "MUNICIPALITY OF SAINT-ROCH-DE-RICHELIEU": "SNT203-M",
  "MUNICIPALITY OF SAINT-ROCH-OUEST": "SNT204-M",
  "MUNICIPALITY OF SAINT-ROMAIN": "SNT205-M",
  "MUNICIPALITY OF SAINT-SAMUEL": "SNT206-M",
  "MUNICIPALITY OF SAINT-SÉBASTIEN": "SNT207-M",
  "MUNICIPALITY OF SAINT-SIMÉON": "SNT208-M",
  "MUNICIPALITY OF SAINT-SIMON": "SNT209-M",
  "MUNICIPALITY OF SAINT-SIMON-LES-MINES": "SNT210-M",
  "MUNICIPALITY OF SAINT-SIXTE": "SNT211-M",
  "MUNICIPALITY OF SAINT-STANISLAS": "SNT212-M",
  "MUNICIPALITY OF SAINT-STANISLAS-DE-KOSTKA": "SNT213-M",
  "MUNICIPALITY OF SAINT-SYLVÈRE": "SNT214-M",
  "MUNICIPALITY OF SAINT-SYLVESTRE": "SNT215-M",
  "MUNICIPALITY OF SAINT-TÉLESPHORE": "SNT216-M",
  "MUNICIPALITY OF SAINT-THÉODORE-D'ACTON": "SNT217-M",
  "MUNICIPALITY OF SAINT-THÉOPHILE": "SNT218-M",
  "MUNICIPALITY OF SAINT-THOMAS": "SNT219-M",
  "MUNICIPALITY OF SAINT-THOMAS-DIDYME": "SNT220-M",
  "MUNICIPALITY OF SAINT-TITE-DES-CAPS": "SNT221-M",
  "MUNICIPALITY OF SAINT-UBALDE": "SNT222-M",
  "MUNICIPALITY OF SAINT-ULRIC": "SNT223-M",
  "MUNICIPALITY OF SAINT-URBAIN-PREMIER": "SNT224-M",
  "MUNICIPALITY OF SAINT-VALENTIN": "SNT225-M",
  "MUNICIPALITY OF SAINT-VALÈRE": "SNT226-M",
  "MUNICIPALITY OF SAINT-VALÉRIEN-DE-MILTON": "SNT227-M",
  "MUNICIPALITY OF SAINT-VALLIER": "SNT228-M",
  "MUNICIPALITY OF SAINT-VENANT-DE-PAQUETTE": "SNT229-M",
  "MUNICIPALITY OF SAINT-VIANNEY": "SNT230-M",
  "MUNICIPALITY OF SAINT-VICTOR": "SNT231-M",
  "MUNICIPALITY OF SAINT-WENCESLAS": "SNTW-M",
  "MUNICIPALITY OF SAINT-ZACHARIE": "SNTZ-M",
  "MUNICIPALITY OF SAINT-ZÉNON": "SNT232-M",
  "MUNICIPALITY OF SAINT-ZOTIQUE": "SNT233-M",
  "MUNICIPALITY OF SAINTE-AGATHE-DE-LOTBINIÈRE": "SNT234-M",
  "MUNICIPALITY OF SAINTE-ANGÈLE-DE-MÉRICI": "SNT235-M",
  "MUNICIPALITY OF SAINTE-ANGÈLE-DE-MONNOIR": "SNT236-M",
  "MUNICIPALITY OF SAINTE-ANGÈLE-DE-PRÉMONT": "SNT237-M",
  "MUNICIPALITY OF SAINTE-ANNE-DE-LA-PÉRADE": "SNT238-M",
  "MUNICIPALITY OF SAINTE-ANNE-DE-LA-ROCHELLE": "SNT239-M",
  "MUNICIPALITY OF SAINTE-ANNE-DE-SOREL": "SNT240-M",
  "MUNICIPALITY OF SAINTE-ANNE-DU-LAC": "SNT241-M",
  "MUNICIPALITY OF SAINTE-ANNE-DU-SAULT": "SNT242-M",
  "MUNICIPALITY OF SAINTE-AURÉLIE": "SNT243-M",
  "MUNICIPALITY OF SAINTE-BARBE": "SNT244-M",
  "MUNICIPALITY OF SAINTE-BÉATRIX": "SNT245-M",
  "MUNICIPALITY OF SAINTE-BRIGIDE-D'IBERVILLE": "SNT246-M",
  "MUNICIPALITY OF SAINTE-CATHERINE-DE-HATLEY": "SNT247-M",
  "MUNICIPALITY OF SAINTE-CÉCILE-DE-MILTON": "SNT248-M",
  "MUNICIPALITY OF SAINTE-CÉCILE-DE-WHITTON": "SNT249-M",
  "MUNICIPALITY OF SAINTE-CHRISTINE-D'AUVERGNE": "SNT250-M",
  "MUNICIPALITY OF SAINTE-CLAIRE": "SNT251-M",
  "MUNICIPALITY OF SAINTE-CLOTILDE": "SNT252-M",
  "MUNICIPALITY OF SAINTE-CLOTILDE-DE-BEAUCE": "SNT253-M",
  "MUNICIPALITY OF SAINTE-CLOTILDE-DE-HORTON": "SNT254-M",
  "MUNICIPALITY OF SAINTE-CROIX": "SNT255-M",
  "MUNICIPALITY OF SAINTE-ÉLISABETH": "SNT256-M",
  "MUNICIPALITY OF SAINTE-ÉLIZABETH-DE-WARWICK": "SNT257-M",
  "MUNICIPALITY OF SAINTE-ÉMÉLIE-DE-L'ÉNERGIE": "SNT258-M",
  "MUNICIPALITY OF SAINTE-EULALIE": "SNT259-M",
  "MUNICIPALITY OF SAINTE-EUPHÉMIE-SUR-RIVIÈRE-DU-SUD": "SNT260-M",
  "MUNICIPALITY OF SAINTE-FAMILLE-DE-L'ÎLE-D'ORLÉANS": "SNT261-M",
  "MUNICIPALITY OF SAINTE-FÉLICITÉ": "SNT262-M",
  "MUNICIPALITY OF SAINTE-FLORENCE": "SNT263-M",
  "MUNICIPALITY OF SAINTE-GENEVIÈVE-DE-BERTHIER": "SNT264-M",
  "MUNICIPALITY OF SAINTE-GERMAINE-BOULÉ": "SNT265-M",
  "MUNICIPALITY OF SAINTE-GERTRUDE-MANNEVILLE": "SNT266-M",
  "MUNICIPALITY OF SAINTE-HEDWIDGE": "SNT267-M",
  "MUNICIPALITY OF SAINTE-HÉLÈNE-DE KAMOURASKA": "SNT268-M",
  "MUNICIPALITY OF SAINTE-HÉLÈNE-DE-BAGOT": "SNT269-M",
  "MUNICIPALITY OF SAINTE-HÉLÈNE-DE-CHESTER": "SNT270-M",
  "MUNICIPALITY OF SAINTE-JULIENNE": "SNT271-M",
  "MUNICIPALITY OF SAINTE-JUSTINE": "SNT272-M",
  "MUNICIPALITY OF SAINTE-JUSTINE-DE-NEWTON": "SNT273-M",
  "MUNICIPALITY OF SAINTE-LUCE": "SNT274-M",
  "MUNICIPALITY OF SAINTE-LUCIE-DE-BEAUREGARD": "SNT275-M",
  "MUNICIPALITY OF SAINTE-LUCIE-DES-LAURENTIDES": "SNT276-M",
  "MUNICIPALITY OF SAINTE-MADELEINE-DE-LA-RIVIÈRE-MADELEINE": "SNT277-M",
  "MUNICIPALITY OF SAINTE-MARCELLINE-DE-KILDARE": "SNT278-M",
  "MUNICIPALITY OF SAINTE-MARGUERITE-MARIE": "SNT279-M",
  "MUNICIPALITY OF SAINTE-MARIE-DE-BLANDFORD": "SNT280-M",
  "MUNICIPALITY OF SAINTE-MARIE-SALOMÉ": "SNT281-M",
  "MUNICIPALITY OF SAINTE-MARTHE": "SNT282-M",
  "MUNICIPALITY OF SAINTE-MARTINE": "SNT283-M",
  "MUNICIPALITY OF SAINTE-MÉLANIE": "SNT284-M",
  "MUNICIPALITY OF SAINTE-MONIQUE": "SNT285-M",
  "MUNICIPALITY OF SAINTE-PAULE": "SNT286-M",
  "MUNICIPALITY OF SAINTE-PERPÉTUE": "SNT287-M",
  "MUNICIPALITY OF SAINTE-RITA": "SNT288-M",
  "MUNICIPALITY OF SAINTE-ROSE-DE-WATFORD": "SNT289-M",
  "MUNICIPALITY OF SAINTE-SABINE": "SNT290-M",
  "MUNICIPALITY OF SAINTE-SOPHIE": "SNT291-M",
  "MUNICIPALITY OF SAINTE-SOPHIE-D'HALIFAX": "SNT292-M",
  "MUNICIPALITY OF SAINTE-THÈCLE": "SNT293-M",
  "MUNICIPALITY OF SAINTE-THÉRÈSE-DE-GASPÉ": "SNT294-M",
  "MUNICIPALITY OF SAINTE-THÉRÈSE-DE-LA-GATINEAU": "SNT295-M",
  "MUNICIPALITY OF SAINTE-URSULE": "SNT296-M",
  "MUNICIPALITY OF SAINTE-VICTOIRE-DE-SOREL": "SNT297-M",
  "MUNICIPALITY OF SAYABEC": "SYBC-M",
  "MUNICIPALITY OF SCOTT": "SCTT-M",
  "MUNICIPALITY OF SHAWVILLE": "SHWV-M",
  "MUNICIPALITY OF SHEENBORO": "SHNB-M",
  "MUNICIPALITY OF SHIGAWAKE": "SHGW-M",
  "MUNICIPALITY OF STANBRIDGE EAST": "STNB-M",
  "MUNICIPALITY OF STANBRIDGE STATION": "STN1-M",
  "MUNICIPALITY OF STANSTEAD-EST": "STNS-M",
  "MUNICIPALITY OF STOKE": "STK-M",
  "MUNICIPALITY OF STORNOWAY": "STRN-M",
  "MUNICIPALITY OF TASCHEREAU": "TSCH-M",
  "MUNICIPALITY OF TERRASSE-VAUDREUIL": "TRRS-M",
  "MUNICIPALITY OF THORNE": "THRN-M",
  "MUNICIPALITY OF TINGWICK": "TNGW-M",
  "MUNICIPALITY OF TOURVILLE": "TRVL-M",
  "MUNICIPALITY OF TRÈS-SAINT-RÉDEMPTEUR": "TRSS-M",
  "MUNICIPALITY OF TROIS-RIVES": "TRSR-M",
  "MUNICIPALITY OF ULVERTON": "ULVR-M",
  "MUNICIPALITY OF UPTON": "UPTN-M",
  "MUNICIPALITY OF VAL-ALAIN": "VLLN-M",
  "MUNICIPALITY OF VAL-BRILLANT": "VLBR-M",
  "MUNICIPALITY OF VAL-DES-BOIS": "VLDS-M",
  "MUNICIPALITY OF VAL-DES-LACS": "VLD1-M",
  "MUNICIPALITY OF VAL-DES-MONTS": "VLD2-M",
  "MUNICIPALITY OF VAL-JOLI": "VLJL-M",
  "MUNICIPALITY OF VAL-MORIN": "VLMR-M",
  "MUNICIPALITY OF VAL-RACINE": "VLRC-M",
  "MUNICIPALITY OF VAL-SAINT-GILLES": "VLSN-M",
  "MUNICIPALITY OF VALLÉE-JONCTION": "VLLJ-M",
  "MUNICIPALITY OF VENISE-EN-QUÉBEC": "VNSN-M",
  "MUNICIPALITY OF VERCHÈRES": "VRCH-M",
  "MUNICIPALITY OF VILLEROY": "VLLR-M",
  "MUNICIPALITY OF WALTHAM": "WLTH-M",
  "MUNICIPALITY OF WEEDON": "WDN-M",
  "MUNICIPALITY OF WENTWORTH-NORD": "WNTW-M",
  "MUNICIPALITY OF WICKHAM": "WCKH-M",
  "MUNICIPALITY OF WOTTON": "WTTN-M",
  "MUNICIPALITY OF YAMACHICHE": "YMCH-M",
  "MUNICIPALITY OF YAMASKA": "YMSK-M",
  "PARISH OF SAINT-JACQUES-LE-MAJEUR-DE-WOLFESTOWN": "SNT338-P",
  "RESORT COUNTY MUNICIPALITY ABITIBI": "ABTB-RC",
  "RESORT COUNTY MUNICIPALITY ABITIBI-OUEST": "ACTN-RC",
  "RESORT COUNTY MUNICIPALITY ACTON": "ANTL-RC",
  "RESORT COUNTY MUNICIPALITY ANTOINE-LABELLE": "ARGT-Rc",
  "RESORT COUNTY MUNICIPALITY ARGENTEUIL": "ARTB-RC",
  "RESORT COUNTY MUNICIPALITY ARTHABASKA": "AVGN-RC",
  "RESORT COUNTY MUNICIPALITY AVIGNON": "BCST-RC",
  "RESORT COUNTY MUNICIPALITY BEAUCE-SARTIGAN": "BHRN-RC",
  "RESORT COUNTY MUNICIPALITY BEAUHARNOIS-SALABERRY": "BHSB-RC",
  "RESORT COUNTY MUNICIPALITY BÉCANCOUR": "BCNC-RC",
  "RESORT COUNTY MUNICIPALITY BELLECHASSE": "BLCS-RC",
  "RESORT COUNTY MUNICIPALITY BONAVENTURE": "BNVT-RC",
  "RESORT COUNTY MUNICIPALITY BROME-MISSISQUOI": "BRMM-RC",
  "RESORT COUNTY MUNICIPALITY CANIAPISCAU": "CNPC-RC",
  "RESORT COUNTY MUNICIPALITY CHARLEVOIX": "CHLX-RC",
  "RESORT COUNTY MUNICIPALITY CHARLEVOIX-EST": "CHLV-RC",
  "RESORT COUNTY MUNICIPALITY COATICOOK": "CTCK-RC",
  "RESORT COUNTY MUNICIPALITY D'AUTRAY": "DATR-RC",
  "RESORT COUNTY MUNICIPALITY DEUX-MONTAGNES": "DMTG-RC",
  "RESORT COUNTY MUNICIPALITY DRUMMOND": "DRMM-RC",
  "RESORT COUNTY MUNICIPALITY JOLIETTE": "JLTT-RC",
  "RESORT COUNTY MUNICIPALITY KAMOURASKA": "KMRS-RC",
  "RESORT COUNTY MUNICIPALITY L'ASSOMPTION": "LSSP-RC",
  "RESORT COUNTY MUNICIPALITY L'ÉRABLE": "LRBL-RC",
  "RESORT COUNTY MUNICIPALITY L'ÎLE-D'ORLÉANS": "LDOR-RC",
  "RESORT COUNTY MUNICIPALITY L'ISLET": "LISL-RC",
  "RESORT COUNTY MUNICIPALITY LA CÔTE-DE-BEAUPRÉ": "LCDB-RC",
  "RESORT COUNTY MUNICIPALITY LA CÔTE-DE-GASPÉ": "LCDG-RC",
  "RESORT COUNTY MUNICIPALITY LA HAUTE-CÔTE-NORD": "LHCN-RC",
  "RESORT COUNTY MUNICIPALITY LA HAUTE-GASPÉSIE": "LHGS-RC",
  "RESORT COUNTY MUNICIPALITY LA HAUTE-YAMASKA": "LHYM-RC",
  "RESORT COUNTY MUNICIPALITY LA JACQUES-CARTIER": "LJQC-RC",
  "RESORT COUNTY MUNICIPALITY LA MATANIE": "LMTN-RC",
  "RESORT COUNTY MUNICIPALITY LA MATAPÉDIA": "LMTA-RC",
  "RESORT COUNTY MUNICIPALITY LA MITIS": "LMTS-RC",
  "RESORT COUNTY MUNICIPALITY LA NOUVELLE-BEAUCE": "LNVB-RC",
  "RESORT COUNTY MUNICIPALITY LA RIVIÈRE-DU-NORD": "LRDN-RC",
  "RESORT COUNTY MUNICIPALITY LA VALLÉE-DE-L'OR": "LVDL-RC",
  "RESORT COUNTY MUNICIPALITY LA VALLÉE-DE-LA-GATINEAU": "LVDG-RC",
  "RESORT COUNTY MUNICIPALITY LA VALLÉE-DU-RICHELIEU": "LVDR-RC",
  "RESORT COUNTY MUNICIPALITY LAC-SAINT-JEAN-EST": "LSJE-RC",
  "RESORT COUNTY MUNICIPALITY LE DOMAINE-DU-ROY": "LDDR-RC",
  "RESORT COUNTY MUNICIPALITY LE FJORD-DU-SAGUENAY": "LJDS-RC",
  "RESORT COUNTY MUNICIPALITY LE GOLFE-DU-SAINT-LAURENT": "LGSL-RC",
  "RESORT COUNTY MUNICIPALITY LE GRANIT": "LGRT-RC",
  "RESORT COUNTY MUNICIPALITY LE HAUT-RICHELIEU": "LHRC-RC",
  "RESORT COUNTY MUNICIPALITY LE HAUT-SAINT-FRANÇOIS": "LHSF-RC",
  "RESORT COUNTY MUNICIPALITY LE HAUT-SAINT-LAURENT": "LHSL-RC",
  "RESORT COUNTY MUNICIPALITY LE ROCHER-PERCÉ": "LRPR-RC",
  "RESORT COUNTY MUNICIPALITY LE VAL-SAINT-FRANÇOIS": "LVSF-RC",
  "RESORT COUNTY MUNICIPALITY LES APPALACHES": "LAPP-RC",
  "RESORT COUNTY MUNICIPALITY LES BASQUES": "LBAS-RC",
  "RESORT COUNTY MUNICIPALITY LES CHENAUX": "LCHN-RC",
  "RESORT COUNTY MUNICIPALITY LES COLLINES-DE-L'OUTAOUAIS": "LCLL-RC",
  "RESORT COUNTY MUNICIPALITY LES ETCHEMINS": "LETC-RC",
  "RESORT COUNTY MUNICIPALITY LES JARDINS-DE-NAPIERVILLE": "LJDE-RC",
  "RESORT COUNTY MUNICIPALITY LES LAURENTIDES": "LLRD-RC",
  "RESORT COUNTY MUNICIPALITY LES MASKOUTAINS": "LMKT-RC",
  "RESORT COUNTY MUNICIPALITY LES MOULINS": "LMNS-RC",
  "RESORT COUNTY MUNICIPALITY LES PAYS-D'EN-HAUT": "LPDN-RC",
  "RESORT COUNTY MUNICIPALITY LES SOURCES": "LSRC-RC",
  "RESORT COUNTY MUNICIPALITY LOTBINIÈRE": "LTBN-RC",
  "RESORT COUNTY MUNICIPALITY MANICOUAGAN": "MNCG-RC",
  "RESORT COUNTY MUNICIPALITY MARGUERITE-D'YOUVILLE": "MGDY-RC",
  "RESORT COUNTY MUNICIPALITY MARIA-CHAPDELAINE": "MCPD-RC",
  "RESORT COUNTY MUNICIPALITY MASKINONGÉ": "MSKN-RG",
  "RESORT COUNTY MUNICIPALITY MATAWINIE": "MTWN-RG",
  "RESORT COUNTY MUNICIPALITY MÉKINAC": "MKNC-RG",
  "RESORT COUNTY MUNICIPALITY MEMPHRÉMAGOG": "MMPM-RG",
  "RESORT COUNTY MUNICIPALITY MINGANIE": "MNGN-RG",
  "RESORT COUNTY MUNICIPALITY MONTCALM": "MNTL-RG",
  "RESORT COUNTY MUNICIPALITY MONTMAGNY": "MTMG-RG",
  "RESORT COUNTY MUNICIPALITY NICOLET-YAMASKA": "NCYM-RG",
  "RESORT COUNTY MUNICIPALITY PAPINEAU": "PPNU-RG",
  "RESORT COUNTY MUNICIPALITY PIERRE-DE SAUREL": "PDSR-RG",
  "RESORT COUNTY MUNICIPALITY PONTIAC": "PNTC-RG",
  "RESORT COUNTY MUNICIPALITY PORTNEUF": "PNTF-RG",
  "RESORT COUNTY MUNICIPALITY RIMOUSKI-NEIGETTE": "RMNG-RG",
  "RESORT COUNTY MUNICIPALITY RIVIÈRE-DU-LOUP": "RVDL-RG",
  "RESORT COUNTY MUNICIPALITY ROBERT-CLICHE": "RBCL-RG",
  "RESORT COUNTY MUNICIPALITY ROUSSILLON": "RSSL-RG",
  "RESORT COUNTY MUNICIPALITY ROUVILLE": "RVLL-RG",
  "RESORT COUNTY MUNICIPALITY SEPT-RIVIÈRES": "SPRV-RG",
  "RESORT COUNTY MUNICIPALITY TÉMISCAMINGUE": "TMSC-RG",
  "RESORT COUNTY MUNICIPALITY TÉMISCOUATA": "TMST-RC",
  "RESORT COUNTY MUNICIPALITY THÉRÈSE-DE BLAINVILLE": "THDB-RC",
  "RESORT COUNTY MUNICIPALITY VAUDREUIL-SOULANGES": "VDSL-RC",
  "TOWN OF ACTON VALE": "ACTN-T",
  "TOWN OF ALMA": "ALM-T",
  "TOWN OF AMOS": "AMS-T",
  "TOWN OF AMQUI": "AMQ-T",
  "TOWN OF ASBESTOS": "ASBS-T",
  "TOWN OF BAIE-COMEAU": "BCM-T",
  "TOWN OF BAIE-D'URFÉ": "BDRF-T",
  "TOWN OF BAIE-SAINT-PAUL": "BSN1-T",
  "TOWN OF BARKMERE": "BRKM-T",
  "TOWN OF BEACONSFIELD": "BCNS-T",
  "TOWN OF BEAUCEVILLE": "BCVL-T",
  "TOWN OF BEAUHARNOIS": "BHRN-T",
  "TOWN OF BEAUPRÉ": "BPR-T",
  "TOWN OF BÉCANCOUR": "BCNC-T",
  "TOWN OF BEDFORD": "BDFR-T",
  "TOWN OF BELLETERRE": "BLLT-T",
  "TOWN OF BELOEIL": "BLL-T",
  "TOWN OF BERTHIERVILLE": "BRT1-T",
  "TOWN OF BLAINVILLE": "BLNV-T",
  "TOWN OF BOIS-DES-FILION": "BSDS-T",
  "TOWN OF BOISBRIAND": "BSBR-T",
  "TOWN OF BONAVENTURE": "BNVN-T",
  "TOWN OF BOUCHERVILLE": "BCHR-T",
  "TOWN OF BROMONT": "BRMN-T",
  "TOWN OF BROSSARD": "BRSS-T",
  "TOWN OF BROWNSBURG-CHATHAM": "BRWN-T",
  "TOWN OF CANDIAC": "CNDC-T",
  "TOWN OF CAP-CHAT": "CPCH-T",
  "TOWN OF CAP-SANTÉ": "CPS1-T",
  "TOWN OF CARIGNAN": "CRGN-T",
  "TOWN OF CARLETON-SUR-MER": "CRLT-T",
  "TOWN OF CAUSAPSCAL": "CSPS-T",
  "TOWN OF CHAMBLY": "CHM2-T",
  "TOWN OF CHANDLER": "CHND-T",
  "TOWN OF CHAPAIS": "CHPS-T",
  "TOWN OF CHARLEMAGNE": "CHRL-T",
  "TOWN OF CHÂTEAU-RICHER": "CHTR-T",
  "TOWN OF CHÂTEAUGUAY": "CHTG-T",
  "TOWN OF CHIBOUGAMAU": "CHBG-T",
  "TOWN OF CLERMONT": "CLRM-T",
  "TOWN OF COATICOOK": "CTCK-T",
  "TOWN OF CONTRECŒUR": "CNTR-T",
  "TOWN OF COOKSHIRE-EATON": "CKSH-T",
  "TOWN OF CÔTE-SAINT-LUC": "CTSN-T",
  "TOWN OF COTEAU-DU-LAC": "CTDL-T",
  "TOWN OF COWANSVILLE": "CWNS-T",
  "TOWN OF DANVILLE": "DNVL-T",
  "TOWN OF DAVELUYVILLE": "DVLY-T",
  "TOWN OF DÉGELIS": "DGLS-T",
  "TOWN OF DELSON": "DLSN-T",
  "TOWN OF DESBIENS": "DSBN-T",
  "TOWN OF DEUX-MONTAGNES": "DXMN-T",
  "TOWN OF DISRAELI": "DSR1-T",
  "TOWN OF DOLBEAU-MISTASSINI": "DLBM-T",
  "TOWN OF DOLLARD-DES ORMEAUX": "DLLR-T",
  "TOWN OF DONNACONA": "DNNC-T",
  "TOWN OF DORVAL": "DRVL-T",
  "TOWN OF DRUMMONDVILLE": "DRMM-T",
  "TOWN OF DUNHAM": "DNHM-T",
  "TOWN OF DUPARQUET": "DPRQ-T",
  "TOWN OF EAST ANGUS": "ESTN-T",
  "TOWN OF ESTÉREL": "ESTR-T",
  "TOWN OF FARNHAM": "FRNH-T",
  "TOWN OF FERMONT": "FRM1-T",
  "TOWN OF FORESTVILLE": "FRST-T",
  "TOWN OF FOSSAMBAULT-SUR-LE-LAC": "FSSM-T",
  "TOWN OF GASPÉ": "GSP-T",
  "TOWN OF GATINEAU": "GTN-T",
  "TOWN OF GRACEFIELD": "GRCF-T",
  "TOWN OF GRANBY": "GRNB-T",
  "TOWN OF GRANDE-RIVIÈRE": "GRN4-T",
  "TOWN OF HAMPSTEAD": "HMPS-T",
  "TOWN OF HUDSON": "HDSN-T",
  "TOWN OF HUNTINGDON": "HNTN-T",
  "TOWN OF JOLIETTE": "JLTT-T",
  "TOWN OF KINGSEY FALLS": "KNGS-T",
  "TOWN OF KIRKLAND": "KRKL-T",
  "TOWN OF L'ANCIENNE-LORETTE": "LNCN-T",
  "TOWN OF L'ASSOMPTION": "LSSM-T",
  "TOWN OF L'ÉPIPHANIE": "LPPH-T",
  "TOWN OF L'ÎLE-CADIEUX": "LLCD-T",
  "TOWN OF L'ÎLE-DORVAL": "LLDR-T",
  "TOWN OF L'ÎLE-PERROT": "LLPR-T",
  "TOWN OF LA MALBAIE": "LMLB-T",
  "TOWN OF LA POCATIÈRE": "LPCT-T",
  "TOWN OF LA PRAIRIE": "LPRR-T",
  "TOWN OF LA SARRE": "LSRR-T",
  "TOWN OF LA TUQUE": "LTQ-T",
  "TOWN OF LAC-BROME": "LCBR-T",
  "TOWN OF LAC-DELAGE": "LCDL-T",
  "TOWN OF LAC-MÉGANTIC": "LCMG-T",
  "TOWN OF LAC-SAINT-JOSEPH": "LCS3-T",
  "TOWN OF LAC-SERGENT": "LCSR-T",
  "TOWN OF LACHUTE": "LCHT-T",
  "TOWN OF LAVAL": "LVL-T",
  "TOWN OF LAVALTRIE": "LVLT-T",
  "TOWN OF LEBEL-SUR-QUÉVILLON": "LBLS-T",
  "TOWN OF LÉRY": "LRY-T",
  "TOWN OF LONGUEUIL": "LNGL-T",
  "TOWN OF LORRAINE": "LRR1-T",
  "TOWN OF LOUISEVILLE": "LSVL-T",
  "TOWN OF MACAMIC": "MCMC-T",
  "TOWN OF MAGOG": "MGG-T",
  "TOWN OF MALARTIC": "MLRT-T",
  "TOWN OF MANIWAKI": "MNWK-T",
  "TOWN OF MARIEVILLE": "MRVL-T",
  "TOWN OF MASCOUCHE": "MSCC-T",
  "TOWN OF MATAGAMI": "MTGM-T",
  "TOWN OF MATANE": "MTN-T",
  "TOWN OF MERCIER": "MRC1-T",
  "TOWN OF MÉTABETCHOUAN--LAC-À-LA-CROIX": "MTBT-T",
  "TOWN OF MÉTIS-SUR-MER": "MTSS-T",
  "TOWN OF MIRABEL": "MRBL-T",
  "TOWN OF MONT-JOLI": "MNTJ-T",
  "TOWN OF MONT-LAURIER": "MNTL-T",
  "TOWN OF MONT-ROYAL": "MNT6-T",
  "TOWN OF MONT-SAINT-HILAIRE": "MNT7-T",
  "TOWN OF MONT-TREMBLANT": "MNTT-T",
  "TOWN OF MONTMAGNY": "MNTM-T",
  "TOWN OF MURDOCHVILLE": "MRDC-T",
  "TOWN OF NEUVILLE": "NVL1-T",
  "TOWN OF NEW RICHMOND": "NWRC-T",
  "TOWN OF NICOLET": "NCLT-T",
  "TOWN OF NORMANDIN": "NRMN-T",
  "TOWN OF NOTRE-DAME-DE-L'ÎLE-PERROT": "NTR25-T",
  "TOWN OF NOTRE-DAME-DES-PRAIRIES": "NTR26-T",
  "TOWN OF OTTERBURN PARK": "OTT1-T",
  "TOWN OF PASPÉBIAC": "PSPB-T",
  "TOWN OF PERCÉ": "PRC-T",
  "TOWN OF PINCOURT": "PNCR-T",
  "TOWN OF PLESSISVILLE": "PLSS-T",
  "TOWN OF POHÉNÉGAMOOK": "PHNG-T",
  "TOWN OF POINTE-CLAIRE": "PNT2-T",
  "TOWN OF PONT-ROUGE": "PNTR-T",
  "TOWN OF PORT-CARTIER": "PRTC-T",
  "TOWN OF PORTNEUF": "PRT1-T",
  "TOWN OF PRÉVOST": "PRVS-T",
  "TOWN OF PRINCEVILLE": "PRNC-T",
  "TOWN OF QUÉBEC": "QBC-T",
  "TOWN OF REPENTIGNY": "RPNT-T",
  "TOWN OF RICHELIEU": "RCHL-T",
  "TOWN OF RICHMOND": "RCHM-T",
  "TOWN OF RIMOUSKI": "RMSK-T",
  "TOWN OF RIVIÈRE-DU-LOUP": "RVRD-T",
  "TOWN OF RIVIÈRE-ROUGE": "RVRR-T",
  "TOWN OF ROBERVAL": "RBRV-T",
  "TOWN OF ROSEMÈRE": "RSMR-T",
  "TOWN OF ROUYN-NORANDA": "RYNN-T",
  "TOWN OF SAGUENAY": "SGNY-T",
  "TOWN OF SAINT-AUGUSTIN-DE-DESMAURES": "SNT414-T",
  "TOWN OF SAINT-BASILE": "SNT415-T",
  "TOWN OF SAINT-BASILE-LE-GRAND": "SNT416-T",
  "TOWN OF SAINT-BRUNO-DE-MONTARVILLE": "SNT417-T",
  "TOWN OF SAINT-CÉSAIRE": "SNT418-T",
  "TOWN OF SAINT-COLOMBAN": "SNT419-T",
  "TOWN OF SAINT-CONSTANT": "SNT420-T",
  "TOWN OF SAINT-EUSTACHE": "SNT421-T",
  "TOWN OF SAINT-FÉLICIEN": "SNT422-T",
  "TOWN OF SAINT-GABRIEL": "SNT423-T",
  "TOWN OF SAINT-GEORGES": "SNT424-T",
  "TOWN OF SAINT-HYACINTHE": "SNT425-T",
  "TOWN OF SAINT-JEAN-SUR-RICHELIEU": "SNT426-T",
  "TOWN OF SAINT-JÉRÔME": "SNT427-T",
  "TOWN OF SAINT-JOSEPH-DE-BEAUCE": "SNT428-T",
  "TOWN OF SAINT-JOSEPH-DE-SOREL": "SNT429-T",
  "TOWN OF SAINT-LAMBERT": "SNT430-T",
  "TOWN OF SAINT-LAZARE": "SNT431-T",
  "TOWN OF SAINT-LIN--LAURENTIDES": "SNT432-T",
  "TOWN OF SAINT-MARC-DES-CARRIÈRES": "SNT433-T",
  "TOWN OF SAINT-OURS": "SNT434-T",
  "TOWN OF SAINT-PAMPHILE": "SNT435-T",
  "TOWN OF SAINT-PASCAL": "SNT436-T",
  "TOWN OF SAINT-PIE": "SNT437-T",
  "TOWN OF SAINT-RAYMOND": "SNT438-T",
  "TOWN OF SAINT-RÉMI": "SNT439-T",
  "TOWN OF SAINT-SAUVEUR": "SNT440-T",
  "TOWN OF SAINT-TITE": "SNT441-T",
  "TOWN OF SAINTE-ADÈLE": "SNT442-T",
  "TOWN OF SAINTE-AGATHE-DES-MONTS": "SNT443-T",
  "TOWN OF SAINTE-ANNE-DE-BEAUPRÉ": "SNT444-T",
  "TOWN OF SAINTE-ANNE-DE-BELLEVUE": "SNT445-T",
  "TOWN OF SAINTE-ANNE-DES-MONTS": "SNT446-T",
  "TOWN OF SAINTE-ANNE-DES-PLAINES": "SNT447-T",
  "TOWN OF SAINTE-CATHERINE": "SNT448-T",
  "TOWN OF SAINTE-CATHERINE-DE-LA-JACQUES-CARTIER": "SNT449-T",
  "TOWN OF SAINTE-JULIE": "SNT450-T",
  "TOWN OF SAINTE-MARGUERITE-DU-LAC-MASSON": "SNT451-T",
  "TOWN OF SAINTE-MARIE": "SNT452-T",
  "TOWN OF SAINTE-MARTHE-SUR-LE-LAC": "SNT453-T",
  "TOWN OF SAINTE-THÉRÈSE": "SNT454-T",
  "TOWN OF SALABERRY-DE-VALLEYFIELD": "SLBR-T",
  "TOWN OF SCHEFFERVILLE": "SCHF-T",
  "TOWN OF SCOTSTOWN": "SCTS-T",
  "TOWN OF SENNETERRE": "SNN1-T",
  "TOWN OF SEPT-ÎLES": "SPTL-T",
  "TOWN OF SHAWINIGAN": "SHWN-T",
  "TOWN OF SHERBROOKE": "SHRB-T",
  "TOWN OF SOREL-TRACY": "SRLT-T",
  "TOWN OF STANSTEAD": "STN2-T",
  "TOWN OF SUTTON": "STTN-T",
  "TOWN OF TÉMISCAMING": "TMSC-T",
  "TOWN OF TÉMISCOUATA-SUR-LE-LAC": "TMS1-T",
  "TOWN OF TERREBONNE": "TRRB-T",
  "TOWN OF THETFORD MINES": "THTF-T",
  "TOWN OF THURSO": "THRS-T",
  "TOWN OF TROIS-PISTOLES": "TRSP-T",
  "TOWN OF TROIS-RIVIÈRES": "TRS2-T",
  "TOWN OF VAL-D'OR": "VLDR-T",
  "TOWN OF VALCOURT": "VLCR-T",
  "TOWN OF VARENNES": "VRNN-T",
  "TOWN OF VAUDREUIL-DORION": "VDRL-T",
  "TOWN OF VICTORIAVILLE": "VCTR-T",
  "TOWN OF VILLE-MARIE": "VLLM-T",
  "TOWN OF WARWICK": "WRWC-T",
  "TOWN OF WATERLOO": "WTRL-T",
  "TOWN OF WATERVILLE": "WTRV-T",
  "TOWN OF WESTMOUNT": "WSTM-T",
  "TOWN OF WINDSOR": "WNDS-T",
  "TOWNSHIP OF AMHERST": "AMHR-TS",
  "TOWNSHIP OF ARUNDEL": "ARND-TS",
  "TOWNSHIP OF AUMOND": "AMND-TS",
  "TOWNSHIP OF BEDFORD": "BDF1-TS",
  "TOWNSHIP OF CHICHESTER": "CHCH-TS",
  "TOWNSHIP OF CLERMONT": "CLR1-TS",
  "TOWNSHIP OF CLEVELAND": "CLVL-TS",
  "TOWNSHIP OF CLORIDORME": "CLRD-TS",
  "TOWNSHIP OF DUNDEE": "DND-TS",
  "TOWNSHIP OF GODMANCHESTER": "GDMN-TS",
  "TOWNSHIP OF GORE": "GR-TS",
  "TOWNSHIP OF GUÉRIN": "GRN-TS",
  "TOWNSHIP OF HAM-NORD": "HMNR-TS",
  "TOWNSHIP OF HAMPDEN": "HMPD-TS",
  "TOWNSHIP OF HARRINGTON": "HRRN-TS",
  "TOWNSHIP OF HATLEY": "HTL1-TS",
  "TOWNSHIP OF HAVELOCK": "HVLC-TS",
  "TOWNSHIP OF HEMMINGFORD": "HMMN-TS",
  "TOWNSHIP OF HOPE": "HP-TS",
  "TOWNSHIP OF LANDRIENNE": "LNDR-TS",
  "TOWNSHIP OF LAUNAY": "LNY-TS",
  "TOWNSHIP OF LINGWICK": "LNGW-TS",
  "TOWNSHIP OF LOCHABER": "LCHB-TS",
  "TOWNSHIP OF LOCHABER-PARTIE-OUEST": "LCH1-TS",
  "TOWNSHIP OF LOW": "LW-TS",
  "TOWNSHIP OF MARSTON": "MRST-TS",
  "TOWNSHIP OF MELBOURNE": "MLBR-TS",
  "TOWNSHIP OF NÉDÉLEC": "NDLC-TS",
  "TOWNSHIP OF ORFORD": "ORFR-TS",
  "TOWNSHIP OF POTTON": "PTTN-TS",
  "TOWNSHIP OF RISTIGOUCHE-PARTIE-SUD-EST": "RSTG-TS",
  "TOWNSHIP OF ROXTON": "RXT1-TS",
  "TOWNSHIP OF SAINT-CAMILLE": "SNT455-TS",
  "TOWNSHIP OF SAINT-GODEFROI": "SNT456-TS",
  "TOWNSHIP OF SAINTE-EDWIDGE-DE-CLIFTON": "SNT457-TS",
  "TOWNSHIP OF SHEFFORD": "SHFF-TS",
  "TOWNSHIP OF STANSTEAD": "STN3-TS",
  "TOWNSHIP OF STRATFORD": "STRT-TS",
  "TOWNSHIP OF TRÉCESSON": "TRCS-TS",
  "TOWNSHIP OF VALCOURT": "VLC1-TS",
  "TOWNSHIP OF WENTWORTH": "WNT1-TS",
  "TOWNSHIP OF WESTBURY": "WSTB-TS",
  "UNITED TOWNSHIP OF LATULIPE-ET-GABOURY": "LTLP-UT",
  "UNITED TOWNSHIP OF STONEHAM-ET-TEWKESBURY": "STNH-UT",
  "VILLAGE OF ABERCORN": "ABRC-V",
  "VILLAGE OF ANGLIERS": "ANGL-V",
  "VILLAGE OF AYER'S CLIFF": "AYRS-V",
  "VILLAGE OF BAIE-TRINITÉ": "BTRN-V",
  "VILLAGE OF BROME": "BRM-V",
  "VILLAGE OF CHUTE-AUX-OUTARDES": "CHTX-V",
  "VILLAGE OF FORT-COULONGE": "FRTC-V",
  "VILLAGE OF GODBOUT": "GDBT-V",
  "VILLAGE OF GRANDES-PILES": "GRN5-V",
  "VILLAGE OF GRENVILLE": "GRN6-V",
  "VILLAGE OF HÉBERTVILLE-STATION": "HBR1-V",
  "VILLAGE OF HEMMINGFORD": "HMM1-V",
  "VILLAGE OF KINGSBURY": "KNG1-V",
  "VILLAGE OF LA GUADELOUPE": "LGDL-V",
  "VILLAGE OF LAC-POULIN": "LCPL-V",
  "VILLAGE OF LAC-SAGUAY": "LCSG-V",
  "VILLAGE OF LAURIER-STATION": "LRRS-V",
  "VILLAGE OF LAWRENCEVILLE": "LWRN-V",
  "VILLAGE OF MARSOUI": "MRS-V",
  "VILLAGE OF MASSUEVILLE": "MSSV-V",
  "VILLAGE OF MONT-SAINT-PIERRE": "MNT8-V",
  "VILLAGE OF NORTH HATLEY": "NRTH-V",
  "VILLAGE OF NOTRE-DAME-DU-BON-CONSEIL": "NTR27-V",
  "VILLAGE OF POINTE-AUX-OUTARDES": "PNTX-V",
  "VILLAGE OF POINTE-DES-CASCADES": "PNTD-V",
  "VILLAGE OF POINTE-FORTUNE": "PNTF-V",
  "VILLAGE OF POINTE-LEBEL": "PNT3-V",
  "VILLAGE OF PORTAGE-DU-FORT": "PRTG-V",
  "VILLAGE OF PRICE": "PRC1-V",
  "VILLAGE OF ROXTON FALLS": "RXT2-V",
  "VILLAGE OF SAINT-ANDRÉ-DU-LAC-SAINT-JEAN": "SNT458-V",
  "VILLAGE OF SAINT-CÉLESTIN": "SNT459-V",
  "VILLAGE OF SAINT-NOËL": "SNT460-V",
  "VILLAGE OF SAINT-PIERRE": "SNT461-V",
  "VILLAGE OF SAINTE-JEANNE-D'ARC": "SNT462-V",
  "VILLAGE OF SAINTE-MADELEINE": "SNT463-V",
  "VILLAGE OF SAINTE-PÉTRONILLE": "SNT464-V",
  "VILLAGE OF SENNEVILLE": "SNNV-V",
  "VILLAGE OF STUKELY-SUD": "STKL-V",
  "VILLAGE OF TADOUSSAC": "TDSS-V",
  "VILLAGE OF TRING-JONCTION": "TRNG-V",
  "VILLAGE OF VAL-DAVID": "VLDV-V",
  "VILLAGE OF VAUDREUIL-SUR-LE-LAC": "VDR1-V",
  "VILLAGE OF WARDEN": "WRDN-V",
  "GRIFFINTOWN, MONTREAL": "MON",
  "BASSE - VILLE, QUÉBEC CITY": "QUE",
  "CAP-ROUGE, QUÉBEC CITY": "QUE",
  "CENTRE-VILLE QUÉBEC CITY, QUÉBEC CITY": "QUE",
  "CHUTES-MONTMORENCY, QUÉBEC CITY": "QUE",
  "CITÉ-UNIVERSITAIRE, QUÉBEC CITY": "QUE",
  "DES CHÂTELS, QUÉBEC CITY": "QUE",
  "DUBERGER-LES SAULES, QUÉBEC CITY": "QUE",
  "HAUTE - VILLE, QUÉBEC CITY": "QUE",
  "JEAN-LESAGE AEROPORT, QUÉBEC CITY": "QUE",
  "JÉSUITES, QUÉBEC CITY": "QUE",
  "L'AÉROPORT, QUÉBEC CITY": "QUE",
  "L'ANGE-GARDIEN, QUÉBEC CITY": "QUE",
  "LAC-SAINT-CHARLES, QUÉBEC CITY": "QUE",
  "LAIRET, QUÉBEC CITY": "QUE",
  "LE QUARTIER PETIT CHAMPLAIN, QUÉBEC CITY": "QUE",
  "LORETTEVILLE, QUÉBEC CITY": "QUE",
  "MAIZERETS, QUÉBEC CITY": "QUE",
  "MONTCALM, QUÉBEC CITY": "QUE",
  "NEUFCHÂTEL EST-LEBOURGNEUF, QUÉBEC CITY": "QUE",
  "NOTRE-DAME-DES-LAURENTIDES, QUÉBEC CITY": "QUE",
  "PLATEAU, QUÉBEC CITY": "QUE",
  "POINTE-DE-SAINTE-FOY, QUÉBEC CITY": "QUE",
  "QUARTIER 4-2, QUÉBEC CITY": "QUE",
  "QUARTIER 4-3, QUÉBEC CITY": "QUE",
  "QUARTIER 4-5, QUÉBEC CITY": "QUE",
  "QUARTIER 4-6, QUÉBEC CITY": "QUE",
  "QUARTIER 5-1, QUÉBEC CITY": "QUE",
  "QUARTIER 5-2, QUÉBEC CITY": "QUE",
  "QUARTIER 5-4, QUÉBEC CITY": "QUE",
  "SAINT LOUIS, QUÉBEC CITY": "QUE",
  "SAINT-AUGUSTIN-DE-DESMAURES, QUÉBEC CITY": "QUE",
  "SAINT-ÉMILE, QUÉBEC CITY": "QUE",
  "SAINT-JEAN-BAPTISTE, QUÉBEC CITY": "QUE",
  "SAINT-ROCH, QUÉBEC CITY": "QUE",
  "SAINT-SACREMENT, QUÉBEC CITY": "QUE",
  "SAINT-SAUVEUR, QUÉBEC CITY": "QUE",
  "SILLERY, QUÉBEC CITY": "QUE",
  "VAL-BÉLAIR, QUÉBEC CITY": "QUE",
  "VANIER, QUÉBEC CITY": "QUE",
  "VIEUX-LIMOILOU, QUÉBEC CITY": "QUE",
  "VIEUX-MOULIN, QUÉBEC CITY": "QUE",
  "DOWNTOWN GATINEAU, GATINEAU": "GAT",
  "VILLAGE-DES-CRÊTE, TROY-RIVIERES": "TRO",
  "VILLAGE DE LA PLAINE, TERREBONNE": "TER",
  "CITY OF ESTEVAN": "ESTV-C",
  "CITY OF HUMBOLDT": "HMBL-C",
  "CITY OF LLOYDMINSTER": "LLYD-C",
  "CITY OF MARTENSVILLE": "MRTN-C",
  "CITY OF MEADOW LAKE": "MDWL-C",
  "CITY OF MELFORT": "MLFR-C",
  "CITY OF MELVILLE": "MLVL-C",
  "CITY OF MOOSE JAW": "MSJW-C",
  "CITY OF NORTH BATTLEFORD": "NRTH-C",
  "CITY OF PRINCE ALBERT": "PRNC-C",
  "CITY OF REGINA": "RGN-C",
  "CITY OF SASKATOON": "SSKT-C",
  "CITY OF SWIFT CURRENT": "SWFT-C",
  "CITY OF WARMAN": "WRMN-C",
  "CITY OF WEYBURN": "WYBR-C",
  "CITY OF YORKTON": "YRKT-C",
  "TOWN OF ABERDEEN": "ABRD-T",
  "TOWN OF ALAMEDA": "ALMD-T",
  "TOWN OF ALLAN": "ALLN-T",
  "TOWN OF ARBORFIELD": "ARBR-T",
  "TOWN OF ARCOLA": "ARCL-T",
  "TOWN OF ASQUITH": "ASQT-T",
  "TOWN OF ASSINIBOIA": "ASSN-T",
  "TOWN OF BALCARRES": "BLCR-T",
  "TOWN OF BALGONIE": "BLGN-T",
  "TOWN OF BATTLEFORD": "BTTL-T",
  "TOWN OF BENGOUGH": "BNGG-T",
  "TOWN OF BIENFAIT": "BNFT-T",
  "TOWN OF BIG RIVER": "BGRV-T",
  "TOWN OF BIGGAR": "BGGR-T",
  "TOWN OF BIRCH HILLS": "BRCH-T",
  "TOWN OF BLAINE LAKE": "BLNL-T",
  "TOWN OF BREDENBURY": "BRDN-T",
  "TOWN OF BROADVIEW": "BRDV-T",
  "TOWN OF BRUNO": "BRN-T",
  "TOWN OF BURSTALL": "BRST-T",
  "TOWN OF CABRI": "CBR-T",
  "TOWN OF CANORA": "CNR-T",
  "TOWN OF CARLYLE": "CRLY-T",
  "TOWN OF CARNDUFF": "CRND-T",
  "TOWN OF CARROT RIVER": "CRRT-T",
  "TOWN OF CENTRAL BUTTE": "CNTR-T",
  "TOWN OF CHOICELAND": "CHCL-T",
  "TOWN OF CHURCHBRIDGE": "CHRC-T",
  "TOWN OF COLONSAY": "CLNS-T",
  "TOWN OF CORONACH": "CRNC-T",
  "TOWN OF CRAIK": "CRK-T",
  "TOWN OF CUDWORTH": "CDWR-T",
  "TOWN OF CUPAR": "CPR-T",
  "TOWN OF CUT KNIFE": "CTKN-T",
  "TOWN OF DALMENY": "DLMN-T",
  "TOWN OF DAVIDSON": "DVDS-T",
  "TOWN OF DELISLE": "DLSL-T",
  "TOWN OF DUCK LAKE": "DCKL-T",
  "TOWN OF DUNDURN": "DNDR-T",
  "TOWN OF EASTEND": "ESTN-T",
  "TOWN OF EATONIA": "ETN-T",
  "TOWN OF ELROSE": "ELRS-T",
  "TOWN OF ESTERHAZY": "ESTR-T",
  "TOWN OF ESTON": "EST1-T",
  "TOWN OF FLEMING": "FLMN-T",
  "TOWN OF FOAM LAKE": "FMLK-T",
  "TOWN OF FORT QU'APELLE": "FRTQ-T",
  "TOWN OF FRANCIS": "FRNC-T",
  "TOWN OF GOVAN": "GVN-T",
  "TOWN OF GRAND COULEE": "GRND-T",
  "TOWN OF GRAVELBOURG": "GRVL-T",
  "TOWN OF GRENFELL": "GRNF-T",
  "TOWN OF GULL LAKE": "GLLL-T",
  "TOWN OF HAFFORD": "HFFR-T",
  "TOWN OF HAGUE": "HG-T",
  "TOWN OF HANLEY": "HNLY-T",
  "TOWN OF HEPBURN": "HPBR-T",
  "TOWN OF HERBERT": "HRBR-T",
  "TOWN OF HUDSON BAY": "HDSN-T",
  "TOWN OF IMPERIAL": "IMPR-T",
  "TOWN OF INDIAN HEAD": "INDN-T",
  "TOWN OF ITUNA": "ITN-T",
  "TOWN OF KAMSACK": "KMSC-T",
  "TOWN OF KELVINGTON": "KLVN-T",
  "TOWN OF KERROBERT": "KRRB-T",
  "TOWN OF KINDERSLEY": "KNDR-T",
  "TOWN OF KINISTINO": "KNST-T",
  "TOWN OF KIPLING": "KPLN-T",
  "TOWN OF KYLE": "KYL-T",
  "TOWN OF LAFLECHE": "LFLC-T",
  "TOWN OF LAMPMAN": "LMPM-T",
  "TOWN OF LANGENBURG": "LNGN-T",
  "TOWN OF LANGHAM": "LNGH-T",
  "TOWN OF LANIGAN": "LNG1-T",
  "TOWN OF LASHBURN": "LSHB-T",
  "TOWN OF LEADER": "LDR-T",
  "TOWN OF LEMBERG": "LMBR-T",
  "TOWN OF LEROY": "LRY-T",
  "TOWN OF LUMSDEN": "LMSD-T",
  "TOWN OF LUSELAND": "LSLN-T",
  "TOWN OF MACKLIN": "MCKL-T",
  "TOWN OF MAIDSTONE": "MDST-T",
  "TOWN OF MAPLE CREEK": "MPLC-T",
  "TOWN OF MARSHALL": "MRSH-T",
  "TOWN OF MIDALE": "MDL-T",
  "TOWN OF MILESTONE": "MLST-T",
  "TOWN OF MOOSOMIN": "MSMN-T",
  "TOWN OF MORSE": "MRS-T",
  "TOWN OF MOSSBANK": "MSSB-T",
  "TOWN OF NAICAM": "NCM-T",
  "TOWN OF NIPAWIN": "NPWN-T",
  "TOWN OF NOKOMIS": "NKMS-T",
  "TOWN OF NORQUAY": "NRQY-T",
  "TOWN OF OGEMA": "OGM-T",
  "TOWN OF OSLER": "OSLR-T",
  "TOWN OF OUTLOOK": "OTLK-T",
  "TOWN OF OXBOW": "OXBW-T",
  "TOWN OF PENSE": "PNS-T",
  "TOWN OF PILOT BUTTE": "PLTB-T",
  "TOWN OF PONTEIX": "PNTX-T",
  "TOWN OF PORCUPINE PLAIN": "PRCP-T",
  "TOWN OF PREECEVILLE": "PRCV-T",
  "TOWN OF QU'APELLE": "QPLL-T",
  "TOWN OF RADISSON": "RDSS-T",
  "TOWN OF RADVILLE": "RDVL-T",
  "TOWN OF RAYMORE": "RYMR-T",
  "TOWN OF REDVERS": "RDVR-T",
  "TOWN OF REGINA BEACH": "RGNB-T",
  "TOWN OF ROCANVILLE": "RCNV-T",
  "TOWN OF ROCKGLEN": "RCKG-T",
  "TOWN OF ROSE VALLEY": "RSVL-T",
  "TOWN OF ROSETOWN": "RSTW-T",
  "TOWN OF ROSTHERN": "RSTH-T",
  "TOWN OF ROULEAU": "RL-T",
  "TOWN OF SALTCOATS": "SLTC-T",
  "TOWN OF SCOTT": "SCTT-T",
  "TOWN OF SHAUNAVON": "SHNV-T",
  "TOWN OF SHELLBROOK": "SHLL-T",
  "TOWN OF SINTALUTA": "SNTL-T",
  "TOWN OF SOUTHEY": "STHY-T",
  "TOWN OF SPIRITWOOD": "SPRT-T",
  "TOWN OF SPRINGSIDE": "SPRN-T",
  "TOWN OF ST BRIEUX": "STBR-T",
  "TOWN OF ST WALBURG": "STWL-T",
  "TOWN OF STAR CITY": "STRC-T",
  "TOWN OF STOUGHTON": "STGH-T",
  "TOWN OF STRASBOURG": "STRS-T",
  "TOWN OF STURGIS": "STRG-T",
  "TOWN OF TISDALE": "TSDL-T",
  "TOWN OF TURTLEFORD": "TRTL-T",
  "TOWN OF UNITY": "UNTY-T",
  "TOWN OF VONDA": "VND-T",
  "TOWN OF WADENA": "WDN-T",
  "TOWN OF WAKAW": "WKW-T",
  "TOWN OF WALDHEIM": "WLDH-T",
  "TOWN OF WAPELLA": "WPLL-T",
  "TOWN OF WATROUS": "WTRS-T",
  "TOWN OF WATSON": "WTSN-T",
  "TOWN OF WAWOTA": "WWT-T",
  "TOWN OF WHITE CITY": "WHTC-T",
  "TOWN OF WHITEWOOD": "WHTW-T",
  "TOWN OF WILKIE": "WLK-T",
  "TOWN OF WILLOW BUNCH": "WLLW-T",
  "TOWN OF WOLSELEY": "WLSL-T",
  "TOWN OF WYNYARD": "WYNY-T",
  "TOWN OF YELLOW GRASS": "YLLW-T",
  "TOWN OF ZEALANDIA": "ZLND-T",
  "HAMLET OF ALTA VISTA": "ALTV-H",
  "HAMLET OF AMSTERDAM": "AMST-H",
  "HAMLET OF ARLINGTON BEACH": "ARLN-H",
  "HAMLET OF BALONE BEACH": "BLNB-H",
  "HAMLET OF BARRIER FORD": "BRRR-H",
  "HAMLET OF BAYARD": "BYRD-H",
  "HAMLET OF BAYVIEW HEIGHTS": "BYVW-H",
  "HAMLET OF BEAUBIER": "BBR-H",
  "HAMLET OF BEAVER CREEK": "BVRC-H",
  "HAMLET OF BELLEGARDE": "BLLG-H",
  "HAMLET OF BIG BEAVER": "BGBV-H",
  "HAMLET OF BLUMENTHAL": "BLMN-H",
  "HAMLET OF BRANCEPETH": "BRNC-H",
  "HAMLET OF BURGIS BEACH": "BRGS-H",
  "HAMLET OF CANDIAC": "CNDC-H",
  "HAMLET OF CANNINGTON LAKE": "CNNN-H",
  "HAMLET OF CARON": "CRN-H",
  "HAMLET OF CASA RIO": "CSR-H",
  "HAMLET OF CATHEDRAL BLUFFS": "CTHD-H",
  "HAMLET OF CEDAR VILLA ESTATES": "CDRV-H",
  "HAMLET OF CHELAN": "CHLN-H",
  "HAMLET OF CLAYBANK": "CLYB-H",
  "HAMLET OF COLESDALE PARK": "CLSD-H",
  "HAMLET OF COLLINGWOOD LAKESHORE ESTATES": "CLLN-H",
  "HAMLET OF CONGRESS": "CNGR-H",
  "HAMLET OF CORNING": "CRNN-H",
  "HAMLET OF CRAWFORD ESTATES": "CRWF-H",
  "HAMLET OF CRUTWELL": "CRTW-H",
  "HAMLET OF CRYSTAL BAY-SUNSET": "CRYS-H",
  "HAMLET OF CRYSTAL LAKE": "CRY1-H",
  "HAMLET OF CRYSTAL SPRINGS": "CRY2-H",
  "HAMLET OF CUDSASKWA BEACH": "CDSS-H",
  "HAMLET OF DARLINGS BEACH": "DRLN-H",
  "HAMLET OF DAVIN": "DVN-H",
  "HAMLET OF DAY'S BEACH": "DYSB-H",
  "HAMLET OF DEER VALLEY": "DRVL-H",
  "HAMLET OF DELMAS": "DLMS-H",
  "HAMLET OF DEMAINE": "DMN-H",
  "HAMLET OF DISCOVERY RIDGE": "DSCV-H",
  "HAMLET OF EAGLE RIDGE COUNTRY ESTATES": "EGLR-H",
  "HAMLET OF EDGELEY": "EDGL-H",
  "HAMLET OF ELBOW LAKE": "ELBW-H",
  "HAMLET OF ELK RIDGE": "ELKR-H",
  "HAMLET OF ERWOOD": "ERWD-H",
  "HAMLET OF EVERGREEN ACRES": "EVRG-H",
  "HAMLET OF EVERGREEN BEACH": "EVR1-H",
  "HAMLET OF EXNER'S TWIN BAYS": "EXNR-H",
  "HAMLET OF FAIRHOLME": "FRHL-H",
  "HAMLET OF FAIRY GLEN": "FRYG-H",
  "HAMLET OF FISKE": "FSK-H",
  "HAMLET OF FRENCHMAN BUTTE": "FRN1-H",
  "HAMLET OF FURDALE": "FRDL-H",
  "HAMLET OF GARRICK": "GRRC-H",
  "HAMLET OF GOOD SPIRIT ACRES": "GDSP-H",
  "HAMLET OF GRAY": "GRY-H",
  "HAMLET OF GREENSPOT": "GRNS-H",
  "HAMLET OF GRONLID": "GRNL-H",
  "HAMLET OF GUERNSEY": "GRN1-H",
  "HAMLET OF HAGEN": "HGN-H",
  "HAMLET OF HAZEL DELL": "HZLD-H",
  "HAMLET OF HENDON": "HNDN-H",
  "HAMLET OF HITCHCOCK BAY": "HTCH-H",
  "HAMLET OF HOEY": "HY-H",
  "HAMLET OF HOLBEIN": "HLBN-H",
  "HAMLET OF HORSESHOE BAY": "HRSS-H",
  "HAMLET OF KANDAHAR": "KNDH-H",
  "HAMLET OF KETCHEN": "KTCH-H",
  "HAMLET OF KOPP'S KOVE": "KPPS-H",
  "HAMLET OF KRONAU": "KRN-H",
  "HAMLET OF KUROKI": "KRK-H",
  "HAMLET OF LAKEVIEW": "LKVW-H",
  "HAMLET OF LANZ POINT": "LNZP-H",
  "HAMLET OF LITTLE FISHING LAKE": "LTTL-H",
  "HAMLET OF LITTLE SWAN RIVER": "LTT1-H",
  "HAMLET OF LIVELONG": "LVLN-H",
  "HAMLET OF LONE ROCK": "LNRC-H",
  "HAMLET OF MACDOWALL": "MCDW-H",
  "HAMLET OF MACPHEAT PARK": "MCPH-H",
  "HAMLET OF MARTINSON'S BEACH": "MRT1-H",
  "HAMLET OF MAYFAIR": "MYFR-H",
  "HAMLET OF MAYMONT BEACH": "MYMN-H",
  "HAMLET OF MCCORD": "MCCR-H",
  "HAMLET OF MERRILL HILLS": "MRRL-H",
  "HAMLET OF MESKANAW": "MSKN-H",
  "HAMLET OF MOHR'S BEACH": "MHRS-H",
  "HAMLET OF MOOSE BAY": "MSBY-H",
  "HAMLET OF MOWREY BEACH": "MWRY-H",
  "HAMLET OF MOZART": "MZRT-H",
  "HAMLET OF MULLINGAR": "MLLN-H",
  "HAMLET OF NESSLIN LAKE": "NSSL-H",
  "HAMLET OF NEUANLAGE": "NNLG-H",
  "HAMLET OF NEUHORST": "NHRS-H",
  "HAMLET OF NORTH COLESDALE PARK": "NRT1-H",
  "HAMLET OF NORTH SHORE FISHING LAKE": "NRT2-H",
  "HAMLET OF NORTH WEYBURN": "NRT3-H",
  "HAMLET OF NORTHSIDE": "NRT4-H",
  "HAMLET OF OKLA": "OKL-H",
  "HAMLET OF ORMISTON": "ORMS-H",
  "HAMLET OF OTTMAN-MURRAY BEACH": "OTTM-H",
  "HAMLET OF PARKLAND BEACH": "PRKL-H",
  "HAMLET OF PARKVIEW": "PRKV-H",
  "HAMLET OF PARRY": "PRRY-H",
  "HAMLET OF PASQUA LAKE": "PSQL-H",
  "HAMLET OF PEEBLES": "PBLS-H",
  "HAMLET OF PELICAN COVE": "PLCN-H",
  "HAMLET OF PELICAN POINT": "PLC1-H",
  "HAMLET OF PELICAN SHORES": "PLC2-H",
  "HAMLET OF PHILLIPS GROVE": "PHLL-H",
  "HAMLET OF POWM BEACH": "PWMB-H",
  "HAMLET OF PRAIRIE RIVER": "PRRR-H",
  "HAMLET OF PRINCE": "PRN1-H",
  "HAMLET OF RICETON": "RCTN-H",
  "HAMLET OF RIVER'S EDGE": "RVRS-H",
  "HAMLET OF RIVERSIDE ESTATES": "RVR1-H",
  "HAMLET OF RUNNYMEDE": "RNNY-H",
  "HAMLET OF SARNIA BEACH": "SRNB-H",
  "HAMLET OF SCOUT LAKE": "SCTL-H",
  "HAMLET OF SLEEPY HOLLOW": "SLPY-H",
  "HAMLET OF SNOWDEN": "SNWD-H",
  "HAMLET OF SORENSEN BEACH": "SRNS-H",
  "HAMLET OF SOUTH WATERHEN LAKE": "STHW-H",
  "HAMLET OF SPRING BAY": "SPR1-H",
  "HAMLET OF SPRUCE BAY": "SPRC-H",
  "HAMLET OF SPRUCE LAKE": "SPR2-H",
  "HAMLET OF ST ISIDORE-DE-BELLEVUE": "STSD-H",
  "HAMLET OF ST JOSEPH'S": "STJS-H",
  "HAMLET OF SUMMERFIELD BEACH": "SMMR-H",
  "HAMLET OF SUNSET BEACH": "SNST-H",
  "HAMLET OF SUNSET VIEW BEACH": "SNS1-H",
  "HAMLET OF SWAN PLAIN": "SWNP-H",
  "HAMLET OF SYLVANIA": "SYLV-H",
  "HAMLET OF TADMORE": "TDMR-H",
  "HAMLET OF TAYLOR BEACH": "TYLR-H",
  "HAMLET OF TREVESSA BEACH": "TRVS-H",
  "HAMLET OF TROSSACHS": "TRSS-H",
  "HAMLET OF TUFFNELL": "TFFN-H",
  "HAMLET OF TURTLE LAKE SOUTH BAY": "TRT1-H",
  "HAMLET OF TWAY": "TWY-H",
  "HAMLET OF UHL'S BAY": "UHLS-H",
  "HAMLET OF USHERVILLE": "USHR-H",
  "HAMLET OF WEST CHATFIELD BEACH": "WSTC-H",
  "HAMLET OF WESTVIEW": "WSTV-H",
  "HAMLET OF WISHART": "WSHR-H",
  "HAMLET OF WYMARK": "WYMR-H",
  "HAMLET OF ARDILL": "ARDL-H",
  "HAMLET OF CACTUS LAKE": "CCTS-H",
  "HAMLET OF CLEMENCEAU": "CLMN-H",
  "HAMLET OF CRANE VALLEY": "CRNV-H",
  "HAMLET OF ELDERSLEY": "ELDR-H",
  "HAMLET OF FIFE LAKE": "FFLK-H",
  "HAMLET OF JASMIN": "JSMN-H",
  "HAMLET OF KAYVILLE": "KYVL-H",
  "HAMLET OF LADY LAKE": "LDYL-H",
  "HAMLET OF LANGBANK": "LNGB-H",
  "HAMLET OF LAPORTE": "LPRT-H",
  "HAMLET OF MAIN CENTRE": "MNCN-H",
  "HAMLET OF MIKADO": "MKD-H",
  "HAMLET OF OUNGRE": "ONGR-H",
  "HAMLET OF PERCIVAL": "PRC1-H",
  "HAMLET OF PIAPOT": "PPT-H",
  "HAMLET OF SHIPMAN": "SHPM-H",
  "HAMLET OF SIMMIE": "SMM-H",
  "HAMLET OF SPRING VALLEY": "SPR3-H",
  "HAMLET OF VANTAGE": "VNTG-H",
  "HAMLET OF VICEROY": "VCRY-H",
  "VILLAGE OF ABBEY": "ABBY-V",
  "VILLAGE OF ABERNETHY": "ABRN-V",
  "VILLAGE OF ALBERTVILLE": "ALBR-V",
  "VILLAGE OF ALIDA": "ALD-V",
  "VILLAGE OF ALVENA": "ALVN-V",
  "VILLAGE OF ANNAHEIM": "ANNH-V",
  "VILLAGE OF ANTLER": "ANTL-V",
  "VILLAGE OF ARCHERWILL": "ARCH-V",
  "VILLAGE OF ARRAN": "ARRN-V",
  "VILLAGE OF ATWATER": "ATWT-V",
  "VILLAGE OF AVONLEA": "AVNL-V",
  "VILLAGE OF AYLESBURY": "AYLS-V",
  "VILLAGE OF AYLSHAM": "AYL1-V",
  "VILLAGE OF BANGOR": "BNGR-V",
  "VILLAGE OF BEATTY": "BTTY-V",
  "VILLAGE OF BEECHY": "BCHY-V",
  "VILLAGE OF BELLE PLAINE": "BLLP-V",
  "VILLAGE OF BETHUNE": "BTHN-V",
  "VILLAGE OF BJORKDALE": "BJRK-V",
  "VILLAGE OF BLADWORTH": "BLDW-V",
  "VILLAGE OF BORDEN": "BRD1-V",
  "VILLAGE OF BRACKEN": "BRCK-V",
  "VILLAGE OF BRADWELL": "BRDW-V",
  "VILLAGE OF BRIERCREST": "BRRC-V",
  "VILLAGE OF BROCK": "BRC1-V",
  "VILLAGE OF BRODERICK": "BRDR-V",
  "VILLAGE OF BROWNLEE": "BRWN-V",
  "VILLAGE OF BUCHANAN": "BCHN-V",
  "VILLAGE OF BUENA VISTA": "BNVS-V",
  "VILLAGE OF BULYEA": "BLY-V",
  "VILLAGE OF CADILLAC": "CDLL-V",
  "VILLAGE OF CALDER": "CLDR-V",
  "VILLAGE OF CANWOOD": "CNWD-V",
  "VILLAGE OF CARIEVALE": "CRVL-V",
  "VILLAGE OF CARMICHAEL": "CRMC-V",
  "VILLAGE OF CARONPORT": "CRNP-V",
  "VILLAGE OF CEYLON": "CYLN-V",
  "VILLAGE OF CHAMBERLAIN": "CHMB-V",
  "VILLAGE OF CHAPLIN": "CHPL-V",
  "VILLAGE OF CHRISTOPHER LAKE": "CHRS-V",
  "VILLAGE OF CLAVET": "CLVT-V",
  "VILLAGE OF CLIMAX": "CLMX-V",
  "VILLAGE OF CODERRE": "CDRR-V",
  "VILLAGE OF CODETTE": "CDTT-V",
  "VILLAGE OF COLEVILLE": "CLVL-V",
  "VILLAGE OF CONQUEST": "CNQS-V",
  "VILLAGE OF CONSUL": "CNSL-V",
  "VILLAGE OF CRAVEN": "CRVN-V",
  "VILLAGE OF CREELMAN": "CRLM-V",
  "VILLAGE OF DAFOE": "DF-V",
  "VILLAGE OF DEBDEN": "DBDN-V",
  "VILLAGE OF DENHOLM": "DNHL-V",
  "VILLAGE OF DENZIL": "DNZL-V",
  "VILLAGE OF DILKE": "DLK-V",
  "VILLAGE OF DINSMORE": "DNSM-V",
  "VILLAGE OF DISLEY": "DSLY-V",
  "VILLAGE OF DODSLAND": "DDSL-V",
  "VILLAGE OF DORINTOSH": "DRNT-V",
  "VILLAGE OF DRAKE": "DRK-V",
  "VILLAGE OF DRINKWATER": "DRNK-V",
  "VILLAGE OF DUBUC": "DBC-V",
  "VILLAGE OF DUFF": "DFF-V",
  "VILLAGE OF DUVAL": "DVL-V",
  "VILLAGE OF DYSART": "DYSR-V",
  "VILLAGE OF EARL GREY": "ERLG-V",
  "VILLAGE OF EBENEZER": "EBNZ-V",
  "VILLAGE OF EDAM": "EDM-V",
  "VILLAGE OF EDENWOLD": "EDNW-V",
  "VILLAGE OF ELBOW": "ELB1-V",
  "VILLAGE OF ELFROS": "ELFR-V",
  "VILLAGE OF ELSTOW": "ELST-V",
  "VILLAGE OF ENDEAVOUR": "ENDV-V",
  "VILLAGE OF ENGLEFELD": "ENGL-V",
  "VILLAGE OF ERNFOLD": "ERNF-V",
  "VILLAGE OF EYEBROW": "EYBR-V",
  "VILLAGE OF FAIRLIGHT": "FRLG-V",
  "VILLAGE OF FENWOOD": "FNWD-V",
  "VILLAGE OF FILLMORE": "FLLM-V",
  "VILLAGE OF FINDLATER": "FNDL-V",
  "VILLAGE OF FLAXCOMBE": "FLXC-V",
  "VILLAGE OF FORGET": "FRGT-V",
  "VILLAGE OF FOSSTON": "FSST-V",
  "VILLAGE OF FOX VALLEY": "FXVL-V",
  "VILLAGE OF FROBISHER": "FRBS-V",
  "VILLAGE OF FRONTIER": "FRNT-V",
  "VILLAGE OF GAINSBOROUGH": "GNSB-V",
  "VILLAGE OF GERALD": "GRLD-V",
  "VILLAGE OF GLADMAR": "GLDM-V",
  "VILLAGE OF GLASLYN": "GLSL-V",
  "VILLAGE OF GLEN EWEN": "GLNW-V",
  "VILLAGE OF GLENAVON": "GLNV-V",
  "VILLAGE OF GLENSIDE": "GLNS-V",
  "VILLAGE OF GOLDEN PRAIRIE": "GLDN-V",
  "VILLAGE OF GOODEVE": "GDV-V",
  "VILLAGE OF GOODSOIL": "GDSL-V",
  "VILLAGE OF GOODWATER": "GDWT-V",
  "VILLAGE OF GRAYSON": "GRYS-V",
  "VILLAGE OF HALBRITE": "HLBR-V",
  "VILLAGE OF HAWARDEN": "HWRD-V",
  "VILLAGE OF HAZENMORE": "HZNM-V",
  "VILLAGE OF HAZLET": "HZLT-V",
  "VILLAGE OF HEWARD": "HWR1-V",
  "VILLAGE OF HODGEVILLE": "HDGV-V",
  "VILLAGE OF HOLDFAST": "HLDF-V",
  "VILLAGE OF HUBBARD": "HBBR-V",
  "VILLAGE OF HYAS": "HYS-V",
  "VILLAGE OF INVERMAY": "INVR-V",
  "VILLAGE OF JANSEN": "JNSN-V",
  "VILLAGE OF KEELER": "KLR-V",
  "VILLAGE OF KELLIHER": "KLLH-V",
  "VILLAGE OF KENASTON": "KNS1-V",
  "VILLAGE OF KENDAL": "KNDL-V",
  "VILLAGE OF KENNEDY": "KNND-V",
  "VILLAGE OF KENOSEE LAKE": "KNSL-V",
  "VILLAGE OF KILLALY": "KLLL-V",
  "VILLAGE OF KINCAID": "KNCD-V",
  "VILLAGE OF KINLEY": "KNLY-V",
  "VILLAGE OF KISBEY": "KSBY-V",
  "VILLAGE OF KRYDOR": "KRYD-V",
  "VILLAGE OF LAIRD": "LRD-V",
  "VILLAGE OF LAKE ALMA": "LKLM-V",
  "VILLAGE OF LAKE LENORE": "LKLN-V",
  "VILLAGE OF LANCER": "LNCR-V",
  "VILLAGE OF LANDIS": "LNDS-V",
  "VILLAGE OF LANG": "LNG-V",
  "VILLAGE OF LEASK": "LSK-V",
  "VILLAGE OF LEBRET": "LBRT-V",
  "VILLAGE OF LEOVILLE": "LVLL-V",
  "VILLAGE OF LEROSS": "LRSS-V",
  "VILLAGE OF LESTOCK": "LSTC-V",
  "VILLAGE OF LIBERTY": "LBR1-V",
  "VILLAGE OF LIMERICK": "LMRC-V",
  "VILLAGE OF LINTLAW": "LNTL-V",
  "VILLAGE OF LIPTON": "LPTN-V",
  "VILLAGE OF LOON LAKE": "LNLK-V",
  "VILLAGE OF LOREBURN": "LRBR-V",
  "VILLAGE OF LOVE": "LV-V",
  "VILLAGE OF LUCKY LAKE": "LCKY-V",
  "VILLAGE OF MACNUTT": "MCNT-V",
  "VILLAGE OF MACOUN": "MCN-V",
  "VILLAGE OF MACRORIE": "MCRR-V",
  "VILLAGE OF MAJOR": "MJR-V",
  "VILLAGE OF MAKWA": "MKW-V",
  "VILLAGE OF MANKOTA": "MNKT-V",
  "VILLAGE OF MANOR": "MNR-V",
  "VILLAGE OF MARCELIN": "MRCL-V",
  "VILLAGE OF MARENGO": "MRNG-V",
  "VILLAGE OF MARGO": "MRG-V",
  "VILLAGE OF MARKINCH": "MRKN-V",
  "VILLAGE OF MARQUIS": "MRQS-V",
  "VILLAGE OF MARSDEN": "MRSD-V",
  "VILLAGE OF MARYFIELD": "MRYF-V",
  "VILLAGE OF MAYMONT": "MYM1-V",
  "VILLAGE OF MCLEAN": "MCLN-V",
  "VILLAGE OF MCTAGGART": "MCTG-V",
  "VILLAGE OF MEACHAM": "MCHM-V",
  "VILLAGE OF MEATH PARK": "MTHP-V",
  "VILLAGE OF MEDSTEAD": "MDS1-V",
  "VILLAGE OF MENDHAM": "MNDH-V",
  "VILLAGE OF MEOTA": "MT-V",
  "VILLAGE OF MERVIN": "MRVN-V",
  "VILLAGE OF MIDDLE LAKE": "MDDL-V",
  "VILLAGE OF MILDEN": "MLDN-V",
  "VILLAGE OF MINTON": "MNTN-V",
  "VILLAGE OF MISTATIM": "MSTT-V",
  "VILLAGE OF MONTMARTRE": "MNTM-V",
  "VILLAGE OF MORTLACH": "MRTL-V",
  "VILLAGE OF MUENSTER": "MNST-V",
  "VILLAGE OF NEILBURG": "NLBR-V",
  "VILLAGE OF NETHERHILL": "NTHR-V",
  "VILLAGE OF NEUDORF": "NDRF-V",
  "VILLAGE OF NEVILLE": "NVLL-V",
  "VILLAGE OF NORTH PORTAL": "NRT5-V",
  "VILLAGE OF ODESSA": "ODSS-V",
  "VILLAGE OF OSAGE": "OSG-V",
  "VILLAGE OF PADDOCKWOOD": "PDDC-V",
  "VILLAGE OF PANGMAN": "PNGM-V",
  "VILLAGE OF PARADISE HILL": "PRDS-V",
  "VILLAGE OF PARKSIDE": "PRKS-V",
  "VILLAGE OF PAYNTON": "PYNT-V",
  "VILLAGE OF PELLY": "PLLY-V",
  "VILLAGE OF PENNANT": "PNNN-V",
  "VILLAGE OF PERDUE": "PRD-V",
  "VILLAGE OF PIERCELAND": "PRCL-V",
  "VILLAGE OF PILGER": "PLGR-V",
  "VILLAGE OF PLEASANTDALE": "PLSN-V",
  "VILLAGE OF PLENTY": "PLNT-V",
  "VILLAGE OF PLUNKETT": "PLNK-V",
  "VILLAGE OF PRELATE": "PRLT-V",
  "VILLAGE OF PRIMATE": "PRMT-V",
  "VILLAGE OF PRUD'HOMME": "PRDH-V",
  "VILLAGE OF PUNNICHY": "PNNC-V",
  "VILLAGE OF QUILL LAKE": "QLLL-V",
  "VILLAGE OF QUINTON": "QNTN-V",
  "VILLAGE OF RABBIT LAKE": "RBBT-V",
  "VILLAGE OF RAMA": "RM-V",
  "RESORT VILLAGE OF METINOTA": "RSRT-V",
  "VILLAGE OF RHEIN": "RHN-V",
  "VILLAGE OF RICHARD": "RCHR-V",
  "VILLAGE OF RICHMOUND": "RCHM-V",
  "VILLAGE OF RIDGEDALE": "RDGD-V",
  "VILLAGE OF RIVERHURST": "RVRH-V",
  "VILLAGE OF ROCHE PERCEE": "RCHP-V",
  "VILLAGE OF RUDDELL": "RDDL-V",
  "VILLAGE OF RUSH LAKE": "RSHL-V",
  "VILLAGE OF RUTHILDA": "RTHL-V",
  "VILLAGE OF SCEPTRE": "SCPT-V",
  "VILLAGE OF SEDLEY": "SDLY-V",
  "VILLAGE OF SEMANS": "SMNS-V",
  "VILLAGE OF SENLAC": "SNLC-V",
  "VILLAGE OF SHACKLETON": "SHCK-V",
  "VILLAGE OF SHAMROCK": "SHMR-V",
  "VILLAGE OF SHEHO": "SHH-V",
  "VILLAGE OF SHELL LAKE": "SHL1-V",
  "VILLAGE OF SILTON": "SLTN-V",
  "VILLAGE OF SIMPSON": "SMPS-V",
  "VILLAGE OF SMEATON": "SMTN-V",
  "VILLAGE OF SMILEY": "SMLY-V",
  "VILLAGE OF SPALDING": "SPLD-V",
  "VILLAGE OF SPEERS": "SPRS-V",
  "VILLAGE OF SPY HILL": "SPYH-V",
  "VILLAGE OF ST BENEDICT": "STBN-V",
  "VILLAGE OF ST GREGOR": "STGR-V",
  "VILLAGE OF ST LOUIS": "STLS-V",
  "VILLAGE OF STENEN": "STNN-V",
  "VILLAGE OF STEWART VALLEY": "STWR-V",
  "VILLAGE OF STOCKHOLM": "STCK-V",
  "VILLAGE OF STORTHOAKS": "STRT-V",
  "VILLAGE OF STRONGFIELD": "STRN-V",
  "VILLAGE OF SUCCESS": "SCCS-V",
  "VILLAGE OF TANTALLON": "TNTL-V",
  "VILLAGE OF TESSIER": "TSSR-V",
  "VILLAGE OF THEODORE": "THDR-V",
  "VILLAGE OF TOGO": "TG-V",
  "VILLAGE OF TOMPKINS": "TMPK-V",
  "VILLAGE OF TORQUAY": "TRQY-V",
  "VILLAGE OF TRAMPING LAKE": "TRMP-V",
  "VILLAGE OF TRIBUNE": "TRBN-V",
  "VILLAGE OF TUGASKE": "TGSK-V",
  "VILLAGE OF TUXFORD": "TXFR-V",
  "VILLAGE OF VAL MARIE": "VLMR-V",
  "VILLAGE OF VALPARAISO": "VLPR-V",
  "VILLAGE OF VANGUARD": "VNGR-V",
  "VILLAGE OF VANSCOY": "VNSC-V",
  "VILLAGE OF VIBANK": "VBNK-V",
  "VILLAGE OF VISCOUNT": "VSCN-V",
  "VILLAGE OF WALDECK": "WLDC-V",
  "VILLAGE OF WALDRON": "WLDR-V",
  "VILLAGE OF WASECA": "WSC-V",
  "VILLAGE OF WEBB": "WBB-V",
  "VILLAGE OF WEEKES": "WKS-V",
  "VILLAGE OF WEIRDALE": "WRDL-V",
  "VILLAGE OF WELDON": "WLDN-V",
  "VILLAGE OF WELWYN": "WLWY-V",
  "VILLAGE OF WHITE FOX": "WHTF-V",
  "VILLAGE OF WILCOX": "WLCX-V",
  "VILLAGE OF WINDTHORST": "WNDT-V",
  "VILLAGE OF WISETON": "WSTN-V",
  "VILLAGE OF WOOD MOUNTAIN": "WDMN-V",
  "VILLAGE OF YARBO": "YRB-V",
  "VILLAGE OF YOUNG": "YNG-V",
  "VILLAGE OF ZELMA": "ZLM-V",
  "VILLAGE OF ZENON PARK": "ZNNP-V",
  "NORTHERN HAMLET BLACK POINT": "BLPT-NH",
  "NORTHERN HAMLET COLE BAY": "CLBY-NH",
  "NORTHERN HAMLET DORE LAKE": "DRLK-NH",
  "NORTHERN HAMLET JANS BAY": "JNBY-NH",
  "NORTHERN HAMLET MICHEL VILLAGE": "MCVL-NH",
  "NORTHERN HAMLET PATUANAK": "PTNK-NH",
  "NORTHERN HAMLET ST GEORGE'S HILL": "STGG-NH",
  "NORTHERN HAMLET STONY RAPIDS": "STRP-NH",
  "NORTHERN HAMLET TIMBER BAY": "TMBY-NH",
  "NORTHERN HAMLET TURNOR LAKE": "TRNL-NH",
  "NORTHERN HAMLET WEYAKWIN": "WYKW-NH",
  "NORTHERN TOWN CREIGHTON": "CRGT-NH",
  "NORTHERN TOWN LA RONGE": "LRNG-NH",
  "NORTHERN VILLAGE AIR RONGE": "ARNG-NV",
  "NORTHERN VILLAGE BEAUVAL": "BVAL-NV",
  "NORTHERN VILLAGE BUFFALO NARROWS": "BFFN-NV",
  "NORTHERN VILLAGE CUMBERLAND HOUSE": "CMBR-NV",
  "NORTHERN VILLAGE DENARE BEACH": "DNRB-NV",
  "NORTHERN VILLAGE GREEN LAKE": "GRLK-NV",
  "NORTHERN VILLAGE ILE A LA CROSSE": "LCRS-NV",
  "NORTHERN VILLAGE LA LOCHE": "LLOC-NV",
  "NORTHERN VILLAGE PELICAN NARROWS": "PLCN-NV",
  "NORTHERN VILLAGE PINEHOUSE": "PNHS-NV",
  "NORTHERN VILLAGE SANDY BAY": "SDBY-NV",
  "RESORT VILLAGE ALICE BEACH": "ALBC-RV",
  "RESORT VILLAGE AQUADEO": "AQDE-RV",
  "RESORT VILLAGE B-SAY-TAH": "BSTH-RV",
  "RESORT VILLAGE BEAVER FLAT": "BVFL-RV",
  "RESORT VILLAGE BIG SHELL": "BGSH-RV",
  "RESORT VILLAGE BIRD'S POINT": "BRPT-RV",
  "RESORT VILLAGE CANDLE LAKE": "CNDL-RV",
  "RESORT VILLAGE CHITEK LAKE": "CHLK-RV",
  "RESORT VILLAGE CHORNEY BEACH": "CHBC-RV",
  "RESORT VILLAGE COCHIN": "CCHN-RV",
  "RESORT VILLAGE COTEAU BEACH": "CTBC-RV",
  "RESORT VILLAGE DISTRICT OF KETEPWA": "DTKT-RV",
  "RESORT VILLAGE ECHO BAY": "ECBY-RV",
  "RESORT VILLAGE ELK RIDGE": "ELRD-RV",
  "RESORT VILLAGE ETTERS BEACH": "ETBC-RV",
  "RESORT VILLAGE FORT SAN": "FRSN-RV",
  "RESORT VILLAGE GLEN HARBOUR": "SLHB-RV",
  "RESORT VILLAGE GRANDVIEW BEACH": "GRVB-RV",
  "RESORT VILLAGE GREIG LAKE": "GGLK-RV",
  "RESORT VILLAGE ISLAND VIEW": "ISVW-RV",
  "RESORT VILLAGE KANNATA VALLEY": "KNVL-RV",
  "RESORT VILLAGE KIVIMAA-MONNLIGHT BAY": "KVM-RV",
  "RESORT VILLAGE LESLIE BEACH": "LSBC-RV",
  "RESORT VILLAGE LUMSDEN BEACH": "LSDB-RV",
  "RESORT VILLAGE MANITOU BEACH": "MNBC-RV",
  "RESORT VILLAGE MELVILLE BEACH": "MVBC-RV",
  "RESORT VILLAGE MISTUSINNE": "MSTS-RV",
  "RESORT VILLAGE NORTH GROVE": "NRGR-RV",
  "RESORT VILLAGE PEBBLE BAYE": "PBBL-RV",
  "RESORT VILLAGE PELICAN POINTE": "PLCP-RV",
  "RESORT VILLAGE SASKATCHEWAN BEACH": "SKWN-RV",
  "RESORT VILLAGE SHIELDS": "SHLD-RV",
  "RESORT VILLAGE SOUTH LAKE": "STLK-RV",
  "RESORT VILLAGE SUN VALLEY": "SVLL-RV",
  "RESORT VILLAGE SUNSET COVE": "SSCV-RV",
  "RESORT VILLAGE THODE": "THDE-RV",
  "RESORT VILLAGE TOBIN LAKE": "TBLK-RV",
  "RESORT VILLAGE TURTLE VIEW": "TTVW-RV",
  "RESORT VILLAGE WAKAW LAKE": "WKLE-RV",
  "RESORT VILLAGE WEE TOO BEACH": "WTBC-RV",
  "RESORT VILLAGE WEST END": "WSED-RV",
  "RURAL MUNICIPALITY OF ABERDEEN NO 373": "ABR1-RM",
  "RURAL MUNICIPALITY OF ABERNETHY NO 186": "ABR2-RM",
  "RURAL MUNICIPALITY OF ANTELOPE PARK NO 322": "ANT1-RM",
  "RURAL MUNICIPALITY OF ANTLER NO 61": "ANT2-RM",
  "RURAL MUNICIPALITY OF ARBORFIELD NO 456": "ARB1-RM",
  "RURAL MUNICIPALITY OF ARGYLE NO 1": "ARGY-RM",
  "RURAL MUNICIPALITY OF ARLINGTON NO 79": "ARL1-RM",
  "RURAL MUNICIPALITY OF ARM RIVER NO 252": "ARMR-RM",
  "RURAL MUNICIPALITY OF AUVERGNE NO 76": "AVRG-RM",
  "RURAL MUNICIPALITY OF BAILDON NO 131": "BLDN-RM",
  "RURAL MUNICIPALITY OF BARRIER VALLEY NO 397": "BRR1-RM",
  "RURAL MUNICIPALITY OF BATTLE RIVER NO 438": "BTT1-RM",
  "RURAL MUNICIPALITY OF BAYNE NO 371": "BYNN-RM",
  "RURAL MUNICIPALITY OF BEAVER RIDGE NO 622": "BVRR-RM",
  "RURAL MUNICIPALITY OF BENGOUGH NO 40": "BNG1-RM",
  "RURAL MUNICIPALITY OF BENSON NO 35": "BNSN-RM",
  "RURAL MUNICIPALITY OF BIG ARM NO 251": "BGRM-RM",
  "RURAL MUNICIPALITY OF BIG QUILL NO 308": "BGQL-RM",
  "RURAL MUNICIPALITY OF BIG RIVER NO 555": "BGR1-RM",
  "RURAL MUNICIPALITY OF BIG STICK NO 141": "BGST-RM",
  "RURAL MUNICIPALITY OF BIGGAR NO 347": "BGG1-RM",
  "RURAL MUNICIPALITY OF BIRCH HILLS NO 460": "BRC2-RM",
  "RURAL MUNICIPALITY OF BJORKDALE NO 426": "BJR1-RM",
  "RURAL MUNICIPALITY OF BLAINE LAKE NO, 434": "BLN1-RM",
  "RURAL MUNICIPALITY OF BLUCHER NO 343": "BLCH-RM",
  "RURAL MUNICIPALITY OF BONE CREEK NO 108": "BNCR-RM",
  "RURAL MUNICIPALITY OF BRATT'S LAKE NO 129": "BRTT-RM",
  "RURAL MUNICIPALITY OF BRITANNIA NO 502": "BRTN-RM",
  "RURAL MUNICIPALITY OF BROCK NO 64": "BRC3-RM",
  "RURAL MUNICIPALITY OF BROKENSHELL NO 68": "BRKN-RM",
  "RURAL MUNICIPALITY OF BROWNING NO 34": "BRW1-RM",
  "RURAL MUNICIPALITY OF BUCHANAN NO 304": "BCH1-RM",
  "RURAL MUNICIPALITY OF BUCKLAND NO 491": "BCKL-RM",
  "RURAL MUNICIPALITY OF BUFFALO NO 409": "BFFL-RM",
  "RURAL MUNICIPALITY OF CALDER NO 241": "CLD1-RM",
  "RURAL MUNICIPALITY OF CALEDONIA NO 99": "CLDN-RM",
  "RURAL MUNICIPALITY OF CAMBRIA NO 6": "CMBR-RM",
  "RURAL MUNICIPALITY OF CANA NO 214": "CNN-RM",
  "RURAL MUNICIPALITY OF CANAAN NO 225": "CNN1-RM",
  "RURAL MUNICIPALITY OF CANWOOD NO 494": "CNW1-RM",
  "RURAL MUNICIPALITY OF CARMICHAEL NO 109": "CRM1-RM",
  "RURAL MUNICIPALITY OF CARON NO 162": "CRN1-RM",
  "RURAL MUNICIPALITY OF CHAPLIN NO 164": "CHP1-RM",
  "RURAL MUNICIPALITY OF CHESTER NO 125": "CHST-RM",
  "RURAL MUNICIPALITY OF CHESTERFIELD NO 261": "CHS1-RM",
  "RURAL MUNICIPALITY OF CHURCHBRIDGE NO 211": "CHR1-RM",
  "RURAL MUNICIPALITY OF CLAYTON NO 333": "CLYT-RM",
  "RURAL MUNICIPALITY OF CLINWORTH NO 230": "CLNW-RM",
  "RURAL MUNICIPALITY OF COALFIELDS NO 4": "CLFL-RM",
  "RURAL MUNICIPALITY OF COLONSAY NO 342": "CLN1-RM",
  "RURAL MUNICIPALITY OF CONNAUGHT NO 457": "CNNG-RM",
  "RURAL MUNICIPALITY OF CORMAN PARK NO 344": "CRMN-RM",
  "RURAL MUNICIPALITY OF COTE NO 271": "CTN-RM",
  "RURAL MUNICIPALITY OF COTEAU NO 255": "CTN1-RM",
  "RURAL MUNICIPALITY OF COULEE NO 136": "CLN-RM",
  "RURAL MUNICIPALITY OF CRAIK NO 222": "CRKN-RM",
  "RURAL MUNICIPALITY OF CUPAR NO 218": "CPRN-RM",
  "RURAL MUNICIPALITY OF CUT KNIFE NO 439": "CTK1-RM",
  "RURAL MUNICIPALITY OF CYMRI NO 36": "CYMR-RM",
  "RURAL MUNICIPALITY OF DEER FORKS NO 232": "DRFR-RM",
  "RURAL MUNICIPALITY OF DOUGLAS NO 436": "DGLS-RM",
  "RURAL MUNICIPALITY OF DUCK LAKE NO 463": "DCK1-RM",
  "RURAL MUNICIPALITY OF DUFFERIN NO 190": "DFFR-RM",
  "RURAL MUNICIPALITY OF DUNDURN NO 314": "DND1-RM",
  "RURAL MUNICIPALITY OF EAGLE CREEK NO 376": "EGLC-RM",
  "RURAL MUNICIPALITY OF EDENWOLD NO 158": "EDN1-RM",
  "RURAL MUNICIPALITY OF ELCAPO NO 154": "ELCP-RM",
  "RURAL MUNICIPALITY OF ELDON NO 471": "ELDN-RM",
  "RURAL MUNICIPALITY OF ELFROS NO 307": "ELF1-RM",
  "RURAL MUNICIPALITY OF ELMSTHORPE NO 100": "ELMS-RM",
  "RURAL MUNICIPALITY OF EMERALD NO 277": "EMRL-RM",
  "RURAL MUNICIPALITY OF ENFIELD NO 194": "ENFL-RM",
  "RURAL MUNICIPALITY OF ENNISKILLEN NO 3": "ENNS-RM",
  "RURAL MUNICIPALITY OF ENTERPRISE NO 142": "ENTR-RM",
  "RURAL MUNICIPALITY OF ESTEVAN NO 5": "EST2-RM",
  "RURAL MUNICIPALITY OF EXCEL NO 71": "EXCL-RM",
  "RURAL MUNICIPALITY OF EXCELSIOR NO 166": "EXC1-RM",
  "RURAL MUNICIPALITY OF EYE HILL NO 382": "EYHL-RM",
  "RURAL MUNICIPALITY OF EYEBROW NO 193": "EYB1-RM",
  "RURAL MUNICIPALITY OF FERTILE BELT NO 183": "FRTL-RM",
  "RURAL MUNICIPALITY OF FERTILE VALLEY NO 285": "FRT1-RM",
  "RURAL MUNICIPALITY OF FILLMORE NO 96": "FLL1-RM",
  "RURAL MUNICIPALITY OF FISH CREEK NO 402": "FSHC-RM",
  "RURAL MUNICIPALITY OF FLETT'S SPRINGS NO 429": "FLTT-RM",
  "RURAL MUNICIPALITY OF FOAM LAKE NO 276": "FML1-RM",
  "RURAL MUNICIPALITY OF FOX VALLEY NO 171": "FXV1-RM",
  "RURAL MUNICIPALITY OF FRANCIS NO 127": "FRN2-RM",
  "RURAL MUNICIPALITY OF FRENCHMAN BUTTE NO 501": "FRN3-RM",
  "RURAL MUNICIPALITY OF FRONTIER NO 19": "FRN4-RM",
  "RURAL MUNICIPALITY OF GARDEN RIVER NO 490": "GRDN-RM",
  "RURAL MUNICIPALITY OF GARRY NO 245": "GRRY-RM",
  "RURAL MUNICIPALITY OF GLEN BAIN NO 105": "GLNB-RM",
  "RURAL MUNICIPALITY OF GLEN MCPHERSON NO 46": "GLNM-RM",
  "RURAL MUNICIPALITY OF GLENSIDE NO 377": "GLN1-RM",
  "RURAL MUNICIPALITY OF GOLDEN WEST NO 95": "GLD1-RM",
  "RURAL MUNICIPALITY OF GOOD LAKE NO 274": "GDLK-RM",
  "RURAL MUNICIPALITY OF GRANDVIEW NO 349": "GRN2-RM",
  "RURAL MUNICIPALITY OF GRANT NO 372": "GRNT-RM",
  "RURAL MUNICIPALITY OF GRASS LAKE NO 381": "GRSS-RM",
  "RURAL MUNICIPALITY OF GRASSY CREEK NO 78": "GRS1-RM",
  "RURAL MUNICIPALITY OF GRAVELBOURG NO 104": "GRV1-RM",
  "RURAL MUNICIPALITY OF GRAYSON NO 184": "GRY1-RM",
  "RURAL MUNICIPALITY OF GREAT BEND NO 405": "GRTB-RM",
  "RURAL MUNICIPALITY OF GRIFFIN NO 66": "GRFF-RM",
  "RURAL MUNICIPALITY OF GULL LAKE NO 139": "GLL1-RM",
  "RURAL MUNICIPALITY OF HAPPY VALLEY NO 10": "HPPY-RM",
  "RURAL MUNICIPALITY OF HAPPYLAND NO 231": "HPP1-RM",
  "RURAL MUNICIPALITY OF HARRIS NO 316": "HRRS-RM",
  "RURAL MUNICIPALITY OF HART BUTTE NO 11": "HRTB-RM",
  "RURAL MUNICIPALITY OF HAZEL DELL NO 335": "HZL1-RM",
  "RURAL MUNICIPALITY OF HAZELWOOD NO 94": "HZLW-RM",
  "RURAL MUNICIPALITY OF HEART'S HILL NO 352": "HRTS-RM",
  "RURAL MUNICIPALITY OF HILLSBOROUGH NO 132": "HLLS-RM",
  "RURAL MUNICIPALITY OF HILLSDALE NO 440": "HLL1-RM",
  "RURAL MUNICIPALITY OF HOODOO NO 401": "HDN-RM",
  "RURAL MUNICIPALITY OF HUDSON BAY NO 394": "HDS1-RM",
  "RURAL MUNICIPALITY OF HUMBOLDT NO 370": "HMB1-RM",
  "RURAL MUNICIPALITY OF HURON NO 223": "HRNN-RM",
  "RURAL MUNICIPALITY OF INDIAN HEAD NO 156": "IND1-RM",
  "RURAL MUNICIPALITY OF INSINGER NO 275": "INSN-RM",
  "RURAL MUNICIPALITY OF INVERGORDON NO 430": "INV1-RM",
  "RURAL MUNICIPALITY OF INVERMAY NO 305": "INV2-RM",
  "RURAL MUNICIPALITY OF ITUNA BON ACCORD NO 246": "ITNB-RM",
  "RURAL MUNICIPALITY OF KELLROSS NO 247": "KLLR-RM",
  "RURAL MUNICIPALITY OF KELVINGTON NO 366": "KLV1-RM",
  "RURAL MUNICIPALITY OF KEY WEST NO 70": "KYWS-RM",
  "RURAL MUNICIPALITY OF KEYS NO 303": "KYSN-RM",
  "RURAL MUNICIPALITY OF KINDERSLEY NO 290": "KND1-RM",
  "RURAL MUNICIPALITY OF KING GEORGE NO 256": "KNGG-RM",
  "RURAL MUNICIPALITY OF KINGSLEY NO 124": "KNGS-RM",
  "RURAL MUNICIPALITY OF KINISTINO NO 459": "KNS2-RM",
  "RURAL MUNICIPALITY OF KLAKE JOHNSTON NO 102": "KLKJ-RM",
  "RURAL MUNICIPALITY OF LAC PELLETIER NO 107": "LCPL-RM",
  "RURAL MUNICIPALITY OF LACADENA NO 228": "LCDN-RM",
  "RURAL MUNICIPALITY OF LAIRD NO 404": "LRDN-RM",
  "RURAL MUNICIPALITY OF LAJORD NO 128": "LJRD-RM",
  "RURAL MUNICIPALITY OF LAKE ALMA NO 8": "LKL1-RM",
  "RURAL MUNICIPALITY OF LAKE LENORE NO 399": "LKL2-RM",
  "RURAL MUNICIPALITY OF LAKELAND NO 521": "LKL3-RM",
  "RURAL MUNICIPALITY OF LAKESIDE NO 338": "LKSD-RM",
  "RURAL MUNICIPALITY OF LAKEVIEW NO 337": "LKV1-RM",
  "RURAL MUNICIPALITY OF LANGENBURG NO 181": "LNG2-RM",
  "RURAL MUNICIPALITY OF LAST MOUNTAIN VALLEY NO 250": "LSTM-RM",
  "RURAL MUNICIPALITY OF LAURIER NO 38": "LRRN-RM",
  "RURAL MUNICIPALITY OF LAWTONIA NO 135": "LWTN-RM",
  "RURAL MUNICIPALITY OF LEASK NO 464": "LSKN-RM",
  "RURAL MUNICIPALITY OF LEROY NO 339": "LRYN-RM",
  "RURAL MUNICIPALITY OF LIPTON NO 217": "LPT1-RM",
  "RURAL MUNICIPALITY OF LIVINGSTON NO 331": "LVNG-RM",
  "RURAL MUNICIPALITY OF LOMOND NO 37": "LMND-RM",
  "RURAL MUNICIPALITY OF LONE TREE NO 18": "LNTR-RM",
  "RURAL MUNICIPALITY OF LONGLAKETON NO 219": "LNGL-RM",
  "RURAL MUNICIPALITY OF LOON LAKE NO 561": "LNL1-RM",
  "RURAL MUNICIPALITY OF LOREBURN NO 254": "LRB1-RM",
  "RURAL MUNICIPALITY OF LOST RIVER NO 313": "LSTR-RM",
  "RURAL MUNICIPALITY OF LUMSDEN NO 189": "LMS1-RM",
  "RURAL MUNICIPALITY OF MANITOU LAKE NO 442": "MNTL-RM",
  "RURAL MUNICIPALITY OF MANKOTA NO 45": "MNK1-RM",
  "RURAL MUNICIPALITY OF MAPLE BUSH NO 224": "MPLB-RM",
  "RURAL MUNICIPALITY OF MAPLE CREEK NO 111": "MPL1-RM",
  "RURAL MUNICIPALITY OF MARIPOSA NO 350": "MRPS-RM",
  "RURAL MUNICIPALITY OF MARQUIS NO 191": "MRQ1-RM",
  "RURAL MUNICIPALITY OF MARRIOTT NO 317": "MRRT-RM",
  "RURAL MUNICIPALITY OF MARTIN NO 122": "MRT2-RM",
  "RURAL MUNICIPALITY OF MARYFIELD NO 91": "MRY1-RM",
  "RURAL MUNICIPALITY OF MAYFIELD NO 406": "MYFL-RM",
  "RURAL MUNICIPALITY OF MCCRANEY NO 282": "MCC1-RM",
  "RURAL MUNICIPALITY OF MCLEOD NO 185": "MCLD-RM",
  "RURAL MUNICIPALITY OF MCKILLOP NO 220": "MCK1-RM",
  "RURAL MUNICIPALITY OF MEADOW LAKE NO 588": "MDW1-RM",
  "RURAL MUNICIPALITY OF MEDSTEAD NO 497": "MDS2-RM",
  "RURAL MUNICIPALITY OF MEETING LAKE NO 466": "MTNG-RM",
  "RURAL MUNICIPALITY OF MEOTA NO 468": "MTN-RM",
  "RURAL MUNICIPALITY OF MERVIN NO 499": "MRV1-RM",
  "RURAL MUNICIPALITY OF MILDEN NO 286": "MLD1-RM",
  "RURAL MUNICIPALITY OF MILTON NO 292": "MLTN-RM",
  "RURAL MUNICIPALITY OF MIRY CREEK NO 229": "MRYC-RM",
  "RURAL MUNICIPALITY OF MONET NO 257": "MNT1-RM",
  "RURAL MUNICIPALITY OF MONTMARTRE NO 126": "MNT2-RM",
  "RURAL MUNICIPALITY OF MONTROSE NO 315": "MNTR-RM",
  "RURAL MUNICIPALITY OF MOOSE CREAKK NO 33": "MSCR-RM",
  "RURAL MUNICIPALITY OF MOOSE JAW NO 161": "MSJ1-RM",
  "RURAL MUNICIPALITY OF MOOSE MOUNTAIN NO 63": "MSM1-RM",
  "RURAL MUNICIPALITY OF MOOSE RANGE NO 486": "MSRN-RM",
  "RURAL MUNICIPALITY OF MOOSOMIN NO 121": "MSM2-RM",
  "RURAL MUNICIPALITY OF MORRIS NO 312": "MRRS-RM",
  "RURAL MUNICIPALITY OF MORSE NO 165": "MRSN-RM",
  "RURAL MUNICIPALITY OF MOUNT HOPE NO 279": "MNTH-RM",
  "RURAL MUNICIPALITY OF MOUNT PLEASANT NO 2": "MNTP-RM",
  "RURAL MUNICIPALITY OF MOUNTAIN VIEW NO 318": "MNT3-RM",
  "RURAL MUNICIPALITY OF NEWCOMBE NO 260": "NWCM-RM",
  "RURAL MUNICIPALITY OF NIPAWIN NO 487": "NPW1-RM",
  "RURAL MUNICIPALITY OF NORTH BATTLEFORD NO 437": "NRT6-RM",
  "RURAL MUNICIPALITY OF NORTH QU'APELLE NO 187": "NRT7-RM",
  "RURAL MUNICIPALITY OF NORTON NO 69": "NRTN-RM",
  "RURAL MUNICIPALITY OF OAKDALE NO 320": "OKDL-RM",
  "RURAL MUNICIPALITY OF OLD POST NO 43": "OLDP-RM",
  "RURAL MUNICIPALITY OF ORKNEY NO 244": "ORKN-RM",
  "RURAL MUNICIPALITY OF PADDOCKWOOD NO 520": "PDD1-RM",
  "RURAL MUNICIPALITY OF PARKDALE NO 498": "PRKD-RM",
  "RURAL MUNICIPALITY OF PAYNTON NO 470": "PYN1-RM",
  "RURAL MUNICIPALITY OF PENSE NO 160": "PNSN-RM",
  "RURAL MUNICIPALITY OF PERDUE NO 346": "PRDN-RM",
  "RURAL MUNICIPALITY OF PIAPOT NO 110": "PPTN-RM",
  "RURAL MUNICIPALITY OF PINTO CREEK NO 75": "PNTC-RM",
  "RURAL MUNICIPALITY OF PITTVILLE NO 169": "PTTV-RM",
  "RURAL MUNICIPALITY OF PLEASANT VALLEY NO 288": "PLS1-RM",
  "RURAL MUNICIPALITY OF PLEASANTDALE NO 398": "PLS2-RM",
  "RURAL MUNICIPALITY OF PONASS LAKE NO 367": "PNSS-RM",
  "RURAL MUNICIPALITY OF POPLAR VALLEY NO 12": "PPLR-RM",
  "RURAL MUNICIPALITY OF PORCUPINE NO 395": "PRC2-RM",
  "RURAL MUNICIPALITY OF PRAIRIE ROSDEN NO 309": "PRR1-RM",
  "RURAL MUNICIPALITY OF PRAIRIEDALE NO 321": "PRRD-RM",
  "RURAL MUNICIPALITY OF PREECEVILLE NO 334": "PRC3-RM",
  "RURAL MUNICIPALITY OF PRINCE ALBERT NO 461": "PRN2-RM",
  "RURAL MUNICIPALITY OF PROGRESS NO 351": "PRGR-RM",
  "RURAL MUNICIPALITY OF RECIPROCITY NO 32": "RCPR-RM",
  "RURAL MUNICIPALITY OF REDBERRY NO 435": "RDBR-RM",
  "RURAL MUNICIPALITY OF REDBURN NO 130": "RDB1-RM",
  "RURAL MUNICIPALITY OF REFORD NO 379": "RFRD-RM",
  "RURAL MUNICIPALITY OF RENO NO 51": "RNN-RM",
  "RURAL MUNICIPALITY OF RIVERSIDE NO 168": "RVR2-RM",
  "RURAL MUNICIPALITY OF ROCANVILLE NO 151": "RCN1-RM",
  "RURAL MUNICIPALITY OF RODGERS NO 133": "RDGR-RM",
  "RURAL MUNICIPALITY OF ROSEDALE NO 283": "RSDL-RM",
  "RURAL MUNICIPALITY OF ROSEMOUNT NO 378": "RSMN-RM",
  "RURAL MUNICIPALITY OF ROSTHERN NO 402": "RST1-RM",
  "RURAL MUNICIPALITY OF ROUND HILL NO 467": "RNDH-RM",
  "RURAL MUNICIPALITY OF ROUND VALLEY NO 410": "RNDV-RM",
  "RURAL MUNICIPALITY OF RUDY NO 284": "RDYN-RM",
  "RURAL MUNICIPALITY OF SALTCOATS NO 213": "SLT1-RM",
  "RURAL MUNICIPALITY OF SARNIA NO 221": "SRNN-RM",
  "RURAL MUNICIPALITY OF SASKATCHEWAN LANDING NO 167": "SSK1-RM",
  "RURAL MUNICIPALITY OF SASMAN NO 336": "SSMN-RM",
  "RURAL MUNICIPALITY OF SCOTT NO 98": "SCT1-RM",
  "RURAL MUNICIPALITY OF SENLAC NO 411": "SNL1-RM",
  "RURAL MUNICIPALITY OF SHAMROCK NO 134": "SHM1-RM",
  "RURAL MUNICIPALITY OF SHELLBROOK NO 493": "SHL2-RM",
  "RURAL MUNICIPALITY OF SHERWOOD NO 159": "SHRW-RM",
  "RURAL MUNICIPALITY OF SILVERWOOD NO 123": "SLVR-RM",
  "RURAL MUNICIPALITY OF SLIDING HILLS NO 273": "SLDN-RM",
  "RURAL MUNICIPALITY OF SNIPE LAKE NO 259": "SNPL-RM",
  "RURAL MUNICIPALITY OF SOURIS VALLEY NO 7": "SRSV-RM",
  "RURAL MUNICIPALITY OF SOUTH QU'APELLE NO 157": "STHQ-RM",
  "RURAL MUNICIPALITY OF SPALDING NO 368": "SPL1-RM",
  "RURAL MUNICIPALITY OF SPIRITWOOD NO 496": "SPR4-RM",
  "RURAL MUNICIPALITY OF SPY HILL NO 152": "SPY1-RM",
  "RURAL MUNICIPALITY OF ST ANDREWS NO 287": "STND-RM",
  "RURAL MUNICIPALITY OF ST LOUIS NO 431": "STL1-RM",
  "RURAL MUNICIPALITY OF ST PETER NO 369": "STPT-RM",
  "RURAL MUNICIPALITY OF ST PHILIPS NO 301": "STPH-RM",
  "RURAL MUNICIPALITY OF STANLEY NO 215": "STNL-RM",
  "RURAL MUNICIPALITY OF STAR CITY NO 428": "STR1-RM",
  "RURAL MUNICIPALITY OF STONEHENGE NO 73": "STNH-RM",
  "RURAL MUNICIPALITY OF STORTHOAKS NO 31": "STR2-RM",
  "RURAL MUNICIPALITY OF SURPRISE VALLEY NO 9": "SRPR-RM",
  "RURAL MUNICIPALITY OF SUTTON NO 103": "STTN-RM",
  "RURAL MUNICIPALITY OF SWIFT CURRENT NO 137": "SWF1-RM",
  "RURAL MUNICIPALITY OF TECUMSEH NO 65": "TCMS-RM",
  "RURAL MUNICIPALITY OF TERRELL NO 101": "TRRL-RM",
  "RURAL MUNICIPALITY OF THE GAP NO 39": "THGP-RM",
  "RURAL MUNICIPALITY OF THREE LAKES NO 400": "THRL-RM",
  "RURAL MUNICIPALITY OF TISDALE NO 427": "TSD1-RM",
  "RURAL MUNICIPALITY OF TORCH RIVER NO 488": "TRCH-RM",
  "RURAL MUNICIPALITY OF TOUCHWOOD NO 248": "TCHW-RM",
  "RURAL MUNICIPALITY OF TRAMPING LAKE NO 380": "TRM1-RM",
  "RURAL MUNICIPALITY OF TULLYMET NO 216": "TLLY-RM",
  "RURAL MUNICIPALITY OF TURTLE RIVER NO 469": "TRT2-RM",
  "RURAL MUNICIPALITY OF USBORNE NO 310": "USBR-RM",
  "RURAL MUNICIPALITY OF VAL MARIE NO 17": "VLM1-RM",
  "RURAL MUNICIPALITY OF VANSCOY NO 345": "VNS1-RM",
  "RURAL MUNICIPALITY OF VICTORY NO 226": "VCTR-RM",
  "RURAL MUNICIPALITY OF VISCOUNT NO 341": "VSC1-RM",
  "RURAL MUNICIPALITY OF WALLACE NO 243": "WLLC-RM",
  "RURAL MUNICIPALITY OF WALPOLE NO 92": "WLPL-RM",
  "RURAL MUNICIPALITY OF WAVERLEY NO 44": "WVRL-RM",
  "RURAL MUNICIPALITY OF WAWKEN NO 93": "WWKN-RM",
  "RURAL MUNICIPALITY OF WEBB NO 138": "WBBN-RM",
  "RURAL MUNICIPALITY OF WELLINGTON NO 97": "WLLN-RM",
  "RURAL MUNICIPALITY OF WEYBURN NO 67": "WYB1-RM",
  "RURAL MUNICIPALITY OF WHEATLANDS NO 163": "WHTL-RM",
  "RURAL MUNICIPALITY OF WHISKA CREEK NO 106": "WHSK-RM",
  "RURAL MUNICIPALITY OF WHITE VALLEY NO 49": "WHTV-RM",
  "RURAL MUNICIPALITY OF WILLNER NO 253": "WLL1-RM",
  "RURAL MUNICIPALITY OF WILLOW BUNCH NO 42": "WLL2-RM",
  "RURAL MUNICIPALITY OF WILLOW CREEK NO 458": "WLL3-RM",
  "RURAL MUNICIPALITY OF WILLOWDALE NO 153": "WLL4-RM",
  "RURAL MUNICIPALITY OF WILTON NO 472": "WLTN-RM",
  "RURAL MUNICIPALITY OF WINSLOW NO 319": "WNSL-RM",
  "RURAL MUNICIPALITY OF WISE CREEK NO 77": "WSCR-RM",
  "RURAL MUNICIPALITY OF WOLSELEY NO 155": "WLS1-RM",
  "RURAL MUNICIPALITY OF WOLVERINE NO 340": "WLVR-RM",
  "RURAL MUNICIPALITY OF WOOD CREEK NO 281": "WDCR-RM",
  "RURAL MUNICIPALITY OF WOOD RIVER NO 74": "WDRV-RM",
  "RURAL MUNICIPALITY OF WREFORD NO 280": "WRFR-RM",
  "DOWNTOWN, REGINA": "REG",
  "COOPERTOWN, REGINA": "REG",
  "DOWNTOWN REGINA, REGINA": "REG",
  "GERMANTOWN, REGINA": "REG",
  "THE TOWNS, REGINA": "REG",
  "CITY PARK": "SAS",
  "CITY PARK SOUTH": "SAS",
  "HAMPTON VILLAGE": "SAS",
  "PLEASANT HILL VILLAGE": "SAS",
  "WEST DOWNTOWN": "SAS",
  "SOUTH DOWNTOWN": "SAS",
  "CITY OF WHITEHORSE": "SAS-WHTH",
  "TOWN OF DAWSON CITY": "SAS-DWSN",
  "TOWN OF FARO": "SAS-FARO",
  "TOWN OF WATSON LAKE": "SAS-WTSN",
  "VILLAGE OF CARMACKS": "SAS-CRMC",
  "VILLAGE OF HAINES JUNCTION": "SAS-HNJN",
  "VILLAGE OF MAYO": "SAS-MAYO",
  "VILLAGE OF TESLIN": "SAS-TSLN"
});